import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  toString30pk9tzaqopn as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString1pkumu07cwy4m as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Enum3alwj03lh1n41 as Enum,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  isInterface3d6p8outrmvmk as isInterface,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  ArrayList3it5z8td81qkl as ArrayList,
  lazy2hsh8ze7j6ikd as lazy_0,
  until1jbpn0z3f8lbg as until,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  to2cs3ny02qtbcb as to,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  emptyList1g2z5xcrvp2zy as emptyList,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  get_nullable197rfua9r7fsz as get_nullable,
  IntSerializer_getInstance3jjhuzya8j8kz as IntSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  DoubleSerializer_getInstance2y096mioqlqlr as DoubleSerializer_getInstance,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  IntArraySerializer_getInstance1wseiuhv9iku9 as IntArraySerializer_getInstance,
  BooleanSerializer_getInstance1a8uvzxl1s4k4 as BooleanSerializer_getInstance,
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
  STRING_getInstance2md3nu8ka1da4 as STRING_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  serializer1i4e9ym37oxmo as serializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  JsonElementSerializer_getInstance2oljfos0dzhs0 as JsonElementSerializer_getInstance,
  JsonArraySerializer_getInstance1ej8z5oqdqinb as JsonArraySerializer_getInstance,
  JsonObjectSerializer_getInstance1mgth7qb9xrot as JsonObjectSerializer_getInstance,
  Jsonsmkyu9xjl7fv as Json,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import {
  Mixin3lmkm5hum2vdj as Mixin,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Vector2I2k5512l4eeahb as Vector2I,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Bitmap321klycakvwgb5w as Bitmap32,
  Companion_getInstance3ctl2vl10i40x as Companion_getInstance,
  slice2pfxfvku0ybgy as slice,
  TileSetTileInfo253o60hp1pekl as TileSetTileInfo,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  readBitmapdk80pcjw6p8f as readBitmap,
  extractrn4rijx1x4kx as extract,
} from './korlibs-image-root-korlibs-image.mjs';
import { RectSlicec5msorw5q4el as RectSlice } from './korlibs-math-root-korlibs-math.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {}
class $serializer {
  constructor() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.FieldInstance', this, 6);
    tmp0_serialDesc.m16('__identifier', false);
    tmp0_serialDesc.m16('__tile', true);
    tmp0_serialDesc.m16('__type', false);
    tmp0_serialDesc.m16('__value', false);
    tmp0_serialDesc.m16('defUid', false);
    tmp0_serialDesc.m16('realEditorValues', false);
    this.mct_1 = tmp0_serialDesc;
  }
  nct(encoder, value) {
    var tmp0_desc = this.mct_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.oct_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.pct_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, $serializer_getInstance_4(), value.pct_1);
    }
    tmp1_output.n10(tmp0_desc, 2, value.qct_1);
    tmp1_output.r10(tmp0_desc, 3, JsonElementSerializer_getInstance(), value.rct_1);
    tmp1_output.i10(tmp0_desc, 4, value.sct_1);
    tmp1_output.p10(tmp0_desc, 5, JsonArraySerializer_getInstance(), value.tct_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.nct(encoder, value instanceof FieldInstance ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.mct_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_local5 = null;
    var tmp10_input = decoder.xy(tmp0_desc);
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.lz(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.hz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, JsonElementSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.cz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, JsonArraySerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.lz(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.hz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, JsonElementSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.cz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, JsonArraySerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return FieldInstance.uct(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.mct_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_4()), StringSerializer_getInstance(), get_nullable(JsonElementSerializer_getInstance()), IntSerializer_getInstance(), JsonArraySerializer_getInstance()];
  }
}
class FieldInstance {
  toString() {
    return 'FieldInstance(identifier=' + this.oct_1 + ', tile=' + toString(this.pct_1) + ', type=' + this.qct_1 + ', value=' + toString(this.rct_1) + ', defUid=' + this.sct_1 + ', realEditorValues=' + this.tct_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.oct_1);
    result = imul(result, 31) + (this.pct_1 == null ? 0 : this.pct_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.qct_1) | 0;
    result = imul(result, 31) + (this.rct_1 == null ? 0 : hashCode(this.rct_1)) | 0;
    result = imul(result, 31) + this.sct_1 | 0;
    result = imul(result, 31) + this.tct_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldInstance))
      return false;
    var tmp0_other_with_cast = other instanceof FieldInstance ? other : THROW_CCE();
    if (!(this.oct_1 === tmp0_other_with_cast.oct_1))
      return false;
    if (!equals(this.pct_1, tmp0_other_with_cast.pct_1))
      return false;
    if (!(this.qct_1 === tmp0_other_with_cast.qct_1))
      return false;
    if (!equals(this.rct_1, tmp0_other_with_cast.rct_1))
      return false;
    if (!(this.sct_1 === tmp0_other_with_cast.sct_1))
      return false;
    if (!this.tct_1.equals(tmp0_other_with_cast.tct_1))
      return false;
    return true;
  }
  static uct(seen0, identifier, tile, type, value, defUid, realEditorValues, serializationConstructorMarker) {
    if (!(61 === (61 & seen0))) {
      throwMissingFieldException(seen0, 61, $serializer_getInstance().mct_1);
    }
    var $this = createThis(this);
    $this.oct_1 = identifier;
    if (0 === (seen0 & 2))
      $this.pct_1 = null;
    else
      $this.pct_1 = tile;
    $this.qct_1 = type;
    $this.rct_1 = value;
    $this.sct_1 = defUid;
    $this.tct_1 = realEditorValues;
    return $this;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.vct_1 = [null, null, new ArrayListSerializer(DoubleSerializer_getInstance()), null, new LinkedHashSetSerializer(StringSerializer_getInstance()), null, null, new ArrayListSerializer($serializer_getInstance()), null, null, null, null];
  }
}
class $serializer_0 {
  constructor() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EntityInstance', this, 12);
    tmp0_serialDesc.m16('__grid', false);
    tmp0_serialDesc.m16('__identifier', false);
    tmp0_serialDesc.m16('__pivot', false);
    tmp0_serialDesc.m16('__smartColor', false);
    tmp0_serialDesc.m16('__tags', false);
    tmp0_serialDesc.m16('__tile', true);
    tmp0_serialDesc.m16('defUid', false);
    tmp0_serialDesc.m16('fieldInstances', false);
    tmp0_serialDesc.m16('height', false);
    tmp0_serialDesc.m16('iid', false);
    tmp0_serialDesc.m16('px', false);
    tmp0_serialDesc.m16('width', false);
    this.wct_1 = tmp0_serialDesc;
  }
  xct(encoder, value) {
    var tmp0_desc = this.wct_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().vct_1;
    tmp1_output.p10(tmp0_desc, 0, IntArraySerializer_getInstance(), value.zct_1);
    tmp1_output.n10(tmp0_desc, 1, value.acu_1);
    tmp1_output.p10(tmp0_desc, 2, tmp2_cached[2], value.bcu_1);
    tmp1_output.n10(tmp0_desc, 3, value.ccu_1);
    tmp1_output.p10(tmp0_desc, 4, tmp2_cached[4], value.dcu_1);
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.ecu_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, $serializer_getInstance_4(), value.ecu_1);
    }
    tmp1_output.i10(tmp0_desc, 6, value.fcu_1);
    tmp1_output.p10(tmp0_desc, 7, tmp2_cached[7], value.gcu_1);
    tmp1_output.i10(tmp0_desc, 8, value.hcu_1);
    tmp1_output.n10(tmp0_desc, 9, value.icu_1);
    tmp1_output.p10(tmp0_desc, 10, IntArraySerializer_getInstance(), value.jcu_1);
    tmp1_output.i10(tmp0_desc, 11, value.kcu_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.xct(encoder, value instanceof EntityInstance ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.wct_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_local8 = 0;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = 0;
    var tmp16_input = decoder.xy(tmp0_desc);
    var tmp17_cached = Companion_getInstance_1().vct_1;
    if (tmp16_input.nz()) {
      tmp4_local0 = tmp16_input.jz(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.hz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.jz(tmp0_desc, 2, tmp17_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.hz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.jz(tmp0_desc, 4, tmp17_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.lz(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.cz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.jz(tmp0_desc, 7, tmp17_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.cz(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.hz(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.jz(tmp0_desc, 10, IntArraySerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.cz(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.jz(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.hz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.jz(tmp0_desc, 2, tmp17_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.hz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.jz(tmp0_desc, 4, tmp17_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.lz(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.cz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.jz(tmp0_desc, 7, tmp17_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.cz(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.hz(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.jz(tmp0_desc, 10, IntArraySerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.cz(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp16_input.yy(tmp0_desc);
    return EntityInstance.lcu(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  }
  yu() {
    return this.wct_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_1().vct_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntArraySerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2], StringSerializer_getInstance(), tmp0_cached[4], get_nullable($serializer_getInstance_4()), IntSerializer_getInstance(), tmp0_cached[7], IntSerializer_getInstance(), StringSerializer_getInstance(), IntArraySerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class EntityInstance {
  toString() {
    return 'EntityInstance(grid=' + toString_0(this.zct_1) + ', identifier=' + this.acu_1 + ', pivot=' + toString_0(this.bcu_1) + ', smartColor=' + this.ccu_1 + ', tags=' + toString_0(this.dcu_1) + ', tile=' + toString(this.ecu_1) + ', defUid=' + this.fcu_1 + ', fieldInstances=' + toString_0(this.gcu_1) + ', height=' + this.hcu_1 + ', iid=' + this.icu_1 + ', px=' + toString_0(this.jcu_1) + ', width=' + this.kcu_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.zct_1);
    result = imul(result, 31) + getStringHashCode(this.acu_1) | 0;
    result = imul(result, 31) + hashCode(this.bcu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ccu_1) | 0;
    result = imul(result, 31) + hashCode(this.dcu_1) | 0;
    result = imul(result, 31) + (this.ecu_1 == null ? 0 : this.ecu_1.hashCode()) | 0;
    result = imul(result, 31) + this.fcu_1 | 0;
    result = imul(result, 31) + hashCode(this.gcu_1) | 0;
    result = imul(result, 31) + this.hcu_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.icu_1) | 0;
    result = imul(result, 31) + hashCode(this.jcu_1) | 0;
    result = imul(result, 31) + this.kcu_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityInstance))
      return false;
    var tmp0_other_with_cast = other instanceof EntityInstance ? other : THROW_CCE();
    if (!equals(this.zct_1, tmp0_other_with_cast.zct_1))
      return false;
    if (!(this.acu_1 === tmp0_other_with_cast.acu_1))
      return false;
    if (!equals(this.bcu_1, tmp0_other_with_cast.bcu_1))
      return false;
    if (!(this.ccu_1 === tmp0_other_with_cast.ccu_1))
      return false;
    if (!equals(this.dcu_1, tmp0_other_with_cast.dcu_1))
      return false;
    if (!equals(this.ecu_1, tmp0_other_with_cast.ecu_1))
      return false;
    if (!(this.fcu_1 === tmp0_other_with_cast.fcu_1))
      return false;
    if (!equals(this.gcu_1, tmp0_other_with_cast.gcu_1))
      return false;
    if (!(this.hcu_1 === tmp0_other_with_cast.hcu_1))
      return false;
    if (!(this.icu_1 === tmp0_other_with_cast.icu_1))
      return false;
    if (!equals(this.jcu_1, tmp0_other_with_cast.jcu_1))
      return false;
    if (!(this.kcu_1 === tmp0_other_with_cast.kcu_1))
      return false;
    return true;
  }
  c28(value) {
    this.yct_1.c28(value);
  }
  d28() {
    return this.yct_1.d28();
  }
  static lcu(seen0, grid, identifier, pivot, smartColor, tags, tile, defUid, fieldInstances, height, iid, px, width, serializationConstructorMarker) {
    Companion_getInstance_1();
    if (!(4063 === (4063 & seen0))) {
      throwMissingFieldException(seen0, 4063, $serializer_getInstance_0().wct_1);
    }
    var $this = createThis(this);
    $this.zct_1 = grid;
    $this.acu_1 = identifier;
    $this.bcu_1 = pivot;
    $this.ccu_1 = smartColor;
    $this.dcu_1 = tags;
    if (0 === (seen0 & 32))
      $this.ecu_1 = null;
    else
      $this.ecu_1 = tile;
    $this.fcu_1 = defUid;
    $this.gcu_1 = fieldInstances;
    $this.hcu_1 = height;
    $this.icu_1 = iid;
    $this.jcu_1 = px;
    $this.kcu_1 = width;
    $this.yct_1 = new Mixin();
    return $this;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.qcu_1 = [null, new ArrayListSerializer(StringSerializer_getInstance()), Companion_getInstance_6().q1j(), new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, null, null, null, null, Companion_getInstance_7().q1j(), Companion_getInstance_8().q1j(), null, null, null, null, null, null, null, null, Companion_getInstance_9().q1j(), null, null, null, null];
  }
}
class $serializer_1 {
  constructor() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.FieldDefinition', this, 27);
    tmp0_serialDesc.m16('__type', false);
    tmp0_serialDesc.m16('acceptFileTypes', true);
    tmp0_serialDesc.m16('allowedRefs', false);
    tmp0_serialDesc.m16('allowedRefTags', false);
    tmp0_serialDesc.m16('allowOutOfLevelRef', false);
    tmp0_serialDesc.m16('arrayMaxLength', true);
    tmp0_serialDesc.m16('arrayMinLength', true);
    tmp0_serialDesc.m16('autoChainRef', false);
    tmp0_serialDesc.m16('canBeNull', false);
    tmp0_serialDesc.m16('defaultOverride', true);
    tmp0_serialDesc.m16('editorAlwaysShow', false);
    tmp0_serialDesc.m16('editorCutLongValues', false);
    tmp0_serialDesc.m16('editorDisplayMode', false);
    tmp0_serialDesc.m16('editorDisplayPos', false);
    tmp0_serialDesc.m16('editorTextPrefix', true);
    tmp0_serialDesc.m16('editorTextSuffix', true);
    tmp0_serialDesc.m16('identifier', false);
    tmp0_serialDesc.m16('isArray', false);
    tmp0_serialDesc.m16('max', true);
    tmp0_serialDesc.m16('min', true);
    tmp0_serialDesc.m16('regex', true);
    tmp0_serialDesc.m16('symmetricalRef', false);
    tmp0_serialDesc.m16('textLanguageMode', true);
    tmp0_serialDesc.m16('tilesetUid', true);
    tmp0_serialDesc.m16('type', false);
    tmp0_serialDesc.m16('uid', false);
    tmp0_serialDesc.m16('useForSmartColor', false);
    this.rcu_1 = tmp0_serialDesc;
  }
  scu(encoder, value) {
    var tmp0_desc = this.rcu_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().qcu_1;
    tmp1_output.n10(tmp0_desc, 0, value.tcu_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.ucu_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, tmp2_cached[1], value.ucu_1);
    }
    tmp1_output.p10(tmp0_desc, 2, tmp2_cached[2], value.vcu_1);
    tmp1_output.p10(tmp0_desc, 3, tmp2_cached[3], value.wcu_1);
    tmp1_output.f10(tmp0_desc, 4, value.xcu_1);
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.ycu_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, IntSerializer_getInstance(), value.ycu_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.zcu_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, IntSerializer_getInstance(), value.zcu_1);
    }
    tmp1_output.f10(tmp0_desc, 7, value.acv_1);
    tmp1_output.f10(tmp0_desc, 8, value.bcv_1);
    if (tmp1_output.v10(tmp0_desc, 9) ? true : !(value.ccv_1 == null)) {
      tmp1_output.r10(tmp0_desc, 9, JsonObjectSerializer_getInstance(), value.ccv_1);
    }
    tmp1_output.f10(tmp0_desc, 10, value.dcv_1);
    tmp1_output.f10(tmp0_desc, 11, value.ecv_1);
    tmp1_output.p10(tmp0_desc, 12, tmp2_cached[12], value.fcv_1);
    tmp1_output.p10(tmp0_desc, 13, tmp2_cached[13], value.gcv_1);
    if (tmp1_output.v10(tmp0_desc, 14) ? true : !(value.hcv_1 == null)) {
      tmp1_output.r10(tmp0_desc, 14, StringSerializer_getInstance(), value.hcv_1);
    }
    if (tmp1_output.v10(tmp0_desc, 15) ? true : !(value.icv_1 == null)) {
      tmp1_output.r10(tmp0_desc, 15, StringSerializer_getInstance(), value.icv_1);
    }
    tmp1_output.n10(tmp0_desc, 16, value.jcv_1);
    tmp1_output.f10(tmp0_desc, 17, value.kcv_1);
    if (tmp1_output.v10(tmp0_desc, 18) ? true : !(value.lcv_1 == null)) {
      tmp1_output.r10(tmp0_desc, 18, DoubleSerializer_getInstance(), value.lcv_1);
    }
    if (tmp1_output.v10(tmp0_desc, 19) ? true : !(value.mcv_1 == null)) {
      tmp1_output.r10(tmp0_desc, 19, DoubleSerializer_getInstance(), value.mcv_1);
    }
    if (tmp1_output.v10(tmp0_desc, 20) ? true : !(value.ncv_1 == null)) {
      tmp1_output.r10(tmp0_desc, 20, StringSerializer_getInstance(), value.ncv_1);
    }
    tmp1_output.f10(tmp0_desc, 21, value.ocv_1);
    if (tmp1_output.v10(tmp0_desc, 22) ? true : !(value.pcv_1 == null)) {
      tmp1_output.r10(tmp0_desc, 22, tmp2_cached[22], value.pcv_1);
    }
    if (tmp1_output.v10(tmp0_desc, 23) ? true : !(value.qcv_1 == null)) {
      tmp1_output.r10(tmp0_desc, 23, IntSerializer_getInstance(), value.qcv_1);
    }
    tmp1_output.n10(tmp0_desc, 24, value.rcv_1);
    tmp1_output.i10(tmp0_desc, 25, value.scv_1);
    tmp1_output.f10(tmp0_desc, 26, value.tcv_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.scu(encoder, value instanceof FieldDefinition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.rcu_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_local9 = null;
    var tmp14_local10 = false;
    var tmp15_local11 = false;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = false;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = false;
    var tmp26_local22 = null;
    var tmp27_local23 = null;
    var tmp28_local24 = null;
    var tmp29_local25 = 0;
    var tmp30_local26 = false;
    var tmp31_input = decoder.xy(tmp0_desc);
    var tmp32_cached = Companion_getInstance_2().qcu_1;
    if (tmp31_input.nz()) {
      tmp4_local0 = tmp31_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp31_input.lz(tmp0_desc, 1, tmp32_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp31_input.jz(tmp0_desc, 2, tmp32_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp31_input.jz(tmp0_desc, 3, tmp32_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp31_input.zy(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp31_input.lz(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp31_input.lz(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp31_input.zy(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp31_input.zy(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp31_input.lz(tmp0_desc, 9, JsonObjectSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp31_input.zy(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp31_input.zy(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp31_input.jz(tmp0_desc, 12, tmp32_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp31_input.jz(tmp0_desc, 13, tmp32_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp31_input.lz(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp31_input.lz(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp31_input.hz(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp31_input.zy(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp31_input.lz(tmp0_desc, 18, DoubleSerializer_getInstance(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp31_input.lz(tmp0_desc, 19, DoubleSerializer_getInstance(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp31_input.lz(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp31_input.zy(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp31_input.lz(tmp0_desc, 22, tmp32_cached[22], tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp31_input.lz(tmp0_desc, 23, IntSerializer_getInstance(), tmp27_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp28_local24 = tmp31_input.hz(tmp0_desc, 24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp29_local25 = tmp31_input.cz(tmp0_desc, 25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp30_local26 = tmp31_input.zy(tmp0_desc, 26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp31_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp31_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp31_input.lz(tmp0_desc, 1, tmp32_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp31_input.jz(tmp0_desc, 2, tmp32_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp31_input.jz(tmp0_desc, 3, tmp32_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp31_input.zy(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp31_input.lz(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp31_input.lz(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp31_input.zy(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp31_input.zy(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp31_input.lz(tmp0_desc, 9, JsonObjectSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp31_input.zy(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp31_input.zy(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp31_input.jz(tmp0_desc, 12, tmp32_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp31_input.jz(tmp0_desc, 13, tmp32_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp31_input.lz(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp31_input.lz(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp31_input.hz(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp31_input.zy(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp31_input.lz(tmp0_desc, 18, DoubleSerializer_getInstance(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp31_input.lz(tmp0_desc, 19, DoubleSerializer_getInstance(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp31_input.lz(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp31_input.zy(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp31_input.lz(tmp0_desc, 22, tmp32_cached[22], tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp31_input.lz(tmp0_desc, 23, IntSerializer_getInstance(), tmp27_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp28_local24 = tmp31_input.hz(tmp0_desc, 24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp29_local25 = tmp31_input.cz(tmp0_desc, 25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp30_local26 = tmp31_input.zy(tmp0_desc, 26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp31_input.yy(tmp0_desc);
    return FieldDefinition.ucv(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, null);
  }
  yu() {
    return this.rcu_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_2().qcu_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(tmp0_cached[1]), tmp0_cached[2], tmp0_cached[3], BooleanSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(JsonObjectSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[12], tmp0_cached[13], get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[22]), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class FieldDefinition {
  toString() {
    return 'FieldDefinition(type=' + this.tcu_1 + ', acceptFileTypes=' + toString(this.ucu_1) + ', allowedRefs=' + this.vcu_1.toString() + ', allowedRefTags=' + toString_0(this.wcu_1) + ', allowOutOfLevelRef=' + this.xcu_1 + ', arrayMaxLength=' + this.ycu_1 + ', arrayMinLength=' + this.zcu_1 + ', autoChainRef=' + this.acv_1 + ', canBeNull=' + this.bcv_1 + ', defaultOverride=' + toString(this.ccv_1) + ', editorAlwaysShow=' + this.dcv_1 + ', editorCutLongValues=' + this.ecv_1 + ', editorDisplayMode=' + this.fcv_1.toString() + ', editorDisplayPos=' + this.gcv_1.toString() + ', editorTextPrefix=' + this.hcv_1 + ', editorTextSuffix=' + this.icv_1 + ', identifier=' + this.jcv_1 + ', isArray=' + this.kcv_1 + ', max=' + this.lcv_1 + ', min=' + this.mcv_1 + ', regex=' + this.ncv_1 + ', symmetricalRef=' + this.ocv_1 + ', textLanguageMode=' + toString(this.pcv_1) + ', tilesetUid=' + this.qcv_1 + ', fieldDefinitionType=' + this.rcv_1 + ', uid=' + this.scv_1 + ', useForSmartColor=' + this.tcv_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.tcu_1);
    result = imul(result, 31) + (this.ucu_1 == null ? 0 : hashCode(this.ucu_1)) | 0;
    result = imul(result, 31) + this.vcu_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.wcu_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xcu_1) | 0;
    result = imul(result, 31) + (this.ycu_1 == null ? 0 : this.ycu_1) | 0;
    result = imul(result, 31) + (this.zcu_1 == null ? 0 : this.zcu_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.acv_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.bcv_1) | 0;
    result = imul(result, 31) + (this.ccv_1 == null ? 0 : this.ccv_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.dcv_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ecv_1) | 0;
    result = imul(result, 31) + this.fcv_1.hashCode() | 0;
    result = imul(result, 31) + this.gcv_1.hashCode() | 0;
    result = imul(result, 31) + (this.hcv_1 == null ? 0 : getStringHashCode(this.hcv_1)) | 0;
    result = imul(result, 31) + (this.icv_1 == null ? 0 : getStringHashCode(this.icv_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.jcv_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.kcv_1) | 0;
    result = imul(result, 31) + (this.lcv_1 == null ? 0 : getNumberHashCode(this.lcv_1)) | 0;
    result = imul(result, 31) + (this.mcv_1 == null ? 0 : getNumberHashCode(this.mcv_1)) | 0;
    result = imul(result, 31) + (this.ncv_1 == null ? 0 : getStringHashCode(this.ncv_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ocv_1) | 0;
    result = imul(result, 31) + (this.pcv_1 == null ? 0 : this.pcv_1.hashCode()) | 0;
    result = imul(result, 31) + (this.qcv_1 == null ? 0 : this.qcv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rcv_1) | 0;
    result = imul(result, 31) + this.scv_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.tcv_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof FieldDefinition ? other : THROW_CCE();
    if (!(this.tcu_1 === tmp0_other_with_cast.tcu_1))
      return false;
    if (!equals(this.ucu_1, tmp0_other_with_cast.ucu_1))
      return false;
    if (!this.vcu_1.equals(tmp0_other_with_cast.vcu_1))
      return false;
    if (!equals(this.wcu_1, tmp0_other_with_cast.wcu_1))
      return false;
    if (!(this.xcu_1 === tmp0_other_with_cast.xcu_1))
      return false;
    if (!(this.ycu_1 == tmp0_other_with_cast.ycu_1))
      return false;
    if (!(this.zcu_1 == tmp0_other_with_cast.zcu_1))
      return false;
    if (!(this.acv_1 === tmp0_other_with_cast.acv_1))
      return false;
    if (!(this.bcv_1 === tmp0_other_with_cast.bcv_1))
      return false;
    if (!equals(this.ccv_1, tmp0_other_with_cast.ccv_1))
      return false;
    if (!(this.dcv_1 === tmp0_other_with_cast.dcv_1))
      return false;
    if (!(this.ecv_1 === tmp0_other_with_cast.ecv_1))
      return false;
    if (!this.fcv_1.equals(tmp0_other_with_cast.fcv_1))
      return false;
    if (!this.gcv_1.equals(tmp0_other_with_cast.gcv_1))
      return false;
    if (!(this.hcv_1 == tmp0_other_with_cast.hcv_1))
      return false;
    if (!(this.icv_1 == tmp0_other_with_cast.icv_1))
      return false;
    if (!(this.jcv_1 === tmp0_other_with_cast.jcv_1))
      return false;
    if (!(this.kcv_1 === tmp0_other_with_cast.kcv_1))
      return false;
    if (!equals(this.lcv_1, tmp0_other_with_cast.lcv_1))
      return false;
    if (!equals(this.mcv_1, tmp0_other_with_cast.mcv_1))
      return false;
    if (!(this.ncv_1 == tmp0_other_with_cast.ncv_1))
      return false;
    if (!(this.ocv_1 === tmp0_other_with_cast.ocv_1))
      return false;
    if (!equals(this.pcv_1, tmp0_other_with_cast.pcv_1))
      return false;
    if (!(this.qcv_1 == tmp0_other_with_cast.qcv_1))
      return false;
    if (!(this.rcv_1 === tmp0_other_with_cast.rcv_1))
      return false;
    if (!(this.scv_1 === tmp0_other_with_cast.scv_1))
      return false;
    if (!(this.tcv_1 === tmp0_other_with_cast.tcv_1))
      return false;
    return true;
  }
  static ucv(seen0, type, acceptFileTypes, allowedRefs, allowedRefTags, allowOutOfLevelRef, arrayMaxLength, arrayMinLength, autoChainRef, canBeNull, defaultOverride, editorAlwaysShow, editorCutLongValues, editorDisplayMode, editorDisplayPos, editorTextPrefix, editorTextSuffix, identifier, isArray, max, min, regex, symmetricalRef, textLanguageMode, tilesetUid, fieldDefinitionType, uid, useForSmartColor, serializationConstructorMarker) {
    Companion_getInstance_2();
    if (!(119750045 === (119750045 & seen0))) {
      throwMissingFieldException(seen0, 119750045, $serializer_getInstance_1().rcu_1);
    }
    var $this = createThis(this);
    $this.tcu_1 = type;
    if (0 === (seen0 & 2))
      $this.ucu_1 = null;
    else
      $this.ucu_1 = acceptFileTypes;
    $this.vcu_1 = allowedRefs;
    $this.wcu_1 = allowedRefTags;
    $this.xcu_1 = allowOutOfLevelRef;
    if (0 === (seen0 & 32))
      $this.ycu_1 = null;
    else
      $this.ycu_1 = arrayMaxLength;
    if (0 === (seen0 & 64))
      $this.zcu_1 = null;
    else
      $this.zcu_1 = arrayMinLength;
    $this.acv_1 = autoChainRef;
    $this.bcv_1 = canBeNull;
    if (0 === (seen0 & 512))
      $this.ccv_1 = null;
    else
      $this.ccv_1 = defaultOverride;
    $this.dcv_1 = editorAlwaysShow;
    $this.ecv_1 = editorCutLongValues;
    $this.fcv_1 = editorDisplayMode;
    $this.gcv_1 = editorDisplayPos;
    if (0 === (seen0 & 16384))
      $this.hcv_1 = null;
    else
      $this.hcv_1 = editorTextPrefix;
    if (0 === (seen0 & 32768))
      $this.icv_1 = null;
    else
      $this.icv_1 = editorTextSuffix;
    $this.jcv_1 = identifier;
    $this.kcv_1 = isArray;
    if (0 === (seen0 & 262144))
      $this.lcv_1 = null;
    else
      $this.lcv_1 = max;
    if (0 === (seen0 & 524288))
      $this.mcv_1 = null;
    else
      $this.mcv_1 = min;
    if (0 === (seen0 & 1048576))
      $this.ncv_1 = null;
    else
      $this.ncv_1 = regex;
    $this.ocv_1 = symmetricalRef;
    if (0 === (seen0 & 4194304))
      $this.pcv_1 = null;
    else
      $this.pcv_1 = textLanguageMode;
    if (0 === (seen0 & 8388608))
      $this.qcv_1 = null;
    else
      $this.qcv_1 = tilesetUid;
    $this.rcv_1 = fieldDefinitionType;
    $this.scv_1 = uid;
    $this.tcv_1 = useForSmartColor;
    return $this;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.zcv_1 = [null, new ArrayListSerializer($serializer_getInstance_1()), null, null, null, null, null, Companion_getInstance_10().q1j(), Companion_getInstance_11().q1j(), null, null, null, null, null, Companion_getInstance_12().q1j(), null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, Companion_getInstance_13().q1j(), null, null, null];
  }
}
class $serializer_2 {
  constructor() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EntityDefinition', this, 25);
    tmp0_serialDesc.m16('color', false);
    tmp0_serialDesc.m16('fieldDefs', false);
    tmp0_serialDesc.m16('fillOpacity', false);
    tmp0_serialDesc.m16('height', false);
    tmp0_serialDesc.m16('hollow', false);
    tmp0_serialDesc.m16('identifier', false);
    tmp0_serialDesc.m16('keepAspectRatio', false);
    tmp0_serialDesc.m16('limitBehavior', false);
    tmp0_serialDesc.m16('limitScope', false);
    tmp0_serialDesc.m16('lineOpacity', false);
    tmp0_serialDesc.m16('maxCount', false);
    tmp0_serialDesc.m16('nineSliceBorders', false);
    tmp0_serialDesc.m16('pivotX', false);
    tmp0_serialDesc.m16('pivotY', false);
    tmp0_serialDesc.m16('renderMode', false);
    tmp0_serialDesc.m16('resizableX', false);
    tmp0_serialDesc.m16('resizableY', false);
    tmp0_serialDesc.m16('showName', false);
    tmp0_serialDesc.m16('tags', false);
    tmp0_serialDesc.m16('tileOpacity', false);
    tmp0_serialDesc.m16('tileRect', true);
    tmp0_serialDesc.m16('tileRenderMode', false);
    tmp0_serialDesc.m16('tilesetId', true);
    tmp0_serialDesc.m16('uid', false);
    tmp0_serialDesc.m16('width', false);
    this.acw_1 = tmp0_serialDesc;
  }
  bcw(encoder, value) {
    var tmp0_desc = this.acw_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_3().zcv_1;
    tmp1_output.n10(tmp0_desc, 0, value.dcw_1);
    tmp1_output.p10(tmp0_desc, 1, tmp2_cached[1], value.ecw_1);
    tmp1_output.l10(tmp0_desc, 2, value.fcw_1);
    tmp1_output.i10(tmp0_desc, 3, value.gcw_1);
    tmp1_output.f10(tmp0_desc, 4, value.hcw_1);
    tmp1_output.n10(tmp0_desc, 5, value.icw_1);
    tmp1_output.f10(tmp0_desc, 6, value.jcw_1);
    tmp1_output.p10(tmp0_desc, 7, tmp2_cached[7], value.kcw_1);
    tmp1_output.p10(tmp0_desc, 8, tmp2_cached[8], value.lcw_1);
    tmp1_output.l10(tmp0_desc, 9, value.mcw_1);
    tmp1_output.i10(tmp0_desc, 10, value.ncw_1);
    tmp1_output.p10(tmp0_desc, 11, IntArraySerializer_getInstance(), value.ocw_1);
    tmp1_output.l10(tmp0_desc, 12, value.pcw_1);
    tmp1_output.l10(tmp0_desc, 13, value.qcw_1);
    tmp1_output.p10(tmp0_desc, 14, tmp2_cached[14], value.rcw_1);
    tmp1_output.f10(tmp0_desc, 15, value.scw_1);
    tmp1_output.f10(tmp0_desc, 16, value.tcw_1);
    tmp1_output.f10(tmp0_desc, 17, value.ucw_1);
    tmp1_output.p10(tmp0_desc, 18, tmp2_cached[18], value.vcw_1);
    tmp1_output.l10(tmp0_desc, 19, value.wcw_1);
    if (tmp1_output.v10(tmp0_desc, 20) ? true : !(value.xcw_1 == null)) {
      tmp1_output.r10(tmp0_desc, 20, $serializer_getInstance_4(), value.xcw_1);
    }
    tmp1_output.p10(tmp0_desc, 21, tmp2_cached[21], value.ycw_1);
    if (tmp1_output.v10(tmp0_desc, 22) ? true : !(value.zcw_1 == null)) {
      tmp1_output.r10(tmp0_desc, 22, IntSerializer_getInstance(), value.zcw_1);
    }
    tmp1_output.i10(tmp0_desc, 23, value.acx_1);
    tmp1_output.i10(tmp0_desc, 24, value.bcx_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.bcw(encoder, value instanceof EntityDefinition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.acw_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = false;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = 0;
    var tmp15_local11 = null;
    var tmp16_local12 = 0.0;
    var tmp17_local13 = 0.0;
    var tmp18_local14 = null;
    var tmp19_local15 = false;
    var tmp20_local16 = false;
    var tmp21_local17 = false;
    var tmp22_local18 = null;
    var tmp23_local19 = 0.0;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = 0;
    var tmp28_local24 = 0;
    var tmp29_input = decoder.xy(tmp0_desc);
    var tmp30_cached = Companion_getInstance_3().zcv_1;
    if (tmp29_input.nz()) {
      tmp4_local0 = tmp29_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp29_input.jz(tmp0_desc, 1, tmp30_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp29_input.fz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp29_input.cz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp29_input.zy(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp29_input.hz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp29_input.zy(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp29_input.jz(tmp0_desc, 7, tmp30_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp29_input.jz(tmp0_desc, 8, tmp30_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp29_input.fz(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp29_input.cz(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp29_input.jz(tmp0_desc, 11, IntArraySerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp29_input.fz(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp29_input.fz(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp29_input.jz(tmp0_desc, 14, tmp30_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp29_input.zy(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp29_input.zy(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp29_input.zy(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp29_input.jz(tmp0_desc, 18, tmp30_cached[18], tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp29_input.fz(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp29_input.lz(tmp0_desc, 20, $serializer_getInstance_4(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp29_input.jz(tmp0_desc, 21, tmp30_cached[21], tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp29_input.lz(tmp0_desc, 22, IntSerializer_getInstance(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp29_input.cz(tmp0_desc, 23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp28_local24 = tmp29_input.cz(tmp0_desc, 24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp29_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp29_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp29_input.jz(tmp0_desc, 1, tmp30_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp29_input.fz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp29_input.cz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp29_input.zy(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp29_input.hz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp29_input.zy(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp29_input.jz(tmp0_desc, 7, tmp30_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp29_input.jz(tmp0_desc, 8, tmp30_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp29_input.fz(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp29_input.cz(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp29_input.jz(tmp0_desc, 11, IntArraySerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp29_input.fz(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp29_input.fz(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp29_input.jz(tmp0_desc, 14, tmp30_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp29_input.zy(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp29_input.zy(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp29_input.zy(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp29_input.jz(tmp0_desc, 18, tmp30_cached[18], tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp29_input.fz(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp29_input.lz(tmp0_desc, 20, $serializer_getInstance_4(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp29_input.jz(tmp0_desc, 21, tmp30_cached[21], tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp29_input.lz(tmp0_desc, 22, IntSerializer_getInstance(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp29_input.cz(tmp0_desc, 23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp28_local24 = tmp29_input.cz(tmp0_desc, 24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp29_input.yy(tmp0_desc);
    return EntityDefinition.ccx(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, null);
  }
  yu() {
    return this.acw_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_3().zcv_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], DoubleSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[7], tmp0_cached[8], DoubleSerializer_getInstance(), IntSerializer_getInstance(), IntArraySerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), tmp0_cached[14], BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[18], DoubleSerializer_getInstance(), get_nullable($serializer_getInstance_4()), tmp0_cached[21], get_nullable(IntSerializer_getInstance()), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class EntityDefinition {
  toString() {
    return 'EntityDefinition(color=' + this.dcw_1 + ', fieldDefs=' + toString_0(this.ecw_1) + ', fillOpacity=' + this.fcw_1 + ', height=' + this.gcw_1 + ', hollow=' + this.hcw_1 + ', identifier=' + this.icw_1 + ', keepAspectRatio=' + this.jcw_1 + ', limitBehavior=' + this.kcw_1.toString() + ', limitScope=' + this.lcw_1.toString() + ', lineOpacity=' + this.mcw_1 + ', maxCount=' + this.ncw_1 + ', nineSliceBorders=' + toString_0(this.ocw_1) + ', pivotX=' + this.pcw_1 + ', pivotY=' + this.qcw_1 + ', renderMode=' + this.rcw_1.toString() + ', resizableX=' + this.scw_1 + ', resizableY=' + this.tcw_1 + ', showName=' + this.ucw_1 + ', tags=' + toString_0(this.vcw_1) + ', tileOpacity=' + this.wcw_1 + ', tileRect=' + toString(this.xcw_1) + ', tileRenderMode=' + this.ycw_1.toString() + ', tilesetID=' + this.zcw_1 + ', uid=' + this.acx_1 + ', width=' + this.bcx_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.dcw_1);
    result = imul(result, 31) + hashCode(this.ecw_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.fcw_1) | 0;
    result = imul(result, 31) + this.gcw_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.hcw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.icw_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jcw_1) | 0;
    result = imul(result, 31) + this.kcw_1.hashCode() | 0;
    result = imul(result, 31) + this.lcw_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.mcw_1) | 0;
    result = imul(result, 31) + this.ncw_1 | 0;
    result = imul(result, 31) + hashCode(this.ocw_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pcw_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.qcw_1) | 0;
    result = imul(result, 31) + this.rcw_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.scw_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.tcw_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ucw_1) | 0;
    result = imul(result, 31) + hashCode(this.vcw_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.wcw_1) | 0;
    result = imul(result, 31) + (this.xcw_1 == null ? 0 : this.xcw_1.hashCode()) | 0;
    result = imul(result, 31) + this.ycw_1.hashCode() | 0;
    result = imul(result, 31) + (this.zcw_1 == null ? 0 : this.zcw_1) | 0;
    result = imul(result, 31) + this.acx_1 | 0;
    result = imul(result, 31) + this.bcx_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof EntityDefinition ? other : THROW_CCE();
    if (!(this.dcw_1 === tmp0_other_with_cast.dcw_1))
      return false;
    if (!equals(this.ecw_1, tmp0_other_with_cast.ecw_1))
      return false;
    if (!equals(this.fcw_1, tmp0_other_with_cast.fcw_1))
      return false;
    if (!(this.gcw_1 === tmp0_other_with_cast.gcw_1))
      return false;
    if (!(this.hcw_1 === tmp0_other_with_cast.hcw_1))
      return false;
    if (!(this.icw_1 === tmp0_other_with_cast.icw_1))
      return false;
    if (!(this.jcw_1 === tmp0_other_with_cast.jcw_1))
      return false;
    if (!this.kcw_1.equals(tmp0_other_with_cast.kcw_1))
      return false;
    if (!this.lcw_1.equals(tmp0_other_with_cast.lcw_1))
      return false;
    if (!equals(this.mcw_1, tmp0_other_with_cast.mcw_1))
      return false;
    if (!(this.ncw_1 === tmp0_other_with_cast.ncw_1))
      return false;
    if (!equals(this.ocw_1, tmp0_other_with_cast.ocw_1))
      return false;
    if (!equals(this.pcw_1, tmp0_other_with_cast.pcw_1))
      return false;
    if (!equals(this.qcw_1, tmp0_other_with_cast.qcw_1))
      return false;
    if (!this.rcw_1.equals(tmp0_other_with_cast.rcw_1))
      return false;
    if (!(this.scw_1 === tmp0_other_with_cast.scw_1))
      return false;
    if (!(this.tcw_1 === tmp0_other_with_cast.tcw_1))
      return false;
    if (!(this.ucw_1 === tmp0_other_with_cast.ucw_1))
      return false;
    if (!equals(this.vcw_1, tmp0_other_with_cast.vcw_1))
      return false;
    if (!equals(this.wcw_1, tmp0_other_with_cast.wcw_1))
      return false;
    if (!equals(this.xcw_1, tmp0_other_with_cast.xcw_1))
      return false;
    if (!this.ycw_1.equals(tmp0_other_with_cast.ycw_1))
      return false;
    if (!(this.zcw_1 == tmp0_other_with_cast.zcw_1))
      return false;
    if (!(this.acx_1 === tmp0_other_with_cast.acx_1))
      return false;
    if (!(this.bcx_1 === tmp0_other_with_cast.bcx_1))
      return false;
    return true;
  }
  c28(value) {
    this.ccw_1.c28(value);
  }
  d28() {
    return this.ccw_1.d28();
  }
  static ccx(seen0, color, fieldDefs, fillOpacity, height, hollow, identifier, keepAspectRatio, limitBehavior, limitScope, lineOpacity, maxCount, nineSliceBorders, pivotX, pivotY, renderMode, resizableX, resizableY, showName, tags, tileOpacity, tileRect, tileRenderMode, tilesetID, uid, width, serializationConstructorMarker) {
    Companion_getInstance_3();
    if (!(28311551 === (28311551 & seen0))) {
      throwMissingFieldException(seen0, 28311551, $serializer_getInstance_2().acw_1);
    }
    var $this = createThis(this);
    $this.dcw_1 = color;
    $this.ecw_1 = fieldDefs;
    $this.fcw_1 = fillOpacity;
    $this.gcw_1 = height;
    $this.hcw_1 = hollow;
    $this.icw_1 = identifier;
    $this.jcw_1 = keepAspectRatio;
    $this.kcw_1 = limitBehavior;
    $this.lcw_1 = limitScope;
    $this.mcw_1 = lineOpacity;
    $this.ncw_1 = maxCount;
    $this.ocw_1 = nineSliceBorders;
    $this.pcw_1 = pivotX;
    $this.qcw_1 = pivotY;
    $this.rcw_1 = renderMode;
    $this.scw_1 = resizableX;
    $this.tcw_1 = resizableY;
    $this.ucw_1 = showName;
    $this.vcw_1 = tags;
    $this.wcw_1 = tileOpacity;
    if (0 === (seen0 & 1048576))
      $this.xcw_1 = null;
    else
      $this.xcw_1 = tileRect;
    $this.ycw_1 = tileRenderMode;
    if (0 === (seen0 & 4194304))
      $this.zcw_1 = null;
    else
      $this.zcw_1 = tilesetID;
    $this.acx_1 = uid;
    $this.bcx_1 = width;
    $this.ccw_1 = new Mixin();
    return $this;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.dcx_1 = [new ArrayListSerializer($serializer_getInstance_2()), new ArrayListSerializer($serializer_getInstance_5()), new ArrayListSerializer($serializer_getInstance_5()), new ArrayListSerializer($serializer_getInstance_6()), new ArrayListSerializer($serializer_getInstance_1()), new ArrayListSerializer($serializer_getInstance_7())];
  }
}
class $serializer_3 {
  constructor() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.Definitions', this, 6);
    tmp0_serialDesc.m16('entities', false);
    tmp0_serialDesc.m16('enums', false);
    tmp0_serialDesc.m16('externalEnums', false);
    tmp0_serialDesc.m16('layers', false);
    tmp0_serialDesc.m16('levelFields', false);
    tmp0_serialDesc.m16('tilesets', false);
    this.ecx_1 = tmp0_serialDesc;
  }
  fcx(encoder, value) {
    var tmp0_desc = this.ecx_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().dcx_1;
    tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.hcx_1);
    tmp1_output.p10(tmp0_desc, 1, tmp2_cached[1], value.icx_1);
    tmp1_output.p10(tmp0_desc, 2, tmp2_cached[2], value.jcx_1);
    tmp1_output.p10(tmp0_desc, 3, tmp2_cached[3], value.kcx_1);
    tmp1_output.p10(tmp0_desc, 4, tmp2_cached[4], value.lcx_1);
    tmp1_output.p10(tmp0_desc, 5, tmp2_cached[5], value.mcx_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.fcx(encoder, value instanceof Definitions ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ecx_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.xy(tmp0_desc);
    var tmp11_cached = Companion_getInstance_4().dcx_1;
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.jz(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.jz(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.jz(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.jz(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.jz(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.jz(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.jz(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.jz(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return Definitions.ncx(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.ecx_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_4().dcx_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], tmp0_cached[3], tmp0_cached[4], tmp0_cached[5]];
  }
}
class Definitions {
  toString() {
    return 'Definitions(entities=' + toString_0(this.hcx_1) + ', enums=' + toString_0(this.icx_1) + ', externalEnums=' + toString_0(this.jcx_1) + ', layers=' + toString_0(this.kcx_1) + ', levelFields=' + toString_0(this.lcx_1) + ', tilesets=' + toString_0(this.mcx_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.hcx_1);
    result = imul(result, 31) + hashCode(this.icx_1) | 0;
    result = imul(result, 31) + hashCode(this.jcx_1) | 0;
    result = imul(result, 31) + hashCode(this.kcx_1) | 0;
    result = imul(result, 31) + hashCode(this.lcx_1) | 0;
    result = imul(result, 31) + hashCode(this.mcx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Definitions))
      return false;
    var tmp0_other_with_cast = other instanceof Definitions ? other : THROW_CCE();
    if (!equals(this.hcx_1, tmp0_other_with_cast.hcx_1))
      return false;
    if (!equals(this.icx_1, tmp0_other_with_cast.icx_1))
      return false;
    if (!equals(this.jcx_1, tmp0_other_with_cast.jcx_1))
      return false;
    if (!equals(this.kcx_1, tmp0_other_with_cast.kcx_1))
      return false;
    if (!equals(this.lcx_1, tmp0_other_with_cast.lcx_1))
      return false;
    if (!equals(this.mcx_1, tmp0_other_with_cast.mcx_1))
      return false;
    return true;
  }
  c28(value) {
    this.gcx_1.c28(value);
  }
  d28() {
    return this.gcx_1.d28();
  }
  static ncx(seen0, entities, enums, externalEnums, layers, levelFields, tilesets, serializationConstructorMarker) {
    Companion_getInstance_4();
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_3().ecx_1);
    }
    var $this = createThis(this);
    $this.hcx_1 = entities;
    $this.icx_1 = enums;
    $this.jcx_1 = externalEnums;
    $this.kcx_1 = layers;
    $this.lcx_1 = levelFields;
    $this.mcx_1 = tilesets;
    $this.gcx_1 = new Mixin();
    return $this;
  }
}
class Companion_4 {}
class $serializer_4 {
  constructor() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.TilesetRectangle', this, 5);
    tmp0_serialDesc.m16('h', false);
    tmp0_serialDesc.m16('tilesetUid', false);
    tmp0_serialDesc.m16('w', false);
    tmp0_serialDesc.m16('x', false);
    tmp0_serialDesc.m16('y', false);
    this.ocx_1 = tmp0_serialDesc;
  }
  pcx(encoder, value) {
    var tmp0_desc = this.ocx_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.i10(tmp0_desc, 0, value.qcx_1);
    tmp1_output.i10(tmp0_desc, 1, value.rcx_1);
    tmp1_output.i10(tmp0_desc, 2, value.scx_1);
    tmp1_output.i10(tmp0_desc, 3, value.tcx_1);
    tmp1_output.i10(tmp0_desc, 4, value.ucx_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.pcx(encoder, value instanceof TilesetRectangle ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ocx_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = 0;
    var tmp9_input = decoder.xy(tmp0_desc);
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.cz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.cz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.cz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.cz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.cz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.cz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return TilesetRectangle.vcx(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.ocx_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class TilesetRectangle {
  toString() {
    return 'TilesetRectangle(h=' + this.qcx_1 + ', tilesetUid=' + this.rcx_1 + ', w=' + this.scx_1 + ', x=' + this.tcx_1 + ', y=' + this.ucx_1 + ')';
  }
  hashCode() {
    var result = this.qcx_1;
    result = imul(result, 31) + this.rcx_1 | 0;
    result = imul(result, 31) + this.scx_1 | 0;
    result = imul(result, 31) + this.tcx_1 | 0;
    result = imul(result, 31) + this.ucx_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TilesetRectangle))
      return false;
    var tmp0_other_with_cast = other instanceof TilesetRectangle ? other : THROW_CCE();
    if (!(this.qcx_1 === tmp0_other_with_cast.qcx_1))
      return false;
    if (!(this.rcx_1 === tmp0_other_with_cast.rcx_1))
      return false;
    if (!(this.scx_1 === tmp0_other_with_cast.scx_1))
      return false;
    if (!(this.tcx_1 === tmp0_other_with_cast.tcx_1))
      return false;
    if (!(this.ucx_1 === tmp0_other_with_cast.ucx_1))
      return false;
    return true;
  }
  static vcx(seen0, h, tilesetUid, w, x, y, serializationConstructorMarker) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_4().ocx_1);
    }
    var $this = createThis(this);
    $this.qcx_1 = h;
    $this.rcx_1 = tilesetUid;
    $this.scx_1 = w;
    $this.tcx_1 = x;
    $this.ucx_1 = y;
    return $this;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.mcu_1 = lazy(tmp_0, AllowedRefs$Companion$_anonymous__v2lmwp);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.AllowedRefs', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'Any':
        tmp = AllowedRefs_Any_getInstance();
        break;
      case 'OnlySame':
        tmp = AllowedRefs_OnlySame_getInstance();
        break;
      case 'OnlyTags':
        tmp = AllowedRefs_OnlyTags_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('AllowedRefs could not parse: ' + value);
    }
    return tmp;
  }
  wcx(encoder, value) {
    return encoder.c10(value.zcx_1);
  }
  zu(encoder, value) {
    return this.wcx(encoder, value instanceof AllowedRefs ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class AllowedRefs extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.zcx_1 = value;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ncu_1 = lazy(tmp_0, EditorDisplayMode$Companion$_anonymous__77qsc7);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.EditorDisplayMode', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'ArrayCountNoLabel':
        tmp = EditorDisplayMode_ArrayCountNoLabel_getInstance();
        break;
      case 'ArrayCountWithLabel':
        tmp = EditorDisplayMode_ArrayCountWithLabel_getInstance();
        break;
      case 'EntityTile':
        tmp = EditorDisplayMode_EntityTile_getInstance();
        break;
      case 'Hidden':
        tmp = EditorDisplayMode_Hidden_getInstance();
        break;
      case 'NameAndValue':
        tmp = EditorDisplayMode_NameAndValue_getInstance();
        break;
      case 'PointPath':
        tmp = EditorDisplayMode_PointPath_getInstance();
        break;
      case 'PointPathLoop':
        tmp = EditorDisplayMode_PointPathLoop_getInstance();
        break;
      case 'PointStar':
        tmp = EditorDisplayMode_PointStar_getInstance();
        break;
      case 'Points':
        tmp = EditorDisplayMode_Points_getInstance();
        break;
      case 'RadiusGrid':
        tmp = EditorDisplayMode_RadiusGrid_getInstance();
        break;
      case 'RadiusPx':
        tmp = EditorDisplayMode_RadiusPx_getInstance();
        break;
      case 'RefLinkBetweenCenters':
        tmp = EditorDisplayMode_RefLinkBetweenCenters_getInstance();
        break;
      case 'RefLinkBetweenPivots':
        tmp = EditorDisplayMode_RefLinkBetweenPivots_getInstance();
        break;
      case 'ValueOnly':
        tmp = EditorDisplayMode_ValueOnly_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('EditorDisplayMode could not parse: ' + value);
    }
    return tmp;
  }
  acy(encoder, value) {
    return encoder.c10(value.dcy_1);
  }
  zu(encoder, value) {
    return this.acy(encoder, value instanceof EditorDisplayMode ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_0(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class EditorDisplayMode extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.dcy_1 = value;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ocu_1 = lazy(tmp_0, EditorDisplayPos$Companion$_anonymous__f71kr4);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.EditorDisplayPos', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'Above':
        tmp = EditorDisplayPos_Above_getInstance();
        break;
      case 'Beneath':
        tmp = EditorDisplayPos_Beneath_getInstance();
        break;
      case 'Center':
        tmp = EditorDisplayPos_Center_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('EditorDisplayPos could not parse: ' + value);
    }
    return tmp;
  }
  ecy(encoder, value) {
    return encoder.c10(value.hcy_1);
  }
  zu(encoder, value) {
    return this.ecy(encoder, value instanceof EditorDisplayPos ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_1(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class EditorDisplayPos extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.hcy_1 = value;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.pcu_1 = lazy(tmp_0, TextLanguageMode$Companion$_anonymous__u336u1);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.TextLanguageMode', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'LangC':
        tmp = TextLanguageMode_LangC_getInstance();
        break;
      case 'LangHaxe':
        tmp = TextLanguageMode_LangHaxe_getInstance();
        break;
      case 'LangJS':
        tmp = TextLanguageMode_LangJS_getInstance();
        break;
      case 'LangJson':
        tmp = TextLanguageMode_LangJSON_getInstance();
        break;
      case 'LangLog':
        tmp = TextLanguageMode_LangLog_getInstance();
        break;
      case 'LangLua':
        tmp = TextLanguageMode_LangLua_getInstance();
        break;
      case 'LangMarkdown':
        tmp = TextLanguageMode_LangMarkdown_getInstance();
        break;
      case 'LangPython':
        tmp = TextLanguageMode_LangPython_getInstance();
        break;
      case 'LangRuby':
        tmp = TextLanguageMode_LangRuby_getInstance();
        break;
      case 'LangXml':
        tmp = TextLanguageMode_LangXML_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('TextLanguageMode could not parse: ' + value);
    }
    return tmp;
  }
  icy(encoder, value) {
    return encoder.c10(value.lcy_1);
  }
  zu(encoder, value) {
    return this.icy(encoder, value instanceof TextLanguageMode ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_2(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class TextLanguageMode extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.lcy_1 = value;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.vcv_1 = lazy(tmp_0, LimitBehavior$Companion$_anonymous__hsp10i);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.LimitBehavior', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'DiscardOldOnes':
        tmp = LimitBehavior_DiscardOldOnes_getInstance();
        break;
      case 'MoveLastOne':
        tmp = LimitBehavior_MoveLastOne_getInstance();
        break;
      case 'PreventAdding':
        tmp = LimitBehavior_PreventAdding_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('LimitBehavior could not parse: ' + value);
    }
    return tmp;
  }
  mcy(encoder, value) {
    return encoder.c10(value.pcy_1);
  }
  zu(encoder, value) {
    return this.mcy(encoder, value instanceof LimitBehavior ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_3(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class LimitBehavior extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.pcy_1 = value;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.wcv_1 = lazy(tmp_0, LimitScope$Companion$_anonymous__ndoxsa);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.LimitScope', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'PerLayer':
        tmp = LimitScope_PerLayer_getInstance();
        break;
      case 'PerLevel':
        tmp = LimitScope_PerLevel_getInstance();
        break;
      case 'PerWorld':
        tmp = LimitScope_PerWorld_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('LimitScope could not parse: ' + value);
    }
    return tmp;
  }
  qcy(encoder, value) {
    return encoder.c10(value.tcy_1);
  }
  zu(encoder, value) {
    return this.qcy(encoder, value instanceof LimitScope ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_4(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class LimitScope extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.tcy_1 = value;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.xcv_1 = lazy(tmp_0, RenderMode$Companion$_anonymous__ho71fu);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.RenderMode', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'Cross':
        tmp = RenderMode_Cross_getInstance();
        break;
      case 'Ellipse':
        tmp = RenderMode_Ellipse_getInstance();
        break;
      case 'Rectangle':
        tmp = RenderMode_Rectangle_getInstance();
        break;
      case 'Tile':
        tmp = RenderMode_Tile_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('RenderMode could not parse: ' + value);
    }
    return tmp;
  }
  ucy(encoder, value) {
    return encoder.c10(value.xcy_1);
  }
  zu(encoder, value) {
    return this.ucy(encoder, value instanceof RenderMode ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_5(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class RenderMode extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.xcy_1 = value;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_12 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ycv_1 = lazy(tmp_0, TileRenderMode$Companion$_anonymous__shhaw);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.TileRenderMode', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'Cover':
        tmp = TileRenderMode_Cover_getInstance();
        break;
      case 'FitInside':
        tmp = TileRenderMode_FitInside_getInstance();
        break;
      case 'FullSizeCropped':
        tmp = TileRenderMode_FullSizeCropped_getInstance();
        break;
      case 'FullSizeUncropped':
        tmp = TileRenderMode_FullSizeUncropped_getInstance();
        break;
      case 'NineSlice':
        tmp = TileRenderMode_NineSlice_getInstance();
        break;
      case 'Repeat':
        tmp = TileRenderMode_Repeat_getInstance();
        break;
      case 'Stretch':
        tmp = TileRenderMode_Stretch_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('TileRenderMode could not parse: ' + value);
    }
    return tmp;
  }
  ycy(encoder, value) {
    return encoder.c10(value.bcz_1);
  }
  zu(encoder, value) {
    return this.ycy(encoder, value instanceof TileRenderMode ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_6(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class TileRenderMode extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.bcz_1 = value;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ccz_1 = [null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, new ArrayListSerializer($serializer_getInstance_8())];
  }
}
class $serializer_5 {
  constructor() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EnumDefinition', this, 7);
    tmp0_serialDesc.m16('externalFileChecksum', true);
    tmp0_serialDesc.m16('externalRelPath', true);
    tmp0_serialDesc.m16('iconTilesetUid', true);
    tmp0_serialDesc.m16('identifier', false);
    tmp0_serialDesc.m16('tags', false);
    tmp0_serialDesc.m16('uid', false);
    tmp0_serialDesc.m16('values', false);
    this.dcz_1 = tmp0_serialDesc;
  }
  ecz(encoder, value) {
    var tmp0_desc = this.dcz_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_14().ccz_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.fcz_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, StringSerializer_getInstance(), value.fcz_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.gcz_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, StringSerializer_getInstance(), value.gcz_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.hcz_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, IntSerializer_getInstance(), value.hcz_1);
    }
    tmp1_output.n10(tmp0_desc, 3, value.icz_1);
    tmp1_output.p10(tmp0_desc, 4, tmp2_cached[4], value.jcz_1);
    tmp1_output.i10(tmp0_desc, 5, value.kcz_1);
    tmp1_output.p10(tmp0_desc, 6, tmp2_cached[6], value.lcz_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.ecz(encoder, value instanceof EnumDefinition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.dcz_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_input = decoder.xy(tmp0_desc);
    var tmp12_cached = Companion_getInstance_14().ccz_1;
    if (tmp11_input.nz()) {
      tmp4_local0 = tmp11_input.lz(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.lz(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.hz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.jz(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.cz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.jz(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.lz(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.lz(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.hz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.jz(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.cz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.jz(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp11_input.yy(tmp0_desc);
    return EnumDefinition.mcz(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  yu() {
    return this.dcz_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_14().ccz_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[4], IntSerializer_getInstance(), tmp0_cached[6]];
  }
}
class EnumDefinition {
  toString() {
    return 'EnumDefinition(externalFileChecksum=' + this.fcz_1 + ', externalRelPath=' + this.gcz_1 + ', iconTilesetUid=' + this.hcz_1 + ', identifier=' + this.icz_1 + ', tags=' + toString_0(this.jcz_1) + ', uid=' + this.kcz_1 + ', values=' + toString_0(this.lcz_1) + ')';
  }
  hashCode() {
    var result = this.fcz_1 == null ? 0 : getStringHashCode(this.fcz_1);
    result = imul(result, 31) + (this.gcz_1 == null ? 0 : getStringHashCode(this.gcz_1)) | 0;
    result = imul(result, 31) + (this.hcz_1 == null ? 0 : this.hcz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.icz_1) | 0;
    result = imul(result, 31) + hashCode(this.jcz_1) | 0;
    result = imul(result, 31) + this.kcz_1 | 0;
    result = imul(result, 31) + hashCode(this.lcz_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EnumDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof EnumDefinition ? other : THROW_CCE();
    if (!(this.fcz_1 == tmp0_other_with_cast.fcz_1))
      return false;
    if (!(this.gcz_1 == tmp0_other_with_cast.gcz_1))
      return false;
    if (!(this.hcz_1 == tmp0_other_with_cast.hcz_1))
      return false;
    if (!(this.icz_1 === tmp0_other_with_cast.icz_1))
      return false;
    if (!equals(this.jcz_1, tmp0_other_with_cast.jcz_1))
      return false;
    if (!(this.kcz_1 === tmp0_other_with_cast.kcz_1))
      return false;
    if (!equals(this.lcz_1, tmp0_other_with_cast.lcz_1))
      return false;
    return true;
  }
  static mcz(seen0, externalFileChecksum, externalRelPath, iconTilesetUid, identifier, tags, uid, values, serializationConstructorMarker) {
    Companion_getInstance_14();
    if (!(120 === (120 & seen0))) {
      throwMissingFieldException(seen0, 120, $serializer_getInstance_5().dcz_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.fcz_1 = null;
    else
      $this.fcz_1 = externalFileChecksum;
    if (0 === (seen0 & 2))
      $this.gcz_1 = null;
    else
      $this.gcz_1 = externalRelPath;
    if (0 === (seen0 & 4))
      $this.hcz_1 = null;
    else
      $this.hcz_1 = iconTilesetUid;
    $this.icz_1 = identifier;
    $this.jcz_1 = tags;
    $this.kcz_1 = uid;
    $this.lcz_1 = values;
    return $this;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ocz_1 = [null, new ArrayListSerializer($serializer_getInstance_9()), null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_10()), null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, Companion_getInstance_20().q1j(), null];
  }
}
class $serializer_6 {
  constructor() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.LayerDefinition', this, 24);
    tmp0_serialDesc.m16('__type', false);
    tmp0_serialDesc.m16('autoRuleGroups', false);
    tmp0_serialDesc.m16('autoSourceLayerDefUid', true);
    tmp0_serialDesc.m16('displayOpacity', false);
    tmp0_serialDesc.m16('excludedTags', false);
    tmp0_serialDesc.m16('gridSize', false);
    tmp0_serialDesc.m16('guideGridHei', false);
    tmp0_serialDesc.m16('guideGridWid', false);
    tmp0_serialDesc.m16('hideFieldsWhenInactive', false);
    tmp0_serialDesc.m16('hideInList', false);
    tmp0_serialDesc.m16('identifier', false);
    tmp0_serialDesc.m16('inactiveOpacity', false);
    tmp0_serialDesc.m16('intGridValues', false);
    tmp0_serialDesc.m16('parallaxFactorX', false);
    tmp0_serialDesc.m16('parallaxFactorY', false);
    tmp0_serialDesc.m16('parallaxScaling', false);
    tmp0_serialDesc.m16('pxOffsetX', false);
    tmp0_serialDesc.m16('pxOffsetY', false);
    tmp0_serialDesc.m16('requiredTags', false);
    tmp0_serialDesc.m16('tilePivotX', false);
    tmp0_serialDesc.m16('tilePivotY', false);
    tmp0_serialDesc.m16('tilesetDefUid', true);
    tmp0_serialDesc.m16('type', false);
    tmp0_serialDesc.m16('uid', false);
    this.pcz_1 = tmp0_serialDesc;
  }
  qcz(encoder, value) {
    var tmp0_desc = this.pcz_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_15().ocz_1;
    tmp1_output.n10(tmp0_desc, 0, value.rcz_1);
    tmp1_output.p10(tmp0_desc, 1, tmp2_cached[1], value.scz_1);
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.tcz_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, IntSerializer_getInstance(), value.tcz_1);
    }
    tmp1_output.l10(tmp0_desc, 3, value.ucz_1);
    tmp1_output.p10(tmp0_desc, 4, tmp2_cached[4], value.vcz_1);
    tmp1_output.i10(tmp0_desc, 5, value.wcz_1);
    tmp1_output.i10(tmp0_desc, 6, value.xcz_1);
    tmp1_output.i10(tmp0_desc, 7, value.ycz_1);
    tmp1_output.f10(tmp0_desc, 8, value.zcz_1);
    tmp1_output.f10(tmp0_desc, 9, value.ad0_1);
    tmp1_output.n10(tmp0_desc, 10, value.bd0_1);
    tmp1_output.l10(tmp0_desc, 11, value.cd0_1);
    tmp1_output.p10(tmp0_desc, 12, tmp2_cached[12], value.dd0_1);
    tmp1_output.l10(tmp0_desc, 13, value.ed0_1);
    tmp1_output.l10(tmp0_desc, 14, value.fd0_1);
    tmp1_output.f10(tmp0_desc, 15, value.gd0_1);
    tmp1_output.i10(tmp0_desc, 16, value.hd0_1);
    tmp1_output.i10(tmp0_desc, 17, value.id0_1);
    tmp1_output.p10(tmp0_desc, 18, tmp2_cached[18], value.jd0_1);
    tmp1_output.l10(tmp0_desc, 19, value.kd0_1);
    tmp1_output.l10(tmp0_desc, 20, value.ld0_1);
    if (tmp1_output.v10(tmp0_desc, 21) ? true : !(value.md0_1 == null)) {
      tmp1_output.r10(tmp0_desc, 21, IntSerializer_getInstance(), value.md0_1);
    }
    tmp1_output.p10(tmp0_desc, 22, tmp2_cached[22], value.nd0_1);
    tmp1_output.i10(tmp0_desc, 23, value.od0_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.qcz(encoder, value instanceof LayerDefinition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.pcz_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = 0;
    var tmp11_local7 = 0;
    var tmp12_local8 = false;
    var tmp13_local9 = false;
    var tmp14_local10 = null;
    var tmp15_local11 = 0.0;
    var tmp16_local12 = null;
    var tmp17_local13 = 0.0;
    var tmp18_local14 = 0.0;
    var tmp19_local15 = false;
    var tmp20_local16 = 0;
    var tmp21_local17 = 0;
    var tmp22_local18 = null;
    var tmp23_local19 = 0.0;
    var tmp24_local20 = 0.0;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = 0;
    var tmp28_input = decoder.xy(tmp0_desc);
    var tmp29_cached = Companion_getInstance_15().ocz_1;
    if (tmp28_input.nz()) {
      tmp4_local0 = tmp28_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp28_input.jz(tmp0_desc, 1, tmp29_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp28_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp28_input.fz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp28_input.jz(tmp0_desc, 4, tmp29_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp28_input.cz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp28_input.cz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp28_input.cz(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp28_input.zy(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp28_input.zy(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp28_input.hz(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp28_input.fz(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp28_input.jz(tmp0_desc, 12, tmp29_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp28_input.fz(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp28_input.fz(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp28_input.zy(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp28_input.cz(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp28_input.cz(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp28_input.jz(tmp0_desc, 18, tmp29_cached[18], tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp28_input.fz(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp28_input.fz(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp28_input.lz(tmp0_desc, 21, IntSerializer_getInstance(), tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp28_input.jz(tmp0_desc, 22, tmp29_cached[22], tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp28_input.cz(tmp0_desc, 23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp28_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp28_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp28_input.jz(tmp0_desc, 1, tmp29_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp28_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp28_input.fz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp28_input.jz(tmp0_desc, 4, tmp29_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp28_input.cz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp28_input.cz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp28_input.cz(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp28_input.zy(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp28_input.zy(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp28_input.hz(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp28_input.fz(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp28_input.jz(tmp0_desc, 12, tmp29_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp28_input.fz(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp28_input.fz(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp28_input.zy(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp28_input.cz(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp28_input.cz(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp28_input.jz(tmp0_desc, 18, tmp29_cached[18], tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp28_input.fz(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp28_input.fz(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp28_input.lz(tmp0_desc, 21, IntSerializer_getInstance(), tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp28_input.jz(tmp0_desc, 22, tmp29_cached[22], tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp28_input.cz(tmp0_desc, 23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp28_input.yy(tmp0_desc);
    return LayerDefinition.pd0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, null);
  }
  yu() {
    return this.pcz_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_15().ocz_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], get_nullable(IntSerializer_getInstance()), DoubleSerializer_getInstance(), tmp0_cached[4], IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), DoubleSerializer_getInstance(), tmp0_cached[12], DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[18], DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), tmp0_cached[22], IntSerializer_getInstance()];
  }
}
class LayerDefinition {
  toString() {
    return 'LayerDefinition(type=' + this.rcz_1 + ', autoRuleGroups=' + toString_0(this.scz_1) + ', autoSourceLayerDefUid=' + this.tcz_1 + ', displayOpacity=' + this.ucz_1 + ', excludedTags=' + toString_0(this.vcz_1) + ', gridSize=' + this.wcz_1 + ', guideGridHei=' + this.xcz_1 + ', guideGridWid=' + this.ycz_1 + ', hideFieldsWhenInactive=' + this.zcz_1 + ', hideInList=' + this.ad0_1 + ', identifier=' + this.bd0_1 + ', inactiveOpacity=' + this.cd0_1 + ', intGridValues=' + toString_0(this.dd0_1) + ', parallaxFactorX=' + this.ed0_1 + ', parallaxFactorY=' + this.fd0_1 + ', parallaxScaling=' + this.gd0_1 + ', pxOffsetX=' + this.hd0_1 + ', pxOffsetY=' + this.id0_1 + ', requiredTags=' + toString_0(this.jd0_1) + ', tilePivotX=' + this.kd0_1 + ', tilePivotY=' + this.ld0_1 + ', tilesetDefUid=' + this.md0_1 + ', layerDefinitionType=' + this.nd0_1.toString() + ', uid=' + this.od0_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.rcz_1);
    result = imul(result, 31) + hashCode(this.scz_1) | 0;
    result = imul(result, 31) + (this.tcz_1 == null ? 0 : this.tcz_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ucz_1) | 0;
    result = imul(result, 31) + hashCode(this.vcz_1) | 0;
    result = imul(result, 31) + this.wcz_1 | 0;
    result = imul(result, 31) + this.xcz_1 | 0;
    result = imul(result, 31) + this.ycz_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zcz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ad0_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bd0_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.cd0_1) | 0;
    result = imul(result, 31) + hashCode(this.dd0_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ed0_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.fd0_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gd0_1) | 0;
    result = imul(result, 31) + this.hd0_1 | 0;
    result = imul(result, 31) + this.id0_1 | 0;
    result = imul(result, 31) + hashCode(this.jd0_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.kd0_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ld0_1) | 0;
    result = imul(result, 31) + (this.md0_1 == null ? 0 : this.md0_1) | 0;
    result = imul(result, 31) + this.nd0_1.hashCode() | 0;
    result = imul(result, 31) + this.od0_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LayerDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof LayerDefinition ? other : THROW_CCE();
    if (!(this.rcz_1 === tmp0_other_with_cast.rcz_1))
      return false;
    if (!equals(this.scz_1, tmp0_other_with_cast.scz_1))
      return false;
    if (!(this.tcz_1 == tmp0_other_with_cast.tcz_1))
      return false;
    if (!equals(this.ucz_1, tmp0_other_with_cast.ucz_1))
      return false;
    if (!equals(this.vcz_1, tmp0_other_with_cast.vcz_1))
      return false;
    if (!(this.wcz_1 === tmp0_other_with_cast.wcz_1))
      return false;
    if (!(this.xcz_1 === tmp0_other_with_cast.xcz_1))
      return false;
    if (!(this.ycz_1 === tmp0_other_with_cast.ycz_1))
      return false;
    if (!(this.zcz_1 === tmp0_other_with_cast.zcz_1))
      return false;
    if (!(this.ad0_1 === tmp0_other_with_cast.ad0_1))
      return false;
    if (!(this.bd0_1 === tmp0_other_with_cast.bd0_1))
      return false;
    if (!equals(this.cd0_1, tmp0_other_with_cast.cd0_1))
      return false;
    if (!equals(this.dd0_1, tmp0_other_with_cast.dd0_1))
      return false;
    if (!equals(this.ed0_1, tmp0_other_with_cast.ed0_1))
      return false;
    if (!equals(this.fd0_1, tmp0_other_with_cast.fd0_1))
      return false;
    if (!(this.gd0_1 === tmp0_other_with_cast.gd0_1))
      return false;
    if (!(this.hd0_1 === tmp0_other_with_cast.hd0_1))
      return false;
    if (!(this.id0_1 === tmp0_other_with_cast.id0_1))
      return false;
    if (!equals(this.jd0_1, tmp0_other_with_cast.jd0_1))
      return false;
    if (!equals(this.kd0_1, tmp0_other_with_cast.kd0_1))
      return false;
    if (!equals(this.ld0_1, tmp0_other_with_cast.ld0_1))
      return false;
    if (!(this.md0_1 == tmp0_other_with_cast.md0_1))
      return false;
    if (!this.nd0_1.equals(tmp0_other_with_cast.nd0_1))
      return false;
    if (!(this.od0_1 === tmp0_other_with_cast.od0_1))
      return false;
    return true;
  }
  static pd0(seen0, type, autoRuleGroups, autoSourceLayerDefUid, displayOpacity, excludedTags, gridSize, guideGridHei, guideGridWid, hideFieldsWhenInactive, hideInList, identifier, inactiveOpacity, intGridValues, parallaxFactorX, parallaxFactorY, parallaxScaling, pxOffsetX, pxOffsetY, requiredTags, tilePivotX, tilePivotY, tilesetDefUid, layerDefinitionType, uid, serializationConstructorMarker) {
    Companion_getInstance_15();
    if (!(14680059 === (14680059 & seen0))) {
      throwMissingFieldException(seen0, 14680059, $serializer_getInstance_6().pcz_1);
    }
    var $this = createThis(this);
    $this.rcz_1 = type;
    $this.scz_1 = autoRuleGroups;
    if (0 === (seen0 & 4))
      $this.tcz_1 = null;
    else
      $this.tcz_1 = autoSourceLayerDefUid;
    $this.ucz_1 = displayOpacity;
    $this.vcz_1 = excludedTags;
    $this.wcz_1 = gridSize;
    $this.xcz_1 = guideGridHei;
    $this.ycz_1 = guideGridWid;
    $this.zcz_1 = hideFieldsWhenInactive;
    $this.ad0_1 = hideInList;
    $this.bd0_1 = identifier;
    $this.cd0_1 = inactiveOpacity;
    $this.dd0_1 = intGridValues;
    $this.ed0_1 = parallaxFactorX;
    $this.fd0_1 = parallaxFactorY;
    $this.gd0_1 = parallaxScaling;
    $this.hd0_1 = pxOffsetX;
    $this.id0_1 = pxOffsetY;
    $this.jd0_1 = requiredTags;
    $this.kd0_1 = tilePivotX;
    $this.ld0_1 = tilePivotY;
    if (0 === (seen0 & 2097152))
      $this.md0_1 = null;
    else
      $this.md0_1 = tilesetDefUid;
    $this.nd0_1 = layerDefinitionType;
    $this.od0_1 = uid;
    return $this;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.rd0_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_11()), Companion_getInstance_22().q1j(), new ArrayListSerializer($serializer_getInstance_12()), null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null];
  }
}
class $serializer_7 {
  constructor() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.TilesetDefinition', this, 17);
    tmp0_serialDesc.m16('__cHei', false);
    tmp0_serialDesc.m16('__cWid', false);
    tmp0_serialDesc.m16('cachedPixelData', true);
    tmp0_serialDesc.m16('customData', false);
    tmp0_serialDesc.m16('embedAtlas', true);
    tmp0_serialDesc.m16('enumTags', false);
    tmp0_serialDesc.m16('identifier', false);
    tmp0_serialDesc.m16('padding', false);
    tmp0_serialDesc.m16('pxHei', false);
    tmp0_serialDesc.m16('pxWid', false);
    tmp0_serialDesc.m16('relPath', true);
    tmp0_serialDesc.m16('savedSelections', false);
    tmp0_serialDesc.m16('spacing', false);
    tmp0_serialDesc.m16('tags', false);
    tmp0_serialDesc.m16('tagsSourceEnumUid', true);
    tmp0_serialDesc.m16('tileGridSize', false);
    tmp0_serialDesc.m16('uid', false);
    this.sd0_1 = tmp0_serialDesc;
  }
  td0(encoder, value) {
    var tmp0_desc = this.sd0_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_16().rd0_1;
    tmp1_output.i10(tmp0_desc, 0, value.ud0_1);
    tmp1_output.i10(tmp0_desc, 1, value.vd0_1);
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.wd0_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, JsonObjectSerializer_getInstance(), value.wd0_1);
    }
    tmp1_output.p10(tmp0_desc, 3, tmp2_cached[3], value.xd0_1);
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.yd0_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, tmp2_cached[4], value.yd0_1);
    }
    tmp1_output.p10(tmp0_desc, 5, tmp2_cached[5], value.zd0_1);
    tmp1_output.n10(tmp0_desc, 6, value.ad1_1);
    tmp1_output.i10(tmp0_desc, 7, value.bd1_1);
    tmp1_output.i10(tmp0_desc, 8, value.cd1_1);
    tmp1_output.i10(tmp0_desc, 9, value.dd1_1);
    if (tmp1_output.v10(tmp0_desc, 10) ? true : !(value.ed1_1 == null)) {
      tmp1_output.r10(tmp0_desc, 10, StringSerializer_getInstance(), value.ed1_1);
    }
    tmp1_output.p10(tmp0_desc, 11, JsonArraySerializer_getInstance(), value.fd1_1);
    tmp1_output.i10(tmp0_desc, 12, value.gd1_1);
    tmp1_output.p10(tmp0_desc, 13, tmp2_cached[13], value.hd1_1);
    if (tmp1_output.v10(tmp0_desc, 14) ? true : !(value.id1_1 == null)) {
      tmp1_output.r10(tmp0_desc, 14, IntSerializer_getInstance(), value.id1_1);
    }
    tmp1_output.i10(tmp0_desc, 15, value.jd1_1);
    tmp1_output.i10(tmp0_desc, 16, value.kd1_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.td0(encoder, value instanceof TilesetDefinition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.sd0_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = 0;
    var tmp12_local8 = 0;
    var tmp13_local9 = 0;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = 0;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = 0;
    var tmp20_local16 = 0;
    var tmp21_input = decoder.xy(tmp0_desc);
    var tmp22_cached = Companion_getInstance_16().rd0_1;
    if (tmp21_input.nz()) {
      tmp4_local0 = tmp21_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp21_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp21_input.lz(tmp0_desc, 2, JsonObjectSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp21_input.jz(tmp0_desc, 3, tmp22_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp21_input.lz(tmp0_desc, 4, tmp22_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp21_input.jz(tmp0_desc, 5, tmp22_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp21_input.hz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp21_input.cz(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp21_input.cz(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp21_input.cz(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp21_input.lz(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp21_input.jz(tmp0_desc, 11, JsonArraySerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp21_input.cz(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp21_input.jz(tmp0_desc, 13, tmp22_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp21_input.lz(tmp0_desc, 14, IntSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp21_input.cz(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp21_input.cz(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp21_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp21_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp21_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp21_input.lz(tmp0_desc, 2, JsonObjectSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp21_input.jz(tmp0_desc, 3, tmp22_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp21_input.lz(tmp0_desc, 4, tmp22_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp21_input.jz(tmp0_desc, 5, tmp22_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp21_input.hz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp21_input.cz(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp21_input.cz(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp21_input.cz(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp21_input.lz(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp21_input.jz(tmp0_desc, 11, JsonArraySerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp21_input.cz(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp21_input.jz(tmp0_desc, 13, tmp22_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp21_input.lz(tmp0_desc, 14, IntSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp21_input.cz(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp21_input.cz(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp21_input.yy(tmp0_desc);
    return TilesetDefinition.ld1(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
  }
  yu() {
    return this.sd0_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_16().rd0_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(JsonObjectSerializer_getInstance()), tmp0_cached[3], get_nullable(tmp0_cached[4]), tmp0_cached[5], StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), JsonArraySerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[13], get_nullable(IntSerializer_getInstance()), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class TilesetDefinition {
  toString() {
    return 'TilesetDefinition(cHei=' + this.ud0_1 + ', cWid=' + this.vd0_1 + ', cachedPixelData=' + toString(this.wd0_1) + ', customData=' + toString_0(this.xd0_1) + ', embedAtlas=' + toString(this.yd0_1) + ', enumTags=' + toString_0(this.zd0_1) + ', identifier=' + this.ad1_1 + ', padding=' + this.bd1_1 + ', pxHei=' + this.cd1_1 + ', pxWid=' + this.dd1_1 + ', relPath=' + this.ed1_1 + ', savedSelections=' + this.fd1_1.toString() + ', spacing=' + this.gd1_1 + ', tags=' + toString_0(this.hd1_1) + ', tagsSourceEnumUid=' + this.id1_1 + ', tileGridSize=' + this.jd1_1 + ', uid=' + this.kd1_1 + ')';
  }
  hashCode() {
    var result = this.ud0_1;
    result = imul(result, 31) + this.vd0_1 | 0;
    result = imul(result, 31) + (this.wd0_1 == null ? 0 : this.wd0_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.xd0_1) | 0;
    result = imul(result, 31) + (this.yd0_1 == null ? 0 : this.yd0_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.zd0_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ad1_1) | 0;
    result = imul(result, 31) + this.bd1_1 | 0;
    result = imul(result, 31) + this.cd1_1 | 0;
    result = imul(result, 31) + this.dd1_1 | 0;
    result = imul(result, 31) + (this.ed1_1 == null ? 0 : getStringHashCode(this.ed1_1)) | 0;
    result = imul(result, 31) + this.fd1_1.hashCode() | 0;
    result = imul(result, 31) + this.gd1_1 | 0;
    result = imul(result, 31) + hashCode(this.hd1_1) | 0;
    result = imul(result, 31) + (this.id1_1 == null ? 0 : this.id1_1) | 0;
    result = imul(result, 31) + this.jd1_1 | 0;
    result = imul(result, 31) + this.kd1_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TilesetDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof TilesetDefinition ? other : THROW_CCE();
    if (!(this.ud0_1 === tmp0_other_with_cast.ud0_1))
      return false;
    if (!(this.vd0_1 === tmp0_other_with_cast.vd0_1))
      return false;
    if (!equals(this.wd0_1, tmp0_other_with_cast.wd0_1))
      return false;
    if (!equals(this.xd0_1, tmp0_other_with_cast.xd0_1))
      return false;
    if (!equals(this.yd0_1, tmp0_other_with_cast.yd0_1))
      return false;
    if (!equals(this.zd0_1, tmp0_other_with_cast.zd0_1))
      return false;
    if (!(this.ad1_1 === tmp0_other_with_cast.ad1_1))
      return false;
    if (!(this.bd1_1 === tmp0_other_with_cast.bd1_1))
      return false;
    if (!(this.cd1_1 === tmp0_other_with_cast.cd1_1))
      return false;
    if (!(this.dd1_1 === tmp0_other_with_cast.dd1_1))
      return false;
    if (!(this.ed1_1 == tmp0_other_with_cast.ed1_1))
      return false;
    if (!this.fd1_1.equals(tmp0_other_with_cast.fd1_1))
      return false;
    if (!(this.gd1_1 === tmp0_other_with_cast.gd1_1))
      return false;
    if (!equals(this.hd1_1, tmp0_other_with_cast.hd1_1))
      return false;
    if (!(this.id1_1 == tmp0_other_with_cast.id1_1))
      return false;
    if (!(this.jd1_1 === tmp0_other_with_cast.jd1_1))
      return false;
    if (!(this.kd1_1 === tmp0_other_with_cast.kd1_1))
      return false;
    return true;
  }
  static ld1(seen0, cHei, cWid, cachedPixelData, customData, embedAtlas, enumTags, identifier, padding, pxHei, pxWid, relPath, savedSelections, spacing, tags, tagsSourceEnumUid, tileGridSize, uid, serializationConstructorMarker) {
    Companion_getInstance_16();
    if (!(113643 === (113643 & seen0))) {
      throwMissingFieldException(seen0, 113643, $serializer_getInstance_7().sd0_1);
    }
    var $this = createThis(this);
    $this.ud0_1 = cHei;
    $this.vd0_1 = cWid;
    if (0 === (seen0 & 4))
      $this.wd0_1 = null;
    else
      $this.wd0_1 = cachedPixelData;
    $this.xd0_1 = customData;
    if (0 === (seen0 & 16))
      $this.yd0_1 = null;
    else
      $this.yd0_1 = embedAtlas;
    $this.zd0_1 = enumTags;
    $this.ad1_1 = identifier;
    $this.bd1_1 = padding;
    $this.cd1_1 = pxHei;
    $this.dd1_1 = pxWid;
    if (0 === (seen0 & 1024))
      $this.ed1_1 = null;
    else
      $this.ed1_1 = relPath;
    $this.fd1_1 = savedSelections;
    $this.gd1_1 = spacing;
    $this.hd1_1 = tags;
    if (0 === (seen0 & 16384))
      $this.id1_1 = null;
    else
      $this.id1_1 = tagsSourceEnumUid;
    $this.jd1_1 = tileGridSize;
    $this.kd1_1 = uid;
    return $this;
  }
}
class Companion_16 {}
class $serializer_8 {
  constructor() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EnumValueDefinition', this, 4);
    tmp0_serialDesc.m16('__tileSrcRect', true);
    tmp0_serialDesc.m16('color', false);
    tmp0_serialDesc.m16('id', false);
    tmp0_serialDesc.m16('tileId', true);
    this.md1_1 = tmp0_serialDesc;
  }
  nd1(encoder, value) {
    var tmp0_desc = this.md1_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.od1_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, IntArraySerializer_getInstance(), value.od1_1);
    }
    tmp1_output.i10(tmp0_desc, 1, value.pd1_1);
    tmp1_output.n10(tmp0_desc, 2, value.qd1_1);
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.rd1_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, IntSerializer_getInstance(), value.rd1_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.nd1(encoder, value instanceof EnumValueDefinition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.md1_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.xy(tmp0_desc);
    if (tmp8_input.nz()) {
      tmp4_local0 = tmp8_input.lz(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.lz(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.lz(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.lz(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp8_input.yy(tmp0_desc);
    return EnumValueDefinition.sd1(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  yu() {
    return this.md1_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(IntArraySerializer_getInstance()), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance())];
  }
}
class EnumValueDefinition {
  toString() {
    return 'EnumValueDefinition(tileSrcRect=' + toString_0(this.od1_1) + ', color=' + this.pd1_1 + ', id=' + this.qd1_1 + ', tileID=' + this.rd1_1 + ')';
  }
  hashCode() {
    var result = this.od1_1 == null ? 0 : hashCode(this.od1_1);
    result = imul(result, 31) + this.pd1_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.qd1_1) | 0;
    result = imul(result, 31) + (this.rd1_1 == null ? 0 : this.rd1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EnumValueDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof EnumValueDefinition ? other : THROW_CCE();
    if (!equals(this.od1_1, tmp0_other_with_cast.od1_1))
      return false;
    if (!(this.pd1_1 === tmp0_other_with_cast.pd1_1))
      return false;
    if (!(this.qd1_1 === tmp0_other_with_cast.qd1_1))
      return false;
    if (!(this.rd1_1 == tmp0_other_with_cast.rd1_1))
      return false;
    return true;
  }
  static sd1(seen0, tileSrcRect, color, id, tileID, serializationConstructorMarker) {
    if (!(6 === (6 & seen0))) {
      throwMissingFieldException(seen0, 6, $serializer_getInstance_8().md1_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.od1_1 = null;
    else
      $this.od1_1 = tileSrcRect;
    $this.pd1_1 = color;
    $this.qd1_1 = id;
    if (0 === (seen0 & 8))
      $this.rd1_1 = null;
    else
      $this.rd1_1 = tileID;
    return $this;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.td1_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_13()), null];
  }
}
class $serializer_9 {
  constructor() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.AutoLayerRuleGroup', this, 6);
    tmp0_serialDesc.m16('active', false);
    tmp0_serialDesc.m16('collapsed', true);
    tmp0_serialDesc.m16('isOptional', false);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('rules', false);
    tmp0_serialDesc.m16('uid', false);
    this.ud1_1 = tmp0_serialDesc;
  }
  vd1(encoder, value) {
    var tmp0_desc = this.ud1_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_18().td1_1;
    tmp1_output.f10(tmp0_desc, 0, value.wd1_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.xd1_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, BooleanSerializer_getInstance(), value.xd1_1);
    }
    tmp1_output.f10(tmp0_desc, 2, value.yd1_1);
    tmp1_output.n10(tmp0_desc, 3, value.zd1_1);
    tmp1_output.p10(tmp0_desc, 4, tmp2_cached[4], value.ad2_1);
    tmp1_output.i10(tmp0_desc, 5, value.bd2_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.vd1(encoder, value instanceof AutoLayerRuleGroup ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ud1_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_input = decoder.xy(tmp0_desc);
    var tmp11_cached = Companion_getInstance_18().td1_1;
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.zy(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.lz(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.zy(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.hz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.jz(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.cz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.zy(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.lz(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.zy(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.hz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.jz(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.cz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return AutoLayerRuleGroup.cd2(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.ud1_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_18().td1_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), get_nullable(BooleanSerializer_getInstance()), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4], IntSerializer_getInstance()];
  }
}
class AutoLayerRuleGroup {
  toString() {
    return 'AutoLayerRuleGroup(active=' + this.wd1_1 + ', collapsed=' + this.xd1_1 + ', isOptional=' + this.yd1_1 + ', name=' + this.zd1_1 + ', rules=' + toString_0(this.ad2_1) + ', uid=' + this.bd2_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.wd1_1);
    result = imul(result, 31) + (this.xd1_1 == null ? 0 : getBooleanHashCode(this.xd1_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.yd1_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zd1_1) | 0;
    result = imul(result, 31) + hashCode(this.ad2_1) | 0;
    result = imul(result, 31) + this.bd2_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AutoLayerRuleGroup))
      return false;
    var tmp0_other_with_cast = other instanceof AutoLayerRuleGroup ? other : THROW_CCE();
    if (!(this.wd1_1 === tmp0_other_with_cast.wd1_1))
      return false;
    if (!(this.xd1_1 == tmp0_other_with_cast.xd1_1))
      return false;
    if (!(this.yd1_1 === tmp0_other_with_cast.yd1_1))
      return false;
    if (!(this.zd1_1 === tmp0_other_with_cast.zd1_1))
      return false;
    if (!equals(this.ad2_1, tmp0_other_with_cast.ad2_1))
      return false;
    if (!(this.bd2_1 === tmp0_other_with_cast.bd2_1))
      return false;
    return true;
  }
  static cd2(seen0, active, collapsed, isOptional, name, rules, uid, serializationConstructorMarker) {
    Companion_getInstance_18();
    if (!(61 === (61 & seen0))) {
      throwMissingFieldException(seen0, 61, $serializer_getInstance_9().ud1_1);
    }
    var $this = createThis(this);
    $this.wd1_1 = active;
    if (0 === (seen0 & 2))
      $this.xd1_1 = null;
    else
      $this.xd1_1 = collapsed;
    $this.yd1_1 = isOptional;
    $this.zd1_1 = name;
    $this.ad2_1 = rules;
    $this.bd2_1 = uid;
    return $this;
  }
}
class Companion_18 {}
class $serializer_10 {
  constructor() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.IntGridValueDefinition', this, 3);
    tmp0_serialDesc.m16('color', false);
    tmp0_serialDesc.m16('identifier', true);
    tmp0_serialDesc.m16('value', false);
    this.dd2_1 = tmp0_serialDesc;
  }
  ed2(encoder, value) {
    var tmp0_desc = this.dd2_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.fd2_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.gd2_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, StringSerializer_getInstance(), value.gd2_1);
    }
    tmp1_output.i10(tmp0_desc, 2, value.hd2_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.ed2(encoder, value instanceof IntGridValueDefinition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.dd2_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.xy(tmp0_desc);
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.lz(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.cz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.lz(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.cz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return IntGridValueDefinition.id2(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.dd2_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance()];
  }
}
class IntGridValueDefinition {
  toString() {
    return 'IntGridValueDefinition(color=' + this.fd2_1 + ', identifier=' + this.gd2_1 + ', value=' + this.hd2_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.fd2_1);
    result = imul(result, 31) + (this.gd2_1 == null ? 0 : getStringHashCode(this.gd2_1)) | 0;
    result = imul(result, 31) + this.hd2_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IntGridValueDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof IntGridValueDefinition ? other : THROW_CCE();
    if (!(this.fd2_1 === tmp0_other_with_cast.fd2_1))
      return false;
    if (!(this.gd2_1 == tmp0_other_with_cast.gd2_1))
      return false;
    if (!(this.hd2_1 === tmp0_other_with_cast.hd2_1))
      return false;
    return true;
  }
  static id2(seen0, color, identifier, value, serializationConstructorMarker) {
    if (!(5 === (5 & seen0))) {
      throwMissingFieldException(seen0, 5, $serializer_getInstance_10().dd2_1);
    }
    var $this = createThis(this);
    $this.fd2_1 = color;
    if (0 === (seen0 & 2))
      $this.gd2_1 = null;
    else
      $this.gd2_1 = identifier;
    $this.hd2_1 = value;
    return $this;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ncz_1 = lazy(tmp_0, Type$Companion$_anonymous__vg0awb);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.Type', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'AutoLayer':
        tmp = Type_AutoLayer_getInstance();
        break;
      case 'Entities':
        tmp = Type_Entities_getInstance();
        break;
      case 'IntGrid':
        tmp = Type_IntGrid_getInstance();
        break;
      case 'Tiles':
        tmp = Type_Tiles_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('Type could not parse: ' + value);
    }
    return tmp;
  }
  jd2(encoder, value) {
    return encoder.c10(value.md2_1);
  }
  zu(encoder, value) {
    return this.jd2(encoder, value instanceof Type ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_7(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class Type extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.md2_1 = value;
  }
}
class Companion_20 {}
class $serializer_11 {
  constructor() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.TileCustomMetadata', this, 2);
    tmp0_serialDesc.m16('data', false);
    tmp0_serialDesc.m16('tileId', false);
    this.nd2_1 = tmp0_serialDesc;
  }
  od2(encoder, value) {
    var tmp0_desc = this.nd2_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.pd2_1);
    tmp1_output.i10(tmp0_desc, 1, value.qd2_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.od2(encoder, value instanceof TileCustomMetadata ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.nd2_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return TileCustomMetadata.rd2(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.nd2_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class TileCustomMetadata {
  toString() {
    return 'TileCustomMetadata(data=' + this.pd2_1 + ', tileID=' + this.qd2_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.pd2_1);
    result = imul(result, 31) + this.qd2_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TileCustomMetadata))
      return false;
    var tmp0_other_with_cast = other instanceof TileCustomMetadata ? other : THROW_CCE();
    if (!(this.pd2_1 === tmp0_other_with_cast.pd2_1))
      return false;
    if (!(this.qd2_1 === tmp0_other_with_cast.qd2_1))
      return false;
    return true;
  }
  static rd2(seen0, data, tileID, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_11().nd2_1);
    }
    var $this = createThis(this);
    $this.pd2_1 = data;
    $this.qd2_1 = tileID;
    return $this;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_21 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.qd0_1 = lazy(tmp_0, EmbedAtlas$Companion$_anonymous__2y90yr);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.EmbedAtlas', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    if (value === 'LdtkIcons') {
      tmp = EmbedAtlas_LdtkIcons_getInstance();
    } else {
      throw IllegalArgumentException.l('EmbedAtlas could not parse: ' + value);
    }
    return tmp;
  }
  sd2(encoder, value) {
    return encoder.c10(value.vd2_1);
  }
  zu(encoder, value) {
    return this.sd2(encoder, value instanceof EmbedAtlas ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_8(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class EmbedAtlas extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.vd2_1 = value;
  }
}
class Companion_22 {}
class $serializer_12 {
  constructor() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EnumTagValue', this, 2);
    tmp0_serialDesc.m16('enumValueId', false);
    tmp0_serialDesc.m16('tileIds', false);
    this.wd2_1 = tmp0_serialDesc;
  }
  xd2(encoder, value) {
    var tmp0_desc = this.wd2_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.yd2_1);
    tmp1_output.p10(tmp0_desc, 1, IntArraySerializer_getInstance(), value.zd2_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.xd2(encoder, value instanceof EnumTagValue ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.wd2_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.jz(tmp0_desc, 1, IntArraySerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.jz(tmp0_desc, 1, IntArraySerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return EnumTagValue.ad3(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.wd2_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntArraySerializer_getInstance()];
  }
}
class EnumTagValue {
  toString() {
    return 'EnumTagValue(enumValueID=' + this.yd2_1 + ', tileIDS=' + toString_0(this.zd2_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.yd2_1);
    result = imul(result, 31) + hashCode(this.zd2_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EnumTagValue))
      return false;
    var tmp0_other_with_cast = other instanceof EnumTagValue ? other : THROW_CCE();
    if (!(this.yd2_1 === tmp0_other_with_cast.yd2_1))
      return false;
    if (!equals(this.zd2_1, tmp0_other_with_cast.zd2_1))
      return false;
    return true;
  }
  static ad3(seen0, enumValueID, tileIDS, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_12().wd2_1);
    }
    var $this = createThis(this);
    $this.yd2_1 = enumValueID;
    $this.zd2_1 = tileIDS;
    return $this;
  }
}
class Companion_23 {
  constructor() {
    Companion_instance_23 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.dd3_1 = [null, null, null, Companion_getInstance_25().q1j(), null, null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer(IntArraySerializer_getInstance()), Companion_getInstance_26().q1j(), null, null, null, null, null];
  }
}
class $serializer_13 {
  constructor() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.AutoLayerRuleDefinition', this, 22);
    tmp0_serialDesc.m16('active', false);
    tmp0_serialDesc.m16('breakOnMatch', false);
    tmp0_serialDesc.m16('chance', false);
    tmp0_serialDesc.m16('checker', false);
    tmp0_serialDesc.m16('flipX', false);
    tmp0_serialDesc.m16('flipY', false);
    tmp0_serialDesc.m16('outOfBoundsValue', true);
    tmp0_serialDesc.m16('pattern', false);
    tmp0_serialDesc.m16('perlinActive', false);
    tmp0_serialDesc.m16('perlinOctaves', false);
    tmp0_serialDesc.m16('perlinScale', false);
    tmp0_serialDesc.m16('perlinSeed', false);
    tmp0_serialDesc.m16('pivotX', false);
    tmp0_serialDesc.m16('pivotY', false);
    tmp0_serialDesc.m16('size', false);
    tmp0_serialDesc.m16('tileRectsIds', false);
    tmp0_serialDesc.m16('tileMode', false);
    tmp0_serialDesc.m16('uid', false);
    tmp0_serialDesc.m16('xModulo', false);
    tmp0_serialDesc.m16('xOffset', false);
    tmp0_serialDesc.m16('yModulo', false);
    tmp0_serialDesc.m16('yOffset', false);
    this.ed3_1 = tmp0_serialDesc;
  }
  fd3(encoder, value) {
    var tmp0_desc = this.ed3_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_24().dd3_1;
    tmp1_output.f10(tmp0_desc, 0, value.gd3_1);
    tmp1_output.f10(tmp0_desc, 1, value.hd3_1);
    tmp1_output.l10(tmp0_desc, 2, value.id3_1);
    tmp1_output.p10(tmp0_desc, 3, tmp2_cached[3], value.jd3_1);
    tmp1_output.f10(tmp0_desc, 4, value.kd3_1);
    tmp1_output.f10(tmp0_desc, 5, value.ld3_1);
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.md3_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, IntSerializer_getInstance(), value.md3_1);
    }
    tmp1_output.p10(tmp0_desc, 7, IntArraySerializer_getInstance(), value.nd3_1);
    tmp1_output.f10(tmp0_desc, 8, value.od3_1);
    tmp1_output.l10(tmp0_desc, 9, value.pd3_1);
    tmp1_output.l10(tmp0_desc, 10, value.qd3_1);
    tmp1_output.l10(tmp0_desc, 11, value.rd3_1);
    tmp1_output.l10(tmp0_desc, 12, value.sd3_1);
    tmp1_output.l10(tmp0_desc, 13, value.td3_1);
    tmp1_output.i10(tmp0_desc, 14, value.ud3_1);
    tmp1_output.p10(tmp0_desc, 15, tmp2_cached[15], value.vd3_1);
    tmp1_output.p10(tmp0_desc, 16, tmp2_cached[16], value.wd3_1);
    tmp1_output.i10(tmp0_desc, 17, value.xd3_1);
    tmp1_output.i10(tmp0_desc, 18, value.yd3_1);
    tmp1_output.i10(tmp0_desc, 19, value.zd3_1);
    tmp1_output.i10(tmp0_desc, 20, value.ad4_1);
    tmp1_output.i10(tmp0_desc, 21, value.bd4_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.fd3(encoder, value instanceof AutoLayerRuleDefinition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ed3_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = false;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = false;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = 0.0;
    var tmp15_local11 = 0.0;
    var tmp16_local12 = 0.0;
    var tmp17_local13 = 0.0;
    var tmp18_local14 = 0;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = 0;
    var tmp22_local18 = 0;
    var tmp23_local19 = 0;
    var tmp24_local20 = 0;
    var tmp25_local21 = 0;
    var tmp26_input = decoder.xy(tmp0_desc);
    var tmp27_cached = Companion_getInstance_24().dd3_1;
    if (tmp26_input.nz()) {
      tmp4_local0 = tmp26_input.zy(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp26_input.zy(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp26_input.fz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp26_input.jz(tmp0_desc, 3, tmp27_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp26_input.zy(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp26_input.zy(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp26_input.lz(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp26_input.jz(tmp0_desc, 7, IntArraySerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp26_input.zy(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp26_input.fz(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp26_input.fz(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp26_input.fz(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp26_input.fz(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp26_input.fz(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp26_input.cz(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp26_input.jz(tmp0_desc, 15, tmp27_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp26_input.jz(tmp0_desc, 16, tmp27_cached[16], tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp26_input.cz(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp26_input.cz(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp26_input.cz(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp26_input.cz(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp26_input.cz(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp26_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp26_input.zy(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp26_input.zy(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp26_input.fz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp26_input.jz(tmp0_desc, 3, tmp27_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp26_input.zy(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp26_input.zy(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp26_input.lz(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp26_input.jz(tmp0_desc, 7, IntArraySerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp26_input.zy(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp26_input.fz(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp26_input.fz(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp26_input.fz(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp26_input.fz(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp26_input.fz(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp26_input.cz(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp26_input.jz(tmp0_desc, 15, tmp27_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp26_input.jz(tmp0_desc, 16, tmp27_cached[16], tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp26_input.cz(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp26_input.cz(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp26_input.cz(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp26_input.cz(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp26_input.cz(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp26_input.yy(tmp0_desc);
    return AutoLayerRuleDefinition.cd4(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, null);
  }
  yu() {
    return this.ed3_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_24().dd3_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), DoubleSerializer_getInstance(), tmp0_cached[3], BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), IntArraySerializer_getInstance(), BooleanSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[15], tmp0_cached[16], IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class AutoLayerRuleDefinition {
  toString() {
    return 'AutoLayerRuleDefinition(active=' + this.gd3_1 + ', breakOnMatch=' + this.hd3_1 + ', chance=' + this.id3_1 + ', checker=' + this.jd3_1.toString() + ', flipX=' + this.kd3_1 + ', flipY=' + this.ld3_1 + ', outOfBoundsValue=' + this.md3_1 + ', pattern=' + toString_0(this.nd3_1) + ', perlinActive=' + this.od3_1 + ', perlinOctaves=' + this.pd3_1 + ', perlinScale=' + this.qd3_1 + ', perlinSeed=' + this.rd3_1 + ', pivotX=' + this.sd3_1 + ', pivotY=' + this.td3_1 + ', size=' + this.ud3_1 + ', tileIDS=' + toString_0(this.vd3_1) + ', tileMode=' + this.wd3_1.toString() + ', uid=' + this.xd3_1 + ', xModulo=' + this.yd3_1 + ', xOffset=' + this.zd3_1 + ', yModulo=' + this.ad4_1 + ', yOffset=' + this.bd4_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.gd3_1);
    result = imul(result, 31) + getBooleanHashCode(this.hd3_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.id3_1) | 0;
    result = imul(result, 31) + this.jd3_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.kd3_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ld3_1) | 0;
    result = imul(result, 31) + (this.md3_1 == null ? 0 : this.md3_1) | 0;
    result = imul(result, 31) + hashCode(this.nd3_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.od3_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pd3_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.qd3_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.rd3_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sd3_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.td3_1) | 0;
    result = imul(result, 31) + this.ud3_1 | 0;
    result = imul(result, 31) + hashCode(this.vd3_1) | 0;
    result = imul(result, 31) + this.wd3_1.hashCode() | 0;
    result = imul(result, 31) + this.xd3_1 | 0;
    result = imul(result, 31) + this.yd3_1 | 0;
    result = imul(result, 31) + this.zd3_1 | 0;
    result = imul(result, 31) + this.ad4_1 | 0;
    result = imul(result, 31) + this.bd4_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AutoLayerRuleDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof AutoLayerRuleDefinition ? other : THROW_CCE();
    if (!(this.gd3_1 === tmp0_other_with_cast.gd3_1))
      return false;
    if (!(this.hd3_1 === tmp0_other_with_cast.hd3_1))
      return false;
    if (!equals(this.id3_1, tmp0_other_with_cast.id3_1))
      return false;
    if (!this.jd3_1.equals(tmp0_other_with_cast.jd3_1))
      return false;
    if (!(this.kd3_1 === tmp0_other_with_cast.kd3_1))
      return false;
    if (!(this.ld3_1 === tmp0_other_with_cast.ld3_1))
      return false;
    if (!(this.md3_1 == tmp0_other_with_cast.md3_1))
      return false;
    if (!equals(this.nd3_1, tmp0_other_with_cast.nd3_1))
      return false;
    if (!(this.od3_1 === tmp0_other_with_cast.od3_1))
      return false;
    if (!equals(this.pd3_1, tmp0_other_with_cast.pd3_1))
      return false;
    if (!equals(this.qd3_1, tmp0_other_with_cast.qd3_1))
      return false;
    if (!equals(this.rd3_1, tmp0_other_with_cast.rd3_1))
      return false;
    if (!equals(this.sd3_1, tmp0_other_with_cast.sd3_1))
      return false;
    if (!equals(this.td3_1, tmp0_other_with_cast.td3_1))
      return false;
    if (!(this.ud3_1 === tmp0_other_with_cast.ud3_1))
      return false;
    if (!equals(this.vd3_1, tmp0_other_with_cast.vd3_1))
      return false;
    if (!this.wd3_1.equals(tmp0_other_with_cast.wd3_1))
      return false;
    if (!(this.xd3_1 === tmp0_other_with_cast.xd3_1))
      return false;
    if (!(this.yd3_1 === tmp0_other_with_cast.yd3_1))
      return false;
    if (!(this.zd3_1 === tmp0_other_with_cast.zd3_1))
      return false;
    if (!(this.ad4_1 === tmp0_other_with_cast.ad4_1))
      return false;
    if (!(this.bd4_1 === tmp0_other_with_cast.bd4_1))
      return false;
    return true;
  }
  static cd4(seen0, active, breakOnMatch, chance, checker, flipX, flipY, outOfBoundsValue, pattern, perlinActive, perlinOctaves, perlinScale, perlinSeed, pivotX, pivotY, size, tileIDS, tileMode, uid, xModulo, xOffset, yModulo, yOffset, serializationConstructorMarker) {
    Companion_getInstance_24();
    if (!(4194239 === (4194239 & seen0))) {
      throwMissingFieldException(seen0, 4194239, $serializer_getInstance_13().ed3_1);
    }
    var $this = createThis(this);
    $this.gd3_1 = active;
    $this.hd3_1 = breakOnMatch;
    $this.id3_1 = chance;
    $this.jd3_1 = checker;
    $this.kd3_1 = flipX;
    $this.ld3_1 = flipY;
    if (0 === (seen0 & 64))
      $this.md3_1 = null;
    else
      $this.md3_1 = outOfBoundsValue;
    $this.nd3_1 = pattern;
    $this.od3_1 = perlinActive;
    $this.pd3_1 = perlinOctaves;
    $this.qd3_1 = perlinScale;
    $this.rd3_1 = perlinSeed;
    $this.sd3_1 = pivotX;
    $this.td3_1 = pivotY;
    $this.ud3_1 = size;
    $this.vd3_1 = tileIDS;
    $this.wd3_1 = tileMode;
    $this.xd3_1 = uid;
    $this.yd3_1 = xModulo;
    $this.zd3_1 = xOffset;
    $this.ad4_1 = yModulo;
    $this.bd4_1 = yOffset;
    return $this;
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_24 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.bd3_1 = lazy(tmp_0, Checker$Companion$_anonymous__y7s1qy);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.Checker', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'Horizontal':
        tmp = Checker_Horizontal_getInstance();
        break;
      case 'None':
        tmp = Checker_None_getInstance();
        break;
      case 'Vertical':
        tmp = Checker_Vertical_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('Checker could not parse: ' + value);
    }
    return tmp;
  }
  dd4(encoder, value) {
    return encoder.c10(value.gd4_1);
  }
  zu(encoder, value) {
    return this.dd4(encoder, value instanceof Checker ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_9(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class Checker extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.gd4_1 = value;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_25 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.cd3_1 = lazy(tmp_0, TileMode$Companion$_anonymous__ez765a);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.TileMode', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'Single':
        tmp = TileMode_Single_getInstance();
        break;
      case 'Stamp':
        tmp = TileMode_Stamp_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('TileMode could not parse: ' + value);
    }
    return tmp;
  }
  hd4(encoder, value) {
    return encoder.c10(value.kd4_1);
  }
  zu(encoder, value) {
    return this.hd4(encoder, value instanceof TileMode ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_10(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class TileMode extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.kd4_1 = value;
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.pd4_1 = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer(Companion_getInstance_32().q1j()), Companion_getInstance_33().q1j(), Companion_getInstance_34().q1j(), null, null, new ArrayListSerializer($serializer_getInstance_15()), null, null, null, null, null, null, null, Companion_getInstance_35().q1j(), new ArrayListSerializer($serializer_getInstance_19())];
  }
  t9q(jsonString) {
    // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
    var this_0 = Json(VOID, LDTKJson$Companion$load$lambda);
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.mz();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(LDTKJson), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    return this_0.g1h(tmp$ret$1, jsonString);
  }
}
class $serializer_14 {
  constructor() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.LDTKJson', this, 29);
    tmp0_serialDesc.m16('__FORCED_REFS', true);
    tmp0_serialDesc.m16('appBuildId', false);
    tmp0_serialDesc.m16('backupLimit', false);
    tmp0_serialDesc.m16('backupOnSave', false);
    tmp0_serialDesc.m16('bgColor', false);
    tmp0_serialDesc.m16('defaultGridSize', false);
    tmp0_serialDesc.m16('defaultLevelBgColor', false);
    tmp0_serialDesc.m16('defaultLevelHeight', true);
    tmp0_serialDesc.m16('defaultLevelWidth', true);
    tmp0_serialDesc.m16('defaultPivotX', false);
    tmp0_serialDesc.m16('defaultPivotY', false);
    tmp0_serialDesc.m16('defs', false);
    tmp0_serialDesc.m16('exportTiled', false);
    tmp0_serialDesc.m16('externalLevels', false);
    tmp0_serialDesc.m16('flags', false);
    tmp0_serialDesc.m16('identifierStyle', false);
    tmp0_serialDesc.m16('imageExportMode', false);
    tmp0_serialDesc.m16('jsonVersion', false);
    tmp0_serialDesc.m16('levelNamePattern', false);
    tmp0_serialDesc.m16('levels', false);
    tmp0_serialDesc.m16('minifyJson', false);
    tmp0_serialDesc.m16('nextUid', false);
    tmp0_serialDesc.m16('pngFilePattern', true);
    tmp0_serialDesc.m16('simplifiedExport', false);
    tmp0_serialDesc.m16('tutorialDesc', true);
    tmp0_serialDesc.m16('worldGridHeight', true);
    tmp0_serialDesc.m16('worldGridWidth', true);
    tmp0_serialDesc.m16('worldLayout', true);
    tmp0_serialDesc.m16('worlds', false);
    this.qd4_1 = tmp0_serialDesc;
  }
  rd4(encoder, value) {
    var tmp0_desc = this.qd4_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_27().pd4_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.sd4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, $serializer_getInstance_18(), value.sd4_1);
    }
    tmp1_output.l10(tmp0_desc, 1, value.td4_1);
    tmp1_output.i10(tmp0_desc, 2, value.ud4_1);
    tmp1_output.f10(tmp0_desc, 3, value.vd4_1);
    tmp1_output.n10(tmp0_desc, 4, value.wd4_1);
    tmp1_output.i10(tmp0_desc, 5, value.xd4_1);
    tmp1_output.n10(tmp0_desc, 6, value.yd4_1);
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.zd4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 7, IntSerializer_getInstance(), value.zd4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !(value.ad5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 8, IntSerializer_getInstance(), value.ad5_1);
    }
    tmp1_output.l10(tmp0_desc, 9, value.bd5_1);
    tmp1_output.l10(tmp0_desc, 10, value.cd5_1);
    tmp1_output.p10(tmp0_desc, 11, $serializer_getInstance_3(), value.dd5_1);
    tmp1_output.f10(tmp0_desc, 12, value.ed5_1);
    tmp1_output.f10(tmp0_desc, 13, value.fd5_1);
    tmp1_output.p10(tmp0_desc, 14, tmp2_cached[14], value.gd5_1);
    tmp1_output.p10(tmp0_desc, 15, tmp2_cached[15], value.hd5_1);
    tmp1_output.p10(tmp0_desc, 16, tmp2_cached[16], value.id5_1);
    tmp1_output.n10(tmp0_desc, 17, value.jd5_1);
    tmp1_output.n10(tmp0_desc, 18, value.kd5_1);
    tmp1_output.p10(tmp0_desc, 19, tmp2_cached[19], value.ld5_1);
    tmp1_output.f10(tmp0_desc, 20, value.md5_1);
    tmp1_output.i10(tmp0_desc, 21, value.nd5_1);
    if (tmp1_output.v10(tmp0_desc, 22) ? true : !(value.od5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 22, StringSerializer_getInstance(), value.od5_1);
    }
    tmp1_output.f10(tmp0_desc, 23, value.pd5_1);
    if (tmp1_output.v10(tmp0_desc, 24) ? true : !(value.qd5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 24, StringSerializer_getInstance(), value.qd5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 25) ? true : !(value.rd5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 25, IntSerializer_getInstance(), value.rd5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 26) ? true : !(value.sd5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 26, IntSerializer_getInstance(), value.sd5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 27) ? true : !(value.td5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 27, tmp2_cached[27], value.td5_1);
    }
    tmp1_output.p10(tmp0_desc, 28, tmp2_cached[28], value.ud5_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.rd4(encoder, value instanceof LDTKJson ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.qd4_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0;
    var tmp7_local3 = false;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = 0.0;
    var tmp15_local11 = null;
    var tmp16_local12 = false;
    var tmp17_local13 = false;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = false;
    var tmp25_local21 = 0;
    var tmp26_local22 = null;
    var tmp27_local23 = false;
    var tmp28_local24 = null;
    var tmp29_local25 = null;
    var tmp30_local26 = null;
    var tmp31_local27 = null;
    var tmp32_local28 = null;
    var tmp33_input = decoder.xy(tmp0_desc);
    var tmp34_cached = Companion_getInstance_27().pd4_1;
    if (tmp33_input.nz()) {
      tmp4_local0 = tmp33_input.lz(tmp0_desc, 0, $serializer_getInstance_18(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp33_input.fz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp33_input.cz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp33_input.zy(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp33_input.hz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp33_input.cz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp33_input.hz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp33_input.lz(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp33_input.lz(tmp0_desc, 8, IntSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp33_input.fz(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp33_input.fz(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp33_input.jz(tmp0_desc, 11, $serializer_getInstance_3(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp33_input.zy(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp33_input.zy(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp33_input.jz(tmp0_desc, 14, tmp34_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp33_input.jz(tmp0_desc, 15, tmp34_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp33_input.jz(tmp0_desc, 16, tmp34_cached[16], tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp33_input.hz(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp33_input.hz(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp33_input.jz(tmp0_desc, 19, tmp34_cached[19], tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp33_input.zy(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp33_input.cz(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp33_input.lz(tmp0_desc, 22, StringSerializer_getInstance(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp33_input.zy(tmp0_desc, 23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp28_local24 = tmp33_input.lz(tmp0_desc, 24, StringSerializer_getInstance(), tmp28_local24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp29_local25 = tmp33_input.lz(tmp0_desc, 25, IntSerializer_getInstance(), tmp29_local25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp30_local26 = tmp33_input.lz(tmp0_desc, 26, IntSerializer_getInstance(), tmp30_local26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
      tmp31_local27 = tmp33_input.lz(tmp0_desc, 27, tmp34_cached[27], tmp31_local27);
      tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
      tmp32_local28 = tmp33_input.jz(tmp0_desc, 28, tmp34_cached[28], tmp32_local28);
      tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp33_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp33_input.lz(tmp0_desc, 0, $serializer_getInstance_18(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp33_input.fz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp33_input.cz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp33_input.zy(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp33_input.hz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp33_input.cz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp33_input.hz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp33_input.lz(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp33_input.lz(tmp0_desc, 8, IntSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp33_input.fz(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp33_input.fz(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp33_input.jz(tmp0_desc, 11, $serializer_getInstance_3(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp33_input.zy(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp33_input.zy(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp33_input.jz(tmp0_desc, 14, tmp34_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp33_input.jz(tmp0_desc, 15, tmp34_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp33_input.jz(tmp0_desc, 16, tmp34_cached[16], tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp33_input.hz(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp33_input.hz(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp33_input.jz(tmp0_desc, 19, tmp34_cached[19], tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp33_input.zy(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp33_input.cz(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp33_input.lz(tmp0_desc, 22, StringSerializer_getInstance(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp33_input.zy(tmp0_desc, 23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp28_local24 = tmp33_input.lz(tmp0_desc, 24, StringSerializer_getInstance(), tmp28_local24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp29_local25 = tmp33_input.lz(tmp0_desc, 25, IntSerializer_getInstance(), tmp29_local25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp30_local26 = tmp33_input.lz(tmp0_desc, 26, IntSerializer_getInstance(), tmp30_local26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          case 27:
            tmp31_local27 = tmp33_input.lz(tmp0_desc, 27, tmp34_cached[27], tmp31_local27);
            tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
            break;
          case 28:
            tmp32_local28 = tmp33_input.jz(tmp0_desc, 28, tmp34_cached[28], tmp32_local28);
            tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp33_input.yy(tmp0_desc);
    return LDTKJson.vd5(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, tmp31_local27, tmp32_local28, null);
  }
  yu() {
    return this.qd4_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_27().pd4_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_18()), DoubleSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), $serializer_getInstance_3(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[14], tmp0_cached[15], tmp0_cached[16], StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[19], BooleanSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(tmp0_cached[27]), tmp0_cached[28]];
  }
}
class LDTKJson {
  toString() {
    return 'LDTKJson(forcedRefs=' + toString(this.sd4_1) + ', appBuildID=' + this.td4_1 + ', backupLimit=' + this.ud4_1 + ', backupOnSave=' + this.vd4_1 + ', bgColor=' + this.wd4_1 + ', defaultGridSize=' + this.xd4_1 + ', defaultLevelBgColor=' + this.yd4_1 + ', defaultLevelHeight=' + this.zd4_1 + ', defaultLevelWidth=' + this.ad5_1 + ', defaultPivotX=' + this.bd5_1 + ', defaultPivotY=' + this.cd5_1 + ', defs=' + this.dd5_1.toString() + ', exportTiled=' + this.ed5_1 + ', externalLevels=' + this.fd5_1 + ', flags=' + toString_0(this.gd5_1) + ', identifierStyle=' + this.hd5_1.toString() + ', imageExportMode=' + this.id5_1.toString() + ', jsonVersion=' + this.jd5_1 + ', levelNamePattern=' + this.kd5_1 + ', levels=' + toString_0(this.ld5_1) + ', minifyJSON=' + this.md5_1 + ', nextUid=' + this.nd5_1 + ', pngFilePattern=' + this.od5_1 + ', simplifiedExport=' + this.pd5_1 + ', tutorialDesc=' + this.qd5_1 + ', worldGridHeight=' + this.rd5_1 + ', worldGridWidth=' + this.sd5_1 + ', worldLayout=' + toString(this.td5_1) + ', worlds=' + toString_0(this.ud5_1) + ')';
  }
  hashCode() {
    var result = this.sd4_1 == null ? 0 : this.sd4_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.td4_1) | 0;
    result = imul(result, 31) + this.ud4_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.vd4_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wd4_1) | 0;
    result = imul(result, 31) + this.xd4_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.yd4_1) | 0;
    result = imul(result, 31) + (this.zd4_1 == null ? 0 : this.zd4_1) | 0;
    result = imul(result, 31) + (this.ad5_1 == null ? 0 : this.ad5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.bd5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.cd5_1) | 0;
    result = imul(result, 31) + this.dd5_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ed5_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.fd5_1) | 0;
    result = imul(result, 31) + hashCode(this.gd5_1) | 0;
    result = imul(result, 31) + this.hd5_1.hashCode() | 0;
    result = imul(result, 31) + this.id5_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.jd5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kd5_1) | 0;
    result = imul(result, 31) + hashCode(this.ld5_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.md5_1) | 0;
    result = imul(result, 31) + this.nd5_1 | 0;
    result = imul(result, 31) + (this.od5_1 == null ? 0 : getStringHashCode(this.od5_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.pd5_1) | 0;
    result = imul(result, 31) + (this.qd5_1 == null ? 0 : getStringHashCode(this.qd5_1)) | 0;
    result = imul(result, 31) + (this.rd5_1 == null ? 0 : this.rd5_1) | 0;
    result = imul(result, 31) + (this.sd5_1 == null ? 0 : this.sd5_1) | 0;
    result = imul(result, 31) + (this.td5_1 == null ? 0 : this.td5_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.ud5_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LDTKJson))
      return false;
    var tmp0_other_with_cast = other instanceof LDTKJson ? other : THROW_CCE();
    if (!equals(this.sd4_1, tmp0_other_with_cast.sd4_1))
      return false;
    if (!equals(this.td4_1, tmp0_other_with_cast.td4_1))
      return false;
    if (!(this.ud4_1 === tmp0_other_with_cast.ud4_1))
      return false;
    if (!(this.vd4_1 === tmp0_other_with_cast.vd4_1))
      return false;
    if (!(this.wd4_1 === tmp0_other_with_cast.wd4_1))
      return false;
    if (!(this.xd4_1 === tmp0_other_with_cast.xd4_1))
      return false;
    if (!(this.yd4_1 === tmp0_other_with_cast.yd4_1))
      return false;
    if (!(this.zd4_1 == tmp0_other_with_cast.zd4_1))
      return false;
    if (!(this.ad5_1 == tmp0_other_with_cast.ad5_1))
      return false;
    if (!equals(this.bd5_1, tmp0_other_with_cast.bd5_1))
      return false;
    if (!equals(this.cd5_1, tmp0_other_with_cast.cd5_1))
      return false;
    if (!this.dd5_1.equals(tmp0_other_with_cast.dd5_1))
      return false;
    if (!(this.ed5_1 === tmp0_other_with_cast.ed5_1))
      return false;
    if (!(this.fd5_1 === tmp0_other_with_cast.fd5_1))
      return false;
    if (!equals(this.gd5_1, tmp0_other_with_cast.gd5_1))
      return false;
    if (!this.hd5_1.equals(tmp0_other_with_cast.hd5_1))
      return false;
    if (!this.id5_1.equals(tmp0_other_with_cast.id5_1))
      return false;
    if (!(this.jd5_1 === tmp0_other_with_cast.jd5_1))
      return false;
    if (!(this.kd5_1 === tmp0_other_with_cast.kd5_1))
      return false;
    if (!equals(this.ld5_1, tmp0_other_with_cast.ld5_1))
      return false;
    if (!(this.md5_1 === tmp0_other_with_cast.md5_1))
      return false;
    if (!(this.nd5_1 === tmp0_other_with_cast.nd5_1))
      return false;
    if (!(this.od5_1 == tmp0_other_with_cast.od5_1))
      return false;
    if (!(this.pd5_1 === tmp0_other_with_cast.pd5_1))
      return false;
    if (!(this.qd5_1 == tmp0_other_with_cast.qd5_1))
      return false;
    if (!(this.rd5_1 == tmp0_other_with_cast.rd5_1))
      return false;
    if (!(this.sd5_1 == tmp0_other_with_cast.sd5_1))
      return false;
    if (!equals(this.td5_1, tmp0_other_with_cast.td5_1))
      return false;
    if (!equals(this.ud5_1, tmp0_other_with_cast.ud5_1))
      return false;
    return true;
  }
  static vd5(seen0, forcedRefs, appBuildID, backupLimit, backupOnSave, bgColor, defaultGridSize, defaultLevelBgColor, defaultLevelHeight, defaultLevelWidth, defaultPivotX, defaultPivotY, defs, exportTiled, externalLevels, flags, identifierStyle, imageExportMode, jsonVersion, levelNamePattern, levels, minifyJSON, nextUid, pngFilePattern, simplifiedExport, tutorialDesc, worldGridHeight, worldGridWidth, worldLayout, worlds, serializationConstructorMarker) {
    Companion_getInstance_27();
    if (!(281017982 === (281017982 & seen0))) {
      throwMissingFieldException(seen0, 281017982, $serializer_getInstance_14().qd4_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.sd4_1 = null;
    else
      $this.sd4_1 = forcedRefs;
    $this.td4_1 = appBuildID;
    $this.ud4_1 = backupLimit;
    $this.vd4_1 = backupOnSave;
    $this.wd4_1 = bgColor;
    $this.xd4_1 = defaultGridSize;
    $this.yd4_1 = defaultLevelBgColor;
    if (0 === (seen0 & 128))
      $this.zd4_1 = null;
    else
      $this.zd4_1 = defaultLevelHeight;
    if (0 === (seen0 & 256))
      $this.ad5_1 = null;
    else
      $this.ad5_1 = defaultLevelWidth;
    $this.bd5_1 = defaultPivotX;
    $this.cd5_1 = defaultPivotY;
    $this.dd5_1 = defs;
    $this.ed5_1 = exportTiled;
    $this.fd5_1 = externalLevels;
    $this.gd5_1 = flags;
    $this.hd5_1 = identifierStyle;
    $this.id5_1 = imageExportMode;
    $this.jd5_1 = jsonVersion;
    $this.kd5_1 = levelNamePattern;
    $this.ld5_1 = levels;
    $this.md5_1 = minifyJSON;
    $this.nd5_1 = nextUid;
    if (0 === (seen0 & 4194304))
      $this.od5_1 = null;
    else
      $this.od5_1 = pngFilePattern;
    $this.pd5_1 = simplifiedExport;
    if (0 === (seen0 & 16777216))
      $this.qd5_1 = null;
    else
      $this.qd5_1 = tutorialDesc;
    if (0 === (seen0 & 33554432))
      $this.rd5_1 = null;
    else
      $this.rd5_1 = worldGridHeight;
    if (0 === (seen0 & 67108864))
      $this.sd5_1 = null;
    else
      $this.sd5_1 = worldGridWidth;
    if (0 === (seen0 & 134217728))
      $this.td5_1 = null;
    else
      $this.td5_1 = worldLayout;
    $this.ud5_1 = worlds;
    return $this;
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_27 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.xd5_1 = [null, null, new ArrayListSerializer($serializer_getInstance_21()), null, null, null, null, Companion_getInstance_39().q1j(), null, null, new ArrayListSerializer($serializer_getInstance()), null, null, new ArrayListSerializer($serializer_getInstance_16()), null, null, null, null, null, null, null];
  }
}
class $serializer_15 {
  constructor() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.Level', this, 21);
    tmp0_serialDesc.m16('__bgColor', false);
    tmp0_serialDesc.m16('__bgPos', true);
    tmp0_serialDesc.m16('__neighbours', false);
    tmp0_serialDesc.m16('__smartColor', false);
    tmp0_serialDesc.m16('bgColor', true);
    tmp0_serialDesc.m16('bgPivotX', false);
    tmp0_serialDesc.m16('bgPivotY', false);
    tmp0_serialDesc.m16('bgPos', true);
    tmp0_serialDesc.m16('bgRelPath', true);
    tmp0_serialDesc.m16('externalRelPath', true);
    tmp0_serialDesc.m16('fieldInstances', false);
    tmp0_serialDesc.m16('identifier', false);
    tmp0_serialDesc.m16('iid', false);
    tmp0_serialDesc.m16('layerInstances', true);
    tmp0_serialDesc.m16('pxHei', false);
    tmp0_serialDesc.m16('pxWid', false);
    tmp0_serialDesc.m16('uid', false);
    tmp0_serialDesc.m16('useAutoIdentifier', false);
    tmp0_serialDesc.m16('worldDepth', false);
    tmp0_serialDesc.m16('worldX', false);
    tmp0_serialDesc.m16('worldY', false);
    this.yd5_1 = tmp0_serialDesc;
  }
  zd5(encoder, value) {
    var tmp0_desc = this.yd5_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_28().xd5_1;
    tmp1_output.n10(tmp0_desc, 0, value.ad6_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.bd6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, $serializer_getInstance_20(), value.bd6_1);
    }
    tmp1_output.p10(tmp0_desc, 2, tmp2_cached[2], value.cd6_1);
    tmp1_output.n10(tmp0_desc, 3, value.dd6_1);
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.ed6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, StringSerializer_getInstance(), value.ed6_1);
    }
    tmp1_output.l10(tmp0_desc, 5, value.fd6_1);
    tmp1_output.l10(tmp0_desc, 6, value.gd6_1);
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.hd6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 7, tmp2_cached[7], value.hd6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !(value.id6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 8, StringSerializer_getInstance(), value.id6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 9) ? true : !(value.jd6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 9, StringSerializer_getInstance(), value.jd6_1);
    }
    tmp1_output.p10(tmp0_desc, 10, tmp2_cached[10], value.kd6_1);
    tmp1_output.n10(tmp0_desc, 11, value.ld6_1);
    tmp1_output.n10(tmp0_desc, 12, value.md6_1);
    if (tmp1_output.v10(tmp0_desc, 13) ? true : !(value.nd6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 13, tmp2_cached[13], value.nd6_1);
    }
    tmp1_output.i10(tmp0_desc, 14, value.od6_1);
    tmp1_output.i10(tmp0_desc, 15, value.pd6_1);
    tmp1_output.i10(tmp0_desc, 16, value.qd6_1);
    tmp1_output.f10(tmp0_desc, 17, value.rd6_1);
    tmp1_output.i10(tmp0_desc, 18, value.sd6_1);
    tmp1_output.i10(tmp0_desc, 19, value.td6_1);
    tmp1_output.i10(tmp0_desc, 20, value.ud6_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.zd5(encoder, value instanceof Level ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.yd5_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = 0.0;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = 0;
    var tmp19_local15 = 0;
    var tmp20_local16 = 0;
    var tmp21_local17 = false;
    var tmp22_local18 = 0;
    var tmp23_local19 = 0;
    var tmp24_local20 = 0;
    var tmp25_input = decoder.xy(tmp0_desc);
    var tmp26_cached = Companion_getInstance_28().xd5_1;
    if (tmp25_input.nz()) {
      tmp4_local0 = tmp25_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp25_input.lz(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp25_input.jz(tmp0_desc, 2, tmp26_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp25_input.hz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp25_input.lz(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp25_input.fz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp25_input.fz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp25_input.lz(tmp0_desc, 7, tmp26_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp25_input.lz(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp25_input.lz(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp25_input.jz(tmp0_desc, 10, tmp26_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp25_input.hz(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp25_input.hz(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp25_input.lz(tmp0_desc, 13, tmp26_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp25_input.cz(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp25_input.cz(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp25_input.cz(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp25_input.zy(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp25_input.cz(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp25_input.cz(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp25_input.cz(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp25_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp25_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp25_input.lz(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp25_input.jz(tmp0_desc, 2, tmp26_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp25_input.hz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp25_input.lz(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp25_input.fz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp25_input.fz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp25_input.lz(tmp0_desc, 7, tmp26_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp25_input.lz(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp25_input.lz(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp25_input.jz(tmp0_desc, 10, tmp26_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp25_input.hz(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp25_input.hz(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp25_input.lz(tmp0_desc, 13, tmp26_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp25_input.cz(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp25_input.cz(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp25_input.cz(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp25_input.zy(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp25_input.cz(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp25_input.cz(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp25_input.cz(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp25_input.yy(tmp0_desc);
    return Level.vd6(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, null);
  }
  yu() {
    return this.yd5_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_28().xd5_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_20()), tmp0_cached[2], StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), get_nullable(tmp0_cached[7]), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[10], StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[13]), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class Level {
  toString() {
    return 'Level(bgColor=' + this.ad6_1 + ', bgPos=' + toString(this.bd6_1) + ', neighbours=' + toString_0(this.cd6_1) + ', smartColor=' + this.dd6_1 + ', levelBgColor=' + this.ed6_1 + ', bgPivotX=' + this.fd6_1 + ', bgPivotY=' + this.gd6_1 + ', levelBgPos=' + toString(this.hd6_1) + ', bgRelPath=' + this.id6_1 + ', externalRelPath=' + this.jd6_1 + ', fieldInstances=' + toString_0(this.kd6_1) + ', identifier=' + this.ld6_1 + ', iid=' + this.md6_1 + ', layerInstances=' + toString(this.nd6_1) + ', pxHei=' + this.od6_1 + ', pxWid=' + this.pd6_1 + ', uid=' + this.qd6_1 + ', useAutoIdentifier=' + this.rd6_1 + ', worldDepth=' + this.sd6_1 + ', worldX=' + this.td6_1 + ', worldY=' + this.ud6_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.ad6_1);
    result = imul(result, 31) + (this.bd6_1 == null ? 0 : this.bd6_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.cd6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dd6_1) | 0;
    result = imul(result, 31) + (this.ed6_1 == null ? 0 : getStringHashCode(this.ed6_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.fd6_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.gd6_1) | 0;
    result = imul(result, 31) + (this.hd6_1 == null ? 0 : this.hd6_1.hashCode()) | 0;
    result = imul(result, 31) + (this.id6_1 == null ? 0 : getStringHashCode(this.id6_1)) | 0;
    result = imul(result, 31) + (this.jd6_1 == null ? 0 : getStringHashCode(this.jd6_1)) | 0;
    result = imul(result, 31) + hashCode(this.kd6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ld6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.md6_1) | 0;
    result = imul(result, 31) + (this.nd6_1 == null ? 0 : hashCode(this.nd6_1)) | 0;
    result = imul(result, 31) + this.od6_1 | 0;
    result = imul(result, 31) + this.pd6_1 | 0;
    result = imul(result, 31) + this.qd6_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.rd6_1) | 0;
    result = imul(result, 31) + this.sd6_1 | 0;
    result = imul(result, 31) + this.td6_1 | 0;
    result = imul(result, 31) + this.ud6_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Level))
      return false;
    var tmp0_other_with_cast = other instanceof Level ? other : THROW_CCE();
    if (!(this.ad6_1 === tmp0_other_with_cast.ad6_1))
      return false;
    if (!equals(this.bd6_1, tmp0_other_with_cast.bd6_1))
      return false;
    if (!equals(this.cd6_1, tmp0_other_with_cast.cd6_1))
      return false;
    if (!(this.dd6_1 === tmp0_other_with_cast.dd6_1))
      return false;
    if (!(this.ed6_1 == tmp0_other_with_cast.ed6_1))
      return false;
    if (!equals(this.fd6_1, tmp0_other_with_cast.fd6_1))
      return false;
    if (!equals(this.gd6_1, tmp0_other_with_cast.gd6_1))
      return false;
    if (!equals(this.hd6_1, tmp0_other_with_cast.hd6_1))
      return false;
    if (!(this.id6_1 == tmp0_other_with_cast.id6_1))
      return false;
    if (!(this.jd6_1 == tmp0_other_with_cast.jd6_1))
      return false;
    if (!equals(this.kd6_1, tmp0_other_with_cast.kd6_1))
      return false;
    if (!(this.ld6_1 === tmp0_other_with_cast.ld6_1))
      return false;
    if (!(this.md6_1 === tmp0_other_with_cast.md6_1))
      return false;
    if (!equals(this.nd6_1, tmp0_other_with_cast.nd6_1))
      return false;
    if (!(this.od6_1 === tmp0_other_with_cast.od6_1))
      return false;
    if (!(this.pd6_1 === tmp0_other_with_cast.pd6_1))
      return false;
    if (!(this.qd6_1 === tmp0_other_with_cast.qd6_1))
      return false;
    if (!(this.rd6_1 === tmp0_other_with_cast.rd6_1))
      return false;
    if (!(this.sd6_1 === tmp0_other_with_cast.sd6_1))
      return false;
    if (!(this.td6_1 === tmp0_other_with_cast.td6_1))
      return false;
    if (!(this.ud6_1 === tmp0_other_with_cast.ud6_1))
      return false;
    return true;
  }
  static vd6(seen0, bgColor, bgPos, neighbours, smartColor, levelBgColor, bgPivotX, bgPivotY, levelBgPos, bgRelPath, externalRelPath, fieldInstances, identifier, iid, layerInstances, pxHei, pxWid, uid, useAutoIdentifier, worldDepth, worldX, worldY, serializationConstructorMarker) {
    Companion_getInstance_28();
    if (!(2088045 === (2088045 & seen0))) {
      throwMissingFieldException(seen0, 2088045, $serializer_getInstance_15().yd5_1);
    }
    var $this = createThis(this);
    $this.ad6_1 = bgColor;
    if (0 === (seen0 & 2))
      $this.bd6_1 = null;
    else
      $this.bd6_1 = bgPos;
    $this.cd6_1 = neighbours;
    $this.dd6_1 = smartColor;
    if (0 === (seen0 & 16))
      $this.ed6_1 = null;
    else
      $this.ed6_1 = levelBgColor;
    $this.fd6_1 = bgPivotX;
    $this.gd6_1 = bgPivotY;
    if (0 === (seen0 & 128))
      $this.hd6_1 = null;
    else
      $this.hd6_1 = levelBgPos;
    if (0 === (seen0 & 256))
      $this.id6_1 = null;
    else
      $this.id6_1 = bgRelPath;
    if (0 === (seen0 & 512))
      $this.jd6_1 = null;
    else
      $this.jd6_1 = externalRelPath;
    $this.kd6_1 = fieldInstances;
    $this.ld6_1 = identifier;
    $this.md6_1 = iid;
    if (0 === (seen0 & 8192))
      $this.nd6_1 = null;
    else
      $this.nd6_1 = layerInstances;
    $this.od6_1 = pxHei;
    $this.pd6_1 = pxWid;
    $this.qd6_1 = uid;
    $this.rd6_1 = useAutoIdentifier;
    $this.sd6_1 = worldDepth;
    $this.td6_1 = worldX;
    $this.ud6_1 = worldY;
    return $this;
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_28 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.wd6_1 = [null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_17()), new ArrayListSerializer($serializer_getInstance_0()), new ArrayListSerializer($serializer_getInstance_17()), null, null, null, null, null, null, null, null, null, null];
  }
}
class $serializer_16 {
  constructor() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.LayerInstance', this, 23);
    tmp0_serialDesc.m16('__cHei', false);
    tmp0_serialDesc.m16('__cWid', false);
    tmp0_serialDesc.m16('__gridSize', false);
    tmp0_serialDesc.m16('__identifier', false);
    tmp0_serialDesc.m16('__opacity', false);
    tmp0_serialDesc.m16('__pxTotalOffsetX', false);
    tmp0_serialDesc.m16('__pxTotalOffsetY', false);
    tmp0_serialDesc.m16('__tilesetDefUid', true);
    tmp0_serialDesc.m16('__tilesetRelPath', true);
    tmp0_serialDesc.m16('__type', false);
    tmp0_serialDesc.m16('autoLayerTiles', false);
    tmp0_serialDesc.m16('entityInstances', false);
    tmp0_serialDesc.m16('gridTiles', false);
    tmp0_serialDesc.m16('iid', false);
    tmp0_serialDesc.m16('intGridCsv', false);
    tmp0_serialDesc.m16('layerDefUid', false);
    tmp0_serialDesc.m16('levelId', false);
    tmp0_serialDesc.m16('optionalRules', false);
    tmp0_serialDesc.m16('overrideTilesetUid', true);
    tmp0_serialDesc.m16('pxOffsetX', false);
    tmp0_serialDesc.m16('pxOffsetY', false);
    tmp0_serialDesc.m16('seed', false);
    tmp0_serialDesc.m16('visible', false);
    this.xd6_1 = tmp0_serialDesc;
  }
  yd6(encoder, value) {
    var tmp0_desc = this.xd6_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_29().wd6_1;
    tmp1_output.i10(tmp0_desc, 0, value.zd6_1);
    tmp1_output.i10(tmp0_desc, 1, value.ad7_1);
    tmp1_output.i10(tmp0_desc, 2, value.bd7_1);
    tmp1_output.n10(tmp0_desc, 3, value.cd7_1);
    tmp1_output.l10(tmp0_desc, 4, value.dd7_1);
    tmp1_output.i10(tmp0_desc, 5, value.ed7_1);
    tmp1_output.i10(tmp0_desc, 6, value.fd7_1);
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.gd7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 7, IntSerializer_getInstance(), value.gd7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !(value.hd7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 8, StringSerializer_getInstance(), value.hd7_1);
    }
    tmp1_output.n10(tmp0_desc, 9, value.id7_1);
    tmp1_output.p10(tmp0_desc, 10, tmp2_cached[10], value.jd7_1);
    tmp1_output.p10(tmp0_desc, 11, tmp2_cached[11], value.kd7_1);
    tmp1_output.p10(tmp0_desc, 12, tmp2_cached[12], value.ld7_1);
    tmp1_output.n10(tmp0_desc, 13, value.md7_1);
    tmp1_output.p10(tmp0_desc, 14, IntArraySerializer_getInstance(), value.nd7_1);
    tmp1_output.i10(tmp0_desc, 15, value.od7_1);
    tmp1_output.i10(tmp0_desc, 16, value.pd7_1);
    tmp1_output.p10(tmp0_desc, 17, IntArraySerializer_getInstance(), value.qd7_1);
    if (tmp1_output.v10(tmp0_desc, 18) ? true : !(value.rd7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 18, IntSerializer_getInstance(), value.rd7_1);
    }
    tmp1_output.i10(tmp0_desc, 19, value.sd7_1);
    tmp1_output.i10(tmp0_desc, 20, value.td7_1);
    tmp1_output.i10(tmp0_desc, 21, value.ud7_1);
    tmp1_output.f10(tmp0_desc, 22, value.vd7_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.yd6(encoder, value instanceof LayerInstance ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.xd6_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = null;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0;
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = 0;
    var tmp20_local16 = 0;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = 0;
    var tmp24_local20 = 0;
    var tmp25_local21 = 0;
    var tmp26_local22 = false;
    var tmp27_input = decoder.xy(tmp0_desc);
    var tmp28_cached = Companion_getInstance_29().wd6_1;
    if (tmp27_input.nz()) {
      tmp4_local0 = tmp27_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp27_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp27_input.cz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp27_input.hz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp27_input.fz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp27_input.cz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp27_input.cz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp27_input.lz(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp27_input.lz(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp27_input.hz(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp27_input.jz(tmp0_desc, 10, tmp28_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp27_input.jz(tmp0_desc, 11, tmp28_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp27_input.jz(tmp0_desc, 12, tmp28_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp27_input.hz(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp27_input.jz(tmp0_desc, 14, IntArraySerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp27_input.cz(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp27_input.cz(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp27_input.jz(tmp0_desc, 17, IntArraySerializer_getInstance(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp27_input.lz(tmp0_desc, 18, IntSerializer_getInstance(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp27_input.cz(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp27_input.cz(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp27_input.cz(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp27_input.zy(tmp0_desc, 22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp27_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp27_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp27_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp27_input.cz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp27_input.hz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp27_input.fz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp27_input.cz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp27_input.cz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp27_input.lz(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp27_input.lz(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp27_input.hz(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp27_input.jz(tmp0_desc, 10, tmp28_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp27_input.jz(tmp0_desc, 11, tmp28_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp27_input.jz(tmp0_desc, 12, tmp28_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp27_input.hz(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp27_input.jz(tmp0_desc, 14, IntArraySerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp27_input.cz(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp27_input.cz(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp27_input.jz(tmp0_desc, 17, IntArraySerializer_getInstance(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp27_input.lz(tmp0_desc, 18, IntSerializer_getInstance(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp27_input.cz(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp27_input.cz(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp27_input.cz(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp27_input.zy(tmp0_desc, 22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp27_input.yy(tmp0_desc);
    return LayerInstance.wd7(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, null);
  }
  yu() {
    return this.xd6_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_29().wd6_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), DoubleSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[10], tmp0_cached[11], tmp0_cached[12], StringSerializer_getInstance(), IntArraySerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntArraySerializer_getInstance(), get_nullable(IntSerializer_getInstance()), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class LayerInstance {
  toString() {
    return 'LayerInstance(cHei=' + this.zd6_1 + ', cWid=' + this.ad7_1 + ', gridSize=' + this.bd7_1 + ', identifier=' + this.cd7_1 + ', opacity=' + this.dd7_1 + ', pxTotalOffsetX=' + this.ed7_1 + ', pxTotalOffsetY=' + this.fd7_1 + ', tilesetDefUid=' + this.gd7_1 + ', tilesetRelPath=' + this.hd7_1 + ', type=' + this.id7_1 + ', autoLayerTiles=' + toString_0(this.jd7_1) + ', entityInstances=' + toString_0(this.kd7_1) + ', gridTiles=' + toString_0(this.ld7_1) + ', iid=' + this.md7_1 + ', intGridCSV=' + toString_0(this.nd7_1) + ', layerDefUid=' + this.od7_1 + ', levelID=' + this.pd7_1 + ', optionalRules=' + toString_0(this.qd7_1) + ', overrideTilesetUid=' + this.rd7_1 + ', pxOffsetX=' + this.sd7_1 + ', pxOffsetY=' + this.td7_1 + ', seed=' + this.ud7_1 + ', visible=' + this.vd7_1 + ')';
  }
  hashCode() {
    var result = this.zd6_1;
    result = imul(result, 31) + this.ad7_1 | 0;
    result = imul(result, 31) + this.bd7_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.cd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.dd7_1) | 0;
    result = imul(result, 31) + this.ed7_1 | 0;
    result = imul(result, 31) + this.fd7_1 | 0;
    result = imul(result, 31) + (this.gd7_1 == null ? 0 : this.gd7_1) | 0;
    result = imul(result, 31) + (this.hd7_1 == null ? 0 : getStringHashCode(this.hd7_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.id7_1) | 0;
    result = imul(result, 31) + hashCode(this.jd7_1) | 0;
    result = imul(result, 31) + hashCode(this.kd7_1) | 0;
    result = imul(result, 31) + hashCode(this.ld7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.md7_1) | 0;
    result = imul(result, 31) + hashCode(this.nd7_1) | 0;
    result = imul(result, 31) + this.od7_1 | 0;
    result = imul(result, 31) + this.pd7_1 | 0;
    result = imul(result, 31) + hashCode(this.qd7_1) | 0;
    result = imul(result, 31) + (this.rd7_1 == null ? 0 : this.rd7_1) | 0;
    result = imul(result, 31) + this.sd7_1 | 0;
    result = imul(result, 31) + this.td7_1 | 0;
    result = imul(result, 31) + this.ud7_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.vd7_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LayerInstance))
      return false;
    var tmp0_other_with_cast = other instanceof LayerInstance ? other : THROW_CCE();
    if (!(this.zd6_1 === tmp0_other_with_cast.zd6_1))
      return false;
    if (!(this.ad7_1 === tmp0_other_with_cast.ad7_1))
      return false;
    if (!(this.bd7_1 === tmp0_other_with_cast.bd7_1))
      return false;
    if (!(this.cd7_1 === tmp0_other_with_cast.cd7_1))
      return false;
    if (!equals(this.dd7_1, tmp0_other_with_cast.dd7_1))
      return false;
    if (!(this.ed7_1 === tmp0_other_with_cast.ed7_1))
      return false;
    if (!(this.fd7_1 === tmp0_other_with_cast.fd7_1))
      return false;
    if (!(this.gd7_1 == tmp0_other_with_cast.gd7_1))
      return false;
    if (!(this.hd7_1 == tmp0_other_with_cast.hd7_1))
      return false;
    if (!(this.id7_1 === tmp0_other_with_cast.id7_1))
      return false;
    if (!equals(this.jd7_1, tmp0_other_with_cast.jd7_1))
      return false;
    if (!equals(this.kd7_1, tmp0_other_with_cast.kd7_1))
      return false;
    if (!equals(this.ld7_1, tmp0_other_with_cast.ld7_1))
      return false;
    if (!(this.md7_1 === tmp0_other_with_cast.md7_1))
      return false;
    if (!equals(this.nd7_1, tmp0_other_with_cast.nd7_1))
      return false;
    if (!(this.od7_1 === tmp0_other_with_cast.od7_1))
      return false;
    if (!(this.pd7_1 === tmp0_other_with_cast.pd7_1))
      return false;
    if (!equals(this.qd7_1, tmp0_other_with_cast.qd7_1))
      return false;
    if (!(this.rd7_1 == tmp0_other_with_cast.rd7_1))
      return false;
    if (!(this.sd7_1 === tmp0_other_with_cast.sd7_1))
      return false;
    if (!(this.td7_1 === tmp0_other_with_cast.td7_1))
      return false;
    if (!(this.ud7_1 === tmp0_other_with_cast.ud7_1))
      return false;
    if (!(this.vd7_1 === tmp0_other_with_cast.vd7_1))
      return false;
    return true;
  }
  static wd7(seen0, cHei, cWid, gridSize, identifier, opacity, pxTotalOffsetX, pxTotalOffsetY, tilesetDefUid, tilesetRelPath, type, autoLayerTiles, entityInstances, gridTiles, iid, intGridCSV, layerDefUid, levelID, optionalRules, overrideTilesetUid, pxOffsetX, pxOffsetY, seed, visible, serializationConstructorMarker) {
    Companion_getInstance_29();
    if (!(8126079 === (8126079 & seen0))) {
      throwMissingFieldException(seen0, 8126079, $serializer_getInstance_16().xd6_1);
    }
    var $this = createThis(this);
    $this.zd6_1 = cHei;
    $this.ad7_1 = cWid;
    $this.bd7_1 = gridSize;
    $this.cd7_1 = identifier;
    $this.dd7_1 = opacity;
    $this.ed7_1 = pxTotalOffsetX;
    $this.fd7_1 = pxTotalOffsetY;
    if (0 === (seen0 & 128))
      $this.gd7_1 = null;
    else
      $this.gd7_1 = tilesetDefUid;
    if (0 === (seen0 & 256))
      $this.hd7_1 = null;
    else
      $this.hd7_1 = tilesetRelPath;
    $this.id7_1 = type;
    $this.jd7_1 = autoLayerTiles;
    $this.kd7_1 = entityInstances;
    $this.ld7_1 = gridTiles;
    $this.md7_1 = iid;
    $this.nd7_1 = intGridCSV;
    $this.od7_1 = layerDefUid;
    $this.pd7_1 = levelID;
    $this.qd7_1 = optionalRules;
    if (0 === (seen0 & 262144))
      $this.rd7_1 = null;
    else
      $this.rd7_1 = overrideTilesetUid;
    $this.sd7_1 = pxOffsetX;
    $this.td7_1 = pxOffsetY;
    $this.ud7_1 = seed;
    $this.vd7_1 = visible;
    return $this;
  }
}
class Companion_29 {}
class $serializer_17 {
  constructor() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.TileInstance', this, 5);
    tmp0_serialDesc.m16('d', false);
    tmp0_serialDesc.m16('f', false);
    tmp0_serialDesc.m16('px', false);
    tmp0_serialDesc.m16('src', false);
    tmp0_serialDesc.m16('t', false);
    this.xd7_1 = tmp0_serialDesc;
  }
  yd7(encoder, value) {
    var tmp0_desc = this.xd7_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.p10(tmp0_desc, 0, IntArraySerializer_getInstance(), value.zd7_1);
    tmp1_output.i10(tmp0_desc, 1, value.ad8_1);
    tmp1_output.p10(tmp0_desc, 2, IntArraySerializer_getInstance(), value.bd8_1);
    tmp1_output.p10(tmp0_desc, 3, IntArraySerializer_getInstance(), value.cd8_1);
    tmp1_output.i10(tmp0_desc, 4, value.dd8_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.yd7(encoder, value instanceof TileInstance ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.xd7_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_input = decoder.xy(tmp0_desc);
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.jz(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.jz(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.jz(tmp0_desc, 3, IntArraySerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.cz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.jz(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.jz(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.jz(tmp0_desc, 3, IntArraySerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.cz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return TileInstance.ed8(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.xd7_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntArraySerializer_getInstance(), IntSerializer_getInstance(), IntArraySerializer_getInstance(), IntArraySerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class TileInstance {
  toString() {
    return 'TileInstance(d=' + toString_0(this.zd7_1) + ', f=' + this.ad8_1 + ', px=' + toString_0(this.bd8_1) + ', src=' + toString_0(this.cd8_1) + ', t=' + this.dd8_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.zd7_1);
    result = imul(result, 31) + this.ad8_1 | 0;
    result = imul(result, 31) + hashCode(this.bd8_1) | 0;
    result = imul(result, 31) + hashCode(this.cd8_1) | 0;
    result = imul(result, 31) + this.dd8_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TileInstance))
      return false;
    var tmp0_other_with_cast = other instanceof TileInstance ? other : THROW_CCE();
    if (!equals(this.zd7_1, tmp0_other_with_cast.zd7_1))
      return false;
    if (!(this.ad8_1 === tmp0_other_with_cast.ad8_1))
      return false;
    if (!equals(this.bd8_1, tmp0_other_with_cast.bd8_1))
      return false;
    if (!equals(this.cd8_1, tmp0_other_with_cast.cd8_1))
      return false;
    if (!(this.dd8_1 === tmp0_other_with_cast.dd8_1))
      return false;
    return true;
  }
  static ed8(seen0, d, f, px, src, t, serializationConstructorMarker) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_17().xd7_1);
    }
    var $this = createThis(this);
    $this.zd7_1 = d;
    $this.ad8_1 = f;
    $this.bd8_1 = px;
    $this.cd8_1 = src;
    $this.dd8_1 = t;
    return $this;
  }
}
class Companion_30 {}
class $serializer_18 {
  constructor() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.ForcedRefs', this, 24);
    tmp0_serialDesc.m16('AutoLayerRuleGroup', true);
    tmp0_serialDesc.m16('AutoRuleDef', true);
    tmp0_serialDesc.m16('Definitions', true);
    tmp0_serialDesc.m16('EntityDef', true);
    tmp0_serialDesc.m16('EntityInstance', true);
    tmp0_serialDesc.m16('EntityReferenceInfos', true);
    tmp0_serialDesc.m16('EnumDef', true);
    tmp0_serialDesc.m16('EnumDefValues', true);
    tmp0_serialDesc.m16('EnumTagValue', true);
    tmp0_serialDesc.m16('FieldDef', true);
    tmp0_serialDesc.m16('FieldInstance', true);
    tmp0_serialDesc.m16('GridPoint', true);
    tmp0_serialDesc.m16('IntGridValueDef', true);
    tmp0_serialDesc.m16('IntGridValueInstance', true);
    tmp0_serialDesc.m16('LayerDef', true);
    tmp0_serialDesc.m16('LayerInstance', true);
    tmp0_serialDesc.m16('Level', true);
    tmp0_serialDesc.m16('LevelBgPosInfos', true);
    tmp0_serialDesc.m16('NeighbourLevel', true);
    tmp0_serialDesc.m16('Tile', true);
    tmp0_serialDesc.m16('TileCustomMetadata', true);
    tmp0_serialDesc.m16('TilesetDef', true);
    tmp0_serialDesc.m16('TilesetRect', true);
    tmp0_serialDesc.m16('World', true);
    this.fd8_1 = tmp0_serialDesc;
  }
  gd8(encoder, value) {
    var tmp0_desc = this.fd8_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.hd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, $serializer_getInstance_9(), value.hd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.id8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, $serializer_getInstance_13(), value.id8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.jd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, $serializer_getInstance_3(), value.jd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.kd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, $serializer_getInstance_2(), value.kd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.ld8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, $serializer_getInstance_0(), value.ld8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.md8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, $serializer_getInstance_22(), value.md8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.nd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, $serializer_getInstance_5(), value.nd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.od8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 7, $serializer_getInstance_8(), value.od8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !(value.pd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 8, $serializer_getInstance_12(), value.pd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 9) ? true : !(value.qd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 9, $serializer_getInstance_1(), value.qd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 10) ? true : !(value.rd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 10, $serializer_getInstance(), value.rd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 11) ? true : !(value.sd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 11, $serializer_getInstance_23(), value.sd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 12) ? true : !(value.td8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 12, $serializer_getInstance_10(), value.td8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 13) ? true : !(value.ud8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 13, $serializer_getInstance_24(), value.ud8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 14) ? true : !(value.vd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 14, $serializer_getInstance_6(), value.vd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 15) ? true : !(value.wd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 15, $serializer_getInstance_16(), value.wd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 16) ? true : !(value.xd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 16, $serializer_getInstance_15(), value.xd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 17) ? true : !(value.yd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 17, $serializer_getInstance_20(), value.yd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 18) ? true : !(value.zd8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 18, $serializer_getInstance_21(), value.zd8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 19) ? true : !(value.ad9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 19, $serializer_getInstance_17(), value.ad9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 20) ? true : !(value.bd9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 20, $serializer_getInstance_11(), value.bd9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 21) ? true : !(value.cd9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 21, $serializer_getInstance_7(), value.cd9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 22) ? true : !(value.dd9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 22, $serializer_getInstance_4(), value.dd9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 23) ? true : !(value.ed9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 23, $serializer_getInstance_19(), value.ed9_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.gd8(encoder, value instanceof ForcedRefs ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.fd8_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = null;
    var tmp28_input = decoder.xy(tmp0_desc);
    if (tmp28_input.nz()) {
      tmp4_local0 = tmp28_input.lz(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp28_input.lz(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp28_input.lz(tmp0_desc, 2, $serializer_getInstance_3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp28_input.lz(tmp0_desc, 3, $serializer_getInstance_2(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp28_input.lz(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp28_input.lz(tmp0_desc, 5, $serializer_getInstance_22(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp28_input.lz(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp28_input.lz(tmp0_desc, 7, $serializer_getInstance_8(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp28_input.lz(tmp0_desc, 8, $serializer_getInstance_12(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp28_input.lz(tmp0_desc, 9, $serializer_getInstance_1(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp28_input.lz(tmp0_desc, 10, $serializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp28_input.lz(tmp0_desc, 11, $serializer_getInstance_23(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp28_input.lz(tmp0_desc, 12, $serializer_getInstance_10(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp28_input.lz(tmp0_desc, 13, $serializer_getInstance_24(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp28_input.lz(tmp0_desc, 14, $serializer_getInstance_6(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp28_input.lz(tmp0_desc, 15, $serializer_getInstance_16(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp28_input.lz(tmp0_desc, 16, $serializer_getInstance_15(), tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp28_input.lz(tmp0_desc, 17, $serializer_getInstance_20(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp28_input.lz(tmp0_desc, 18, $serializer_getInstance_21(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp28_input.lz(tmp0_desc, 19, $serializer_getInstance_17(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp28_input.lz(tmp0_desc, 20, $serializer_getInstance_11(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp28_input.lz(tmp0_desc, 21, $serializer_getInstance_7(), tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp28_input.lz(tmp0_desc, 22, $serializer_getInstance_4(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp28_input.lz(tmp0_desc, 23, $serializer_getInstance_19(), tmp27_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp28_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp28_input.lz(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp28_input.lz(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp28_input.lz(tmp0_desc, 2, $serializer_getInstance_3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp28_input.lz(tmp0_desc, 3, $serializer_getInstance_2(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp28_input.lz(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp28_input.lz(tmp0_desc, 5, $serializer_getInstance_22(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp28_input.lz(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp28_input.lz(tmp0_desc, 7, $serializer_getInstance_8(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp28_input.lz(tmp0_desc, 8, $serializer_getInstance_12(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp28_input.lz(tmp0_desc, 9, $serializer_getInstance_1(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp28_input.lz(tmp0_desc, 10, $serializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp28_input.lz(tmp0_desc, 11, $serializer_getInstance_23(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp28_input.lz(tmp0_desc, 12, $serializer_getInstance_10(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp28_input.lz(tmp0_desc, 13, $serializer_getInstance_24(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp28_input.lz(tmp0_desc, 14, $serializer_getInstance_6(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp28_input.lz(tmp0_desc, 15, $serializer_getInstance_16(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp28_input.lz(tmp0_desc, 16, $serializer_getInstance_15(), tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp28_input.lz(tmp0_desc, 17, $serializer_getInstance_20(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp28_input.lz(tmp0_desc, 18, $serializer_getInstance_21(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp28_input.lz(tmp0_desc, 19, $serializer_getInstance_17(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp28_input.lz(tmp0_desc, 20, $serializer_getInstance_11(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp28_input.lz(tmp0_desc, 21, $serializer_getInstance_7(), tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp28_input.lz(tmp0_desc, 22, $serializer_getInstance_4(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp28_input.lz(tmp0_desc, 23, $serializer_getInstance_19(), tmp27_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp28_input.yy(tmp0_desc);
    return ForcedRefs.fd9(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, null);
  }
  yu() {
    return this.fd8_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_9()), get_nullable($serializer_getInstance_13()), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_0()), get_nullable($serializer_getInstance_22()), get_nullable($serializer_getInstance_5()), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_12()), get_nullable($serializer_getInstance_1()), get_nullable($serializer_getInstance()), get_nullable($serializer_getInstance_23()), get_nullable($serializer_getInstance_10()), get_nullable($serializer_getInstance_24()), get_nullable($serializer_getInstance_6()), get_nullable($serializer_getInstance_16()), get_nullable($serializer_getInstance_15()), get_nullable($serializer_getInstance_20()), get_nullable($serializer_getInstance_21()), get_nullable($serializer_getInstance_17()), get_nullable($serializer_getInstance_11()), get_nullable($serializer_getInstance_7()), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_19())];
  }
}
class ForcedRefs {
  constructor(autoLayerRuleGroup, autoRuleDef, definitions, entityDef, entityInstance, entityReferenceInfos, enumDef, enumDefValues, enumTagValue, fieldDef, fieldInstance, gridPoint, intGridValueDef, intGridValueInstance, layerDef, layerInstance, level, levelBgPosInfos, neighbourLevel, tile, tileCustomMetadata, tilesetDef, tilesetRect, world) {
    autoLayerRuleGroup = autoLayerRuleGroup === VOID ? null : autoLayerRuleGroup;
    autoRuleDef = autoRuleDef === VOID ? null : autoRuleDef;
    definitions = definitions === VOID ? null : definitions;
    entityDef = entityDef === VOID ? null : entityDef;
    entityInstance = entityInstance === VOID ? null : entityInstance;
    entityReferenceInfos = entityReferenceInfos === VOID ? null : entityReferenceInfos;
    enumDef = enumDef === VOID ? null : enumDef;
    enumDefValues = enumDefValues === VOID ? null : enumDefValues;
    enumTagValue = enumTagValue === VOID ? null : enumTagValue;
    fieldDef = fieldDef === VOID ? null : fieldDef;
    fieldInstance = fieldInstance === VOID ? null : fieldInstance;
    gridPoint = gridPoint === VOID ? null : gridPoint;
    intGridValueDef = intGridValueDef === VOID ? null : intGridValueDef;
    intGridValueInstance = intGridValueInstance === VOID ? null : intGridValueInstance;
    layerDef = layerDef === VOID ? null : layerDef;
    layerInstance = layerInstance === VOID ? null : layerInstance;
    level = level === VOID ? null : level;
    levelBgPosInfos = levelBgPosInfos === VOID ? null : levelBgPosInfos;
    neighbourLevel = neighbourLevel === VOID ? null : neighbourLevel;
    tile = tile === VOID ? null : tile;
    tileCustomMetadata = tileCustomMetadata === VOID ? null : tileCustomMetadata;
    tilesetDef = tilesetDef === VOID ? null : tilesetDef;
    tilesetRect = tilesetRect === VOID ? null : tilesetRect;
    world = world === VOID ? null : world;
    this.hd8_1 = autoLayerRuleGroup;
    this.id8_1 = autoRuleDef;
    this.jd8_1 = definitions;
    this.kd8_1 = entityDef;
    this.ld8_1 = entityInstance;
    this.md8_1 = entityReferenceInfos;
    this.nd8_1 = enumDef;
    this.od8_1 = enumDefValues;
    this.pd8_1 = enumTagValue;
    this.qd8_1 = fieldDef;
    this.rd8_1 = fieldInstance;
    this.sd8_1 = gridPoint;
    this.td8_1 = intGridValueDef;
    this.ud8_1 = intGridValueInstance;
    this.vd8_1 = layerDef;
    this.wd8_1 = layerInstance;
    this.xd8_1 = level;
    this.yd8_1 = levelBgPosInfos;
    this.zd8_1 = neighbourLevel;
    this.ad9_1 = tile;
    this.bd9_1 = tileCustomMetadata;
    this.cd9_1 = tilesetDef;
    this.dd9_1 = tilesetRect;
    this.ed9_1 = world;
  }
  toString() {
    return 'ForcedRefs(autoLayerRuleGroup=' + toString(this.hd8_1) + ', autoRuleDef=' + toString(this.id8_1) + ', definitions=' + toString(this.jd8_1) + ', entityDef=' + toString(this.kd8_1) + ', entityInstance=' + toString(this.ld8_1) + ', entityReferenceInfos=' + toString(this.md8_1) + ', enumDef=' + toString(this.nd8_1) + ', enumDefValues=' + toString(this.od8_1) + ', enumTagValue=' + toString(this.pd8_1) + ', fieldDef=' + toString(this.qd8_1) + ', fieldInstance=' + toString(this.rd8_1) + ', gridPoint=' + toString(this.sd8_1) + ', intGridValueDef=' + toString(this.td8_1) + ', intGridValueInstance=' + toString(this.ud8_1) + ', layerDef=' + toString(this.vd8_1) + ', layerInstance=' + toString(this.wd8_1) + ', level=' + toString(this.xd8_1) + ', levelBgPosInfos=' + toString(this.yd8_1) + ', neighbourLevel=' + toString(this.zd8_1) + ', tile=' + toString(this.ad9_1) + ', tileCustomMetadata=' + toString(this.bd9_1) + ', tilesetDef=' + toString(this.cd9_1) + ', tilesetRect=' + toString(this.dd9_1) + ', world=' + toString(this.ed9_1) + ')';
  }
  hashCode() {
    var result = this.hd8_1 == null ? 0 : this.hd8_1.hashCode();
    result = imul(result, 31) + (this.id8_1 == null ? 0 : this.id8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.jd8_1 == null ? 0 : this.jd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.kd8_1 == null ? 0 : this.kd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ld8_1 == null ? 0 : this.ld8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.md8_1 == null ? 0 : this.md8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.nd8_1 == null ? 0 : this.nd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.od8_1 == null ? 0 : this.od8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.pd8_1 == null ? 0 : this.pd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.qd8_1 == null ? 0 : this.qd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.rd8_1 == null ? 0 : this.rd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.sd8_1 == null ? 0 : this.sd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.td8_1 == null ? 0 : this.td8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ud8_1 == null ? 0 : this.ud8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.vd8_1 == null ? 0 : this.vd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.wd8_1 == null ? 0 : this.wd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.xd8_1 == null ? 0 : this.xd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.yd8_1 == null ? 0 : this.yd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.zd8_1 == null ? 0 : this.zd8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ad9_1 == null ? 0 : this.ad9_1.hashCode()) | 0;
    result = imul(result, 31) + (this.bd9_1 == null ? 0 : this.bd9_1.hashCode()) | 0;
    result = imul(result, 31) + (this.cd9_1 == null ? 0 : this.cd9_1.hashCode()) | 0;
    result = imul(result, 31) + (this.dd9_1 == null ? 0 : this.dd9_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ed9_1 == null ? 0 : this.ed9_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ForcedRefs))
      return false;
    var tmp0_other_with_cast = other instanceof ForcedRefs ? other : THROW_CCE();
    if (!equals(this.hd8_1, tmp0_other_with_cast.hd8_1))
      return false;
    if (!equals(this.id8_1, tmp0_other_with_cast.id8_1))
      return false;
    if (!equals(this.jd8_1, tmp0_other_with_cast.jd8_1))
      return false;
    if (!equals(this.kd8_1, tmp0_other_with_cast.kd8_1))
      return false;
    if (!equals(this.ld8_1, tmp0_other_with_cast.ld8_1))
      return false;
    if (!equals(this.md8_1, tmp0_other_with_cast.md8_1))
      return false;
    if (!equals(this.nd8_1, tmp0_other_with_cast.nd8_1))
      return false;
    if (!equals(this.od8_1, tmp0_other_with_cast.od8_1))
      return false;
    if (!equals(this.pd8_1, tmp0_other_with_cast.pd8_1))
      return false;
    if (!equals(this.qd8_1, tmp0_other_with_cast.qd8_1))
      return false;
    if (!equals(this.rd8_1, tmp0_other_with_cast.rd8_1))
      return false;
    if (!equals(this.sd8_1, tmp0_other_with_cast.sd8_1))
      return false;
    if (!equals(this.td8_1, tmp0_other_with_cast.td8_1))
      return false;
    if (!equals(this.ud8_1, tmp0_other_with_cast.ud8_1))
      return false;
    if (!equals(this.vd8_1, tmp0_other_with_cast.vd8_1))
      return false;
    if (!equals(this.wd8_1, tmp0_other_with_cast.wd8_1))
      return false;
    if (!equals(this.xd8_1, tmp0_other_with_cast.xd8_1))
      return false;
    if (!equals(this.yd8_1, tmp0_other_with_cast.yd8_1))
      return false;
    if (!equals(this.zd8_1, tmp0_other_with_cast.zd8_1))
      return false;
    if (!equals(this.ad9_1, tmp0_other_with_cast.ad9_1))
      return false;
    if (!equals(this.bd9_1, tmp0_other_with_cast.bd9_1))
      return false;
    if (!equals(this.cd9_1, tmp0_other_with_cast.cd9_1))
      return false;
    if (!equals(this.dd9_1, tmp0_other_with_cast.dd9_1))
      return false;
    if (!equals(this.ed9_1, tmp0_other_with_cast.ed9_1))
      return false;
    return true;
  }
  static fd9(seen0, autoLayerRuleGroup, autoRuleDef, definitions, entityDef, entityInstance, entityReferenceInfos, enumDef, enumDefValues, enumTagValue, fieldDef, fieldInstance, gridPoint, intGridValueDef, intGridValueInstance, layerDef, layerInstance, level, levelBgPosInfos, neighbourLevel, tile, tileCustomMetadata, tilesetDef, tilesetRect, world, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_18().fd8_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.hd8_1 = null;
    else
      $this.hd8_1 = autoLayerRuleGroup;
    if (0 === (seen0 & 2))
      $this.id8_1 = null;
    else
      $this.id8_1 = autoRuleDef;
    if (0 === (seen0 & 4))
      $this.jd8_1 = null;
    else
      $this.jd8_1 = definitions;
    if (0 === (seen0 & 8))
      $this.kd8_1 = null;
    else
      $this.kd8_1 = entityDef;
    if (0 === (seen0 & 16))
      $this.ld8_1 = null;
    else
      $this.ld8_1 = entityInstance;
    if (0 === (seen0 & 32))
      $this.md8_1 = null;
    else
      $this.md8_1 = entityReferenceInfos;
    if (0 === (seen0 & 64))
      $this.nd8_1 = null;
    else
      $this.nd8_1 = enumDef;
    if (0 === (seen0 & 128))
      $this.od8_1 = null;
    else
      $this.od8_1 = enumDefValues;
    if (0 === (seen0 & 256))
      $this.pd8_1 = null;
    else
      $this.pd8_1 = enumTagValue;
    if (0 === (seen0 & 512))
      $this.qd8_1 = null;
    else
      $this.qd8_1 = fieldDef;
    if (0 === (seen0 & 1024))
      $this.rd8_1 = null;
    else
      $this.rd8_1 = fieldInstance;
    if (0 === (seen0 & 2048))
      $this.sd8_1 = null;
    else
      $this.sd8_1 = gridPoint;
    if (0 === (seen0 & 4096))
      $this.td8_1 = null;
    else
      $this.td8_1 = intGridValueDef;
    if (0 === (seen0 & 8192))
      $this.ud8_1 = null;
    else
      $this.ud8_1 = intGridValueInstance;
    if (0 === (seen0 & 16384))
      $this.vd8_1 = null;
    else
      $this.vd8_1 = layerDef;
    if (0 === (seen0 & 32768))
      $this.wd8_1 = null;
    else
      $this.wd8_1 = layerInstance;
    if (0 === (seen0 & 65536))
      $this.xd8_1 = null;
    else
      $this.xd8_1 = level;
    if (0 === (seen0 & 131072))
      $this.yd8_1 = null;
    else
      $this.yd8_1 = levelBgPosInfos;
    if (0 === (seen0 & 262144))
      $this.zd8_1 = null;
    else
      $this.zd8_1 = neighbourLevel;
    if (0 === (seen0 & 524288))
      $this.ad9_1 = null;
    else
      $this.ad9_1 = tile;
    if (0 === (seen0 & 1048576))
      $this.bd9_1 = null;
    else
      $this.bd9_1 = tileCustomMetadata;
    if (0 === (seen0 & 2097152))
      $this.cd9_1 = null;
    else
      $this.cd9_1 = tilesetDef;
    if (0 === (seen0 & 4194304))
      $this.dd9_1 = null;
    else
      $this.dd9_1 = tilesetRect;
    if (0 === (seen0 & 8388608))
      $this.ed9_1 = null;
    else
      $this.ed9_1 = world;
    return $this;
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ld4_1 = lazy(tmp_0, Flag$Companion$_anonymous__vfldct);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.Flag', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'DiscardPreCsvIntGrid':
        tmp = Flag_DiscardPreCSVIntGrid_getInstance();
        break;
      case 'ExportPreCsvIntGridFormat':
        tmp = Flag_ExportPreCSVIntGridFormat_getInstance();
        break;
      case 'IgnoreBackupSuggest':
        tmp = Flag_IgnoreBackupSuggest_getInstance();
        break;
      case 'MultiWorlds':
        tmp = Flag_MultiWorlds_getInstance();
        break;
      case 'PrependIndexToLevelFileNames':
        tmp = Flag_PrependIndexToLevelFileNames_getInstance();
        break;
      case 'UseMultilinesType':
        tmp = Flag_UseMultilinesType_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('Flag could not parse: ' + value);
    }
    return tmp;
  }
  gd9(encoder, value) {
    return encoder.c10(value.jd9_1);
  }
  zu(encoder, value) {
    return this.gd9(encoder, value instanceof Flag ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_11(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class Flag extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.jd9_1 = value;
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_32 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.md4_1 = lazy(tmp_0, IdentifierStyle$Companion$_anonymous__e7aoxl);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.IdentifierStyle', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'Capitalize':
        tmp = IdentifierStyle_Capitalize_getInstance();
        break;
      case 'Free':
        tmp = IdentifierStyle_Free_getInstance();
        break;
      case 'Lowercase':
        tmp = IdentifierStyle_Lowercase_getInstance();
        break;
      case 'Uppercase':
        tmp = IdentifierStyle_Uppercase_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('IdentifierStyle could not parse: ' + value);
    }
    return tmp;
  }
  kd9(encoder, value) {
    return encoder.c10(value.nd9_1);
  }
  zu(encoder, value) {
    return this.kd9(encoder, value instanceof IdentifierStyle ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_12(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class IdentifierStyle extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.nd9_1 = value;
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_33 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.nd4_1 = lazy(tmp_0, ImageExportMode$Companion$_anonymous__oljsbh);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.ImageExportMode', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'LayersAndLevels':
        tmp = ImageExportMode_LayersAndLevels_getInstance();
        break;
      case 'None':
        tmp = ImageExportMode_None_getInstance();
        break;
      case 'OneImagePerLayer':
        tmp = ImageExportMode_OneImagePerLayer_getInstance();
        break;
      case 'OneImagePerLevel':
        tmp = ImageExportMode_OneImagePerLevel_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('ImageExportMode could not parse: ' + value);
    }
    return tmp;
  }
  od9(encoder, value) {
    return encoder.c10(value.rd9_1);
  }
  zu(encoder, value) {
    return this.od9(encoder, value instanceof ImageExportMode ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_13(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class ImageExportMode extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.rd9_1 = value;
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_34 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.od4_1 = lazy(tmp_0, WorldLayout$Companion$_anonymous__u3nwqb);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.WorldLayout', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'Free':
        tmp = WorldLayout_Free_getInstance();
        break;
      case 'GridVania':
        tmp = WorldLayout_GridVania_getInstance();
        break;
      case 'LinearHorizontal':
        tmp = WorldLayout_LinearHorizontal_getInstance();
        break;
      case 'LinearVertical':
        tmp = WorldLayout_LinearVertical_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('WorldLayout could not parse: ' + value);
    }
    return tmp;
  }
  sd9(encoder, value) {
    return encoder.c10(value.vd9_1);
  }
  zu(encoder, value) {
    return this.sd9(encoder, value instanceof WorldLayout ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_14(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class WorldLayout extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.vd9_1 = value;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_35 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.wd9_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_15()), null, null, Companion_getInstance_35().q1j()];
  }
}
class $serializer_19 {
  constructor() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.World', this, 8);
    tmp0_serialDesc.m16('defaultLevelHeight', false);
    tmp0_serialDesc.m16('defaultLevelWidth', false);
    tmp0_serialDesc.m16('identifier', false);
    tmp0_serialDesc.m16('iid', false);
    tmp0_serialDesc.m16('levels', false);
    tmp0_serialDesc.m16('worldGridHeight', false);
    tmp0_serialDesc.m16('worldGridWidth', false);
    tmp0_serialDesc.m16('worldLayout', true);
    this.xd9_1 = tmp0_serialDesc;
  }
  yd9(encoder, value) {
    var tmp0_desc = this.xd9_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_36().wd9_1;
    tmp1_output.i10(tmp0_desc, 0, value.zd9_1);
    tmp1_output.i10(tmp0_desc, 1, value.ada_1);
    tmp1_output.n10(tmp0_desc, 2, value.bda_1);
    tmp1_output.n10(tmp0_desc, 3, value.cda_1);
    tmp1_output.p10(tmp0_desc, 4, tmp2_cached[4], value.dda_1);
    tmp1_output.i10(tmp0_desc, 5, value.eda_1);
    tmp1_output.i10(tmp0_desc, 6, value.fda_1);
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.gda_1 == null)) {
      tmp1_output.r10(tmp0_desc, 7, tmp2_cached[7], value.gda_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.yd9(encoder, value instanceof World ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.xd9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_input = decoder.xy(tmp0_desc);
    var tmp13_cached = Companion_getInstance_36().wd9_1;
    if (tmp12_input.nz()) {
      tmp4_local0 = tmp12_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.hz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.hz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.cz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.cz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.hz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.hz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.cz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.cz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp12_input.yy(tmp0_desc);
    return World.hda(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  }
  yu() {
    return this.xd9_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_36().wd9_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4], IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(tmp0_cached[7])];
  }
}
class World {
  toString() {
    return 'World(defaultLevelHeight=' + this.zd9_1 + ', defaultLevelWidth=' + this.ada_1 + ', identifier=' + this.bda_1 + ', iid=' + this.cda_1 + ', levels=' + toString_0(this.dda_1) + ', worldGridHeight=' + this.eda_1 + ', worldGridWidth=' + this.fda_1 + ', worldLayout=' + toString(this.gda_1) + ')';
  }
  hashCode() {
    var result = this.zd9_1;
    result = imul(result, 31) + this.ada_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.bda_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cda_1) | 0;
    result = imul(result, 31) + hashCode(this.dda_1) | 0;
    result = imul(result, 31) + this.eda_1 | 0;
    result = imul(result, 31) + this.fda_1 | 0;
    result = imul(result, 31) + (this.gda_1 == null ? 0 : this.gda_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof World))
      return false;
    var tmp0_other_with_cast = other instanceof World ? other : THROW_CCE();
    if (!(this.zd9_1 === tmp0_other_with_cast.zd9_1))
      return false;
    if (!(this.ada_1 === tmp0_other_with_cast.ada_1))
      return false;
    if (!(this.bda_1 === tmp0_other_with_cast.bda_1))
      return false;
    if (!(this.cda_1 === tmp0_other_with_cast.cda_1))
      return false;
    if (!equals(this.dda_1, tmp0_other_with_cast.dda_1))
      return false;
    if (!(this.eda_1 === tmp0_other_with_cast.eda_1))
      return false;
    if (!(this.fda_1 === tmp0_other_with_cast.fda_1))
      return false;
    if (!equals(this.gda_1, tmp0_other_with_cast.gda_1))
      return false;
    return true;
  }
  static hda(seen0, defaultLevelHeight, defaultLevelWidth, identifier, iid, levels, worldGridHeight, worldGridWidth, worldLayout, serializationConstructorMarker) {
    Companion_getInstance_36();
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_19().xd9_1);
    }
    var $this = createThis(this);
    $this.zd9_1 = defaultLevelHeight;
    $this.ada_1 = defaultLevelWidth;
    $this.bda_1 = identifier;
    $this.cda_1 = iid;
    $this.dda_1 = levels;
    $this.eda_1 = worldGridHeight;
    $this.fda_1 = worldGridWidth;
    if (0 === (seen0 & 128))
      $this.gda_1 = null;
    else
      $this.gda_1 = worldLayout;
    return $this;
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_36 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ida_1 = [new ArrayListSerializer(DoubleSerializer_getInstance()), new ArrayListSerializer(DoubleSerializer_getInstance()), null];
  }
}
class $serializer_20 {
  constructor() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.LevelBackgroundPosition', this, 3);
    tmp0_serialDesc.m16('cropRect', false);
    tmp0_serialDesc.m16('scale', false);
    tmp0_serialDesc.m16('topLeftPx', false);
    this.jda_1 = tmp0_serialDesc;
  }
  kda(encoder, value) {
    var tmp0_desc = this.jda_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_37().ida_1;
    tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.lda_1);
    tmp1_output.p10(tmp0_desc, 1, tmp2_cached[1], value.mda_1);
    tmp1_output.p10(tmp0_desc, 2, IntArraySerializer_getInstance(), value.nda_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.kda(encoder, value instanceof LevelBackgroundPosition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.jda_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.xy(tmp0_desc);
    var tmp8_cached = Companion_getInstance_37().ida_1;
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.jz(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.jz(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.jz(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.jz(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.jz(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.jz(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return LevelBackgroundPosition.oda(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.jda_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_37().ida_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], IntArraySerializer_getInstance()];
  }
}
class LevelBackgroundPosition {
  toString() {
    return 'LevelBackgroundPosition(cropRect=' + toString_0(this.lda_1) + ', scale=' + toString_0(this.mda_1) + ', topLeftPx=' + toString_0(this.nda_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.lda_1);
    result = imul(result, 31) + hashCode(this.mda_1) | 0;
    result = imul(result, 31) + hashCode(this.nda_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LevelBackgroundPosition))
      return false;
    var tmp0_other_with_cast = other instanceof LevelBackgroundPosition ? other : THROW_CCE();
    if (!equals(this.lda_1, tmp0_other_with_cast.lda_1))
      return false;
    if (!equals(this.mda_1, tmp0_other_with_cast.mda_1))
      return false;
    if (!equals(this.nda_1, tmp0_other_with_cast.nda_1))
      return false;
    return true;
  }
  static oda(seen0, cropRect, scale, topLeftPx, serializationConstructorMarker) {
    Companion_getInstance_37();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_20().jda_1);
    }
    var $this = createThis(this);
    $this.lda_1 = cropRect;
    $this.mda_1 = scale;
    $this.nda_1 = topLeftPx;
    return $this;
  }
}
class Companion_37 {}
class $serializer_21 {
  constructor() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.NeighbourLevel', this, 2);
    tmp0_serialDesc.m16('dir', false);
    tmp0_serialDesc.m16('levelIid', false);
    this.pda_1 = tmp0_serialDesc;
  }
  qda(encoder, value) {
    var tmp0_desc = this.pda_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.rda_1);
    tmp1_output.n10(tmp0_desc, 1, value.sda_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.qda(encoder, value instanceof NeighbourLevel ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.pda_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return NeighbourLevel.tda(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.pda_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class NeighbourLevel {
  toString() {
    return 'NeighbourLevel(dir=' + this.rda_1 + ', levelIid=' + this.sda_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.rda_1);
    result = imul(result, 31) + getStringHashCode(this.sda_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NeighbourLevel))
      return false;
    var tmp0_other_with_cast = other instanceof NeighbourLevel ? other : THROW_CCE();
    if (!(this.rda_1 === tmp0_other_with_cast.rda_1))
      return false;
    if (!(this.sda_1 === tmp0_other_with_cast.sda_1))
      return false;
    return true;
  }
  static tda(seen0, dir, levelIid, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_21().pda_1);
    }
    var $this = createThis(this);
    $this.rda_1 = dir;
    $this.sda_1 = levelIid;
    return $this;
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_38 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.wd5_1 = lazy(tmp_0, BgPos$Companion$_anonymous__iejcu8);
  }
  yu() {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.BgPos', STRING_getInstance());
  }
  av(decoder) {
    var value = decoder.sy();
    var tmp;
    switch (value) {
      case 'Contain':
        tmp = BgPos_Contain_getInstance();
        break;
      case 'Cover':
        tmp = BgPos_Cover_getInstance();
        break;
      case 'CoverDirty':
        tmp = BgPos_CoverDirty_getInstance();
        break;
      case 'Unscaled':
        tmp = BgPos_Unscaled_getInstance();
        break;
      default:
        throw IllegalArgumentException.l('BgPos could not parse: ' + value);
    }
    return tmp;
  }
  uda(encoder, value) {
    return encoder.c10(value.xda_1);
  }
  zu(encoder, value) {
    return this.uda(encoder, value instanceof BgPos ? value : THROW_CCE());
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_15(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class BgPos extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.xda_1 = value;
  }
}
class Companion_39 {}
class $serializer_22 {
  constructor() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.FieldInstanceEntityReference', this, 4);
    tmp0_serialDesc.m16('entityIid', false);
    tmp0_serialDesc.m16('layerIid', false);
    tmp0_serialDesc.m16('levelIid', false);
    tmp0_serialDesc.m16('worldIid', false);
    this.yda_1 = tmp0_serialDesc;
  }
  zda(encoder, value) {
    var tmp0_desc = this.yda_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.adb_1);
    tmp1_output.n10(tmp0_desc, 1, value.bdb_1);
    tmp1_output.n10(tmp0_desc, 2, value.cdb_1);
    tmp1_output.n10(tmp0_desc, 3, value.ddb_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.zda(encoder, value instanceof FieldInstanceEntityReference ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.yda_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.xy(tmp0_desc);
    if (tmp8_input.nz()) {
      tmp4_local0 = tmp8_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.hz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.hz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.hz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.hz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp8_input.yy(tmp0_desc);
    return FieldInstanceEntityReference.edb(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  yu() {
    return this.yda_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class FieldInstanceEntityReference {
  toString() {
    return 'FieldInstanceEntityReference(entityIid=' + this.adb_1 + ', layerIid=' + this.bdb_1 + ', levelIid=' + this.cdb_1 + ', worldIid=' + this.ddb_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.adb_1);
    result = imul(result, 31) + getStringHashCode(this.bdb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cdb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ddb_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldInstanceEntityReference))
      return false;
    var tmp0_other_with_cast = other instanceof FieldInstanceEntityReference ? other : THROW_CCE();
    if (!(this.adb_1 === tmp0_other_with_cast.adb_1))
      return false;
    if (!(this.bdb_1 === tmp0_other_with_cast.bdb_1))
      return false;
    if (!(this.cdb_1 === tmp0_other_with_cast.cdb_1))
      return false;
    if (!(this.ddb_1 === tmp0_other_with_cast.ddb_1))
      return false;
    return true;
  }
  static edb(seen0, entityIid, layerIid, levelIid, worldIid, serializationConstructorMarker) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_22().yda_1);
    }
    var $this = createThis(this);
    $this.adb_1 = entityIid;
    $this.bdb_1 = layerIid;
    $this.cdb_1 = levelIid;
    $this.ddb_1 = worldIid;
    return $this;
  }
}
class Companion_40 {}
class $serializer_23 {
  constructor() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.FieldInstanceGridPoint', this, 2);
    tmp0_serialDesc.m16('cx', false);
    tmp0_serialDesc.m16('cy', false);
    this.fdb_1 = tmp0_serialDesc;
  }
  gdb(encoder, value) {
    var tmp0_desc = this.fdb_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.i10(tmp0_desc, 0, value.hdb_1);
    tmp1_output.i10(tmp0_desc, 1, value.idb_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.gdb(encoder, value instanceof FieldInstanceGridPoint ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.fdb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return FieldInstanceGridPoint.jdb(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.fdb_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class FieldInstanceGridPoint {
  toString() {
    return 'FieldInstanceGridPoint(cx=' + this.hdb_1 + ', cy=' + this.idb_1 + ')';
  }
  hashCode() {
    var result = this.hdb_1;
    result = imul(result, 31) + this.idb_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldInstanceGridPoint))
      return false;
    var tmp0_other_with_cast = other instanceof FieldInstanceGridPoint ? other : THROW_CCE();
    if (!(this.hdb_1 === tmp0_other_with_cast.hdb_1))
      return false;
    if (!(this.idb_1 === tmp0_other_with_cast.idb_1))
      return false;
    return true;
  }
  static jdb(seen0, cx, cy, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_23().fdb_1);
    }
    var $this = createThis(this);
    $this.hdb_1 = cx;
    $this.idb_1 = cy;
    return $this;
  }
}
class Companion_41 {}
class $serializer_24 {
  constructor() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.IntGridValueInstance', this, 2);
    tmp0_serialDesc.m16('coordId', false);
    tmp0_serialDesc.m16('v', false);
    this.kdb_1 = tmp0_serialDesc;
  }
  ldb(encoder, value) {
    var tmp0_desc = this.kdb_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.i10(tmp0_desc, 0, value.mdb_1);
    tmp1_output.i10(tmp0_desc, 1, value.ndb_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.ldb(encoder, value instanceof IntGridValueInstance ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.kdb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return IntGridValueInstance.odb(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.kdb_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class IntGridValueInstance {
  toString() {
    return 'IntGridValueInstance(coordID=' + this.mdb_1 + ', v=' + this.ndb_1 + ')';
  }
  hashCode() {
    var result = this.mdb_1;
    result = imul(result, 31) + this.ndb_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IntGridValueInstance))
      return false;
    var tmp0_other_with_cast = other instanceof IntGridValueInstance ? other : THROW_CCE();
    if (!(this.mdb_1 === tmp0_other_with_cast.mdb_1))
      return false;
    if (!(this.ndb_1 === tmp0_other_with_cast.ndb_1))
      return false;
    return true;
  }
  static odb(seen0, coordID, v, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_24().kdb_1);
    }
    var $this = createThis(this);
    $this.mdb_1 = coordID;
    $this.ndb_1 = v;
    return $this;
  }
}
class LDTKWorld {
  constructor(ldtk, tilesetDefsById, tilesetIsExtruded) {
    this.pdb_1 = ldtk;
    this.qdb_1 = tilesetDefsById;
    this.rdb_1 = tilesetIsExtruded;
    var tmp = this;
    tmp.sdb_1 = lazy_0(LDTKWorld$levels$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.tdb_1 = lazy_0(LDTKWorld$levelsByName$delegate$lambda(this));
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.pdb_1.dd5_1.kcx_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.ldtk.view.LDTKWorld.layersDefsById.<anonymous>' call
      var tmp$ret$0 = element.od0_1;
      destination.k3(tmp$ret$0, element);
    }
    tmp_1.udb_1 = destination;
    this.vdb_1 = Bitmap32.k56(imul(this.pdb_1.xd4_1 + 4 | 0, 16), this.pdb_1.xd4_1);
    var tmp_2 = this;
    var tmp_3 = Companion_getInstance();
    // Inline function 'kotlin.collections.map' call
    var this_1 = until(0, 16);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var inductionVariable = this_1.f2_1;
    var last = this_1.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.ldtk.view.LDTKWorld.intsTileSet.<anonymous>' call
        var it = item;
        var tmp$ret$3 = new TileSetTileInfo(it, slice(this.vdb_1, RectangleInt.j3r(imul(this.pdb_1.xd4_1 + 4 | 0, it), 0, this.pdb_1.xd4_1, this.pdb_1.xd4_1)));
        destination_0.h(tmp$ret$3);
      }
       while (!(item === last));
    tmp_2.wdb_1 = tmp_3.e6z(destination_0);
    var _iterator__ex2g4s = this.pdb_1.dd5_1.kcx_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var layer = _iterator__ex2g4s.d1();
      var _iterator__ex2g4s_0 = layer.dd0_1.b1();
      while (_iterator__ex2g4s_0.c1()) {
        var value = _iterator__ex2g4s_0.d1();
        this.vdb_1.r5g(Colors_getInstance().m5p(value.fd2_1), imul(this.pdb_1.xd4_1 + 4 | 0, value.hd2_1));
      }
    }
  }
  xdb() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.sdb_1;
    levels$factory();
    return this_0.w1();
  }
}
class ExtTileset {
  constructor(def, tileset, unextrudedTileSet) {
    this.cdc_1 = def;
    this.ddc_1 = tileset;
    this.edc_1 = unextrudedTileSet;
  }
}
class LDTKLevel {
  constructor(world, level) {
    this.ydb_1 = world;
    this.zdb_1 = level;
    var tmp = this;
    tmp.adc_1 = lazy_0(LDTKLevel$layers$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.bdc_1 = lazy_0(LDTKLevel$layersByName$delegate$lambda(this));
  }
  ocm() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.adc_1;
    layers$factory();
    return this_0.w1();
  }
}
class LDTKLayer {
  constructor(level, layer) {
    this.fdc_1 = level;
    this.gdc_1 = layer;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new $serializer();
  return $serializer_instance;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new $serializer_0();
  return $serializer_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new $serializer_1();
  return $serializer_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new $serializer_2();
  return $serializer_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new $serializer_3();
  return $serializer_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_5() {
  return Companion_instance_4;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new $serializer_4();
  return $serializer_instance_4;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.mcu_1.w1();
}
function AllowedRefs$Companion$_anonymous__v2lmwp() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.AllowedRefs', values());
}
var AllowedRefs_Any_instance;
var AllowedRefs_OnlySame_instance;
var AllowedRefs_OnlyTags_instance;
var Companion_instance_5;
function Companion_getInstance_6() {
  AllowedRefs_initEntries();
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
function values() {
  return [AllowedRefs_Any_getInstance(), AllowedRefs_OnlySame_getInstance(), AllowedRefs_OnlyTags_getInstance()];
}
var AllowedRefs_entriesInitialized;
function AllowedRefs_initEntries() {
  if (AllowedRefs_entriesInitialized)
    return Unit_instance;
  AllowedRefs_entriesInitialized = true;
  AllowedRefs_Any_instance = new AllowedRefs('Any', 0, 'Any');
  AllowedRefs_OnlySame_instance = new AllowedRefs('OnlySame', 1, 'OnlySame');
  AllowedRefs_OnlyTags_instance = new AllowedRefs('OnlyTags', 2, 'OnlyTags');
  Companion_getInstance_6();
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.ncu_1.w1();
}
function EditorDisplayMode$Companion$_anonymous__77qsc7() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.EditorDisplayMode', values_0());
}
var EditorDisplayMode_ArrayCountNoLabel_instance;
var EditorDisplayMode_ArrayCountWithLabel_instance;
var EditorDisplayMode_EntityTile_instance;
var EditorDisplayMode_Hidden_instance;
var EditorDisplayMode_NameAndValue_instance;
var EditorDisplayMode_PointPath_instance;
var EditorDisplayMode_PointPathLoop_instance;
var EditorDisplayMode_PointStar_instance;
var EditorDisplayMode_Points_instance;
var EditorDisplayMode_RadiusGrid_instance;
var EditorDisplayMode_RadiusPx_instance;
var EditorDisplayMode_RefLinkBetweenCenters_instance;
var EditorDisplayMode_RefLinkBetweenPivots_instance;
var EditorDisplayMode_ValueOnly_instance;
var Companion_instance_6;
function Companion_getInstance_7() {
  EditorDisplayMode_initEntries();
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
function values_0() {
  return [EditorDisplayMode_ArrayCountNoLabel_getInstance(), EditorDisplayMode_ArrayCountWithLabel_getInstance(), EditorDisplayMode_EntityTile_getInstance(), EditorDisplayMode_Hidden_getInstance(), EditorDisplayMode_NameAndValue_getInstance(), EditorDisplayMode_PointPath_getInstance(), EditorDisplayMode_PointPathLoop_getInstance(), EditorDisplayMode_PointStar_getInstance(), EditorDisplayMode_Points_getInstance(), EditorDisplayMode_RadiusGrid_getInstance(), EditorDisplayMode_RadiusPx_getInstance(), EditorDisplayMode_RefLinkBetweenCenters_getInstance(), EditorDisplayMode_RefLinkBetweenPivots_getInstance(), EditorDisplayMode_ValueOnly_getInstance()];
}
var EditorDisplayMode_entriesInitialized;
function EditorDisplayMode_initEntries() {
  if (EditorDisplayMode_entriesInitialized)
    return Unit_instance;
  EditorDisplayMode_entriesInitialized = true;
  EditorDisplayMode_ArrayCountNoLabel_instance = new EditorDisplayMode('ArrayCountNoLabel', 0, 'ArrayCountNoLabel');
  EditorDisplayMode_ArrayCountWithLabel_instance = new EditorDisplayMode('ArrayCountWithLabel', 1, 'ArrayCountWithLabel');
  EditorDisplayMode_EntityTile_instance = new EditorDisplayMode('EntityTile', 2, 'EntityTile');
  EditorDisplayMode_Hidden_instance = new EditorDisplayMode('Hidden', 3, 'Hidden');
  EditorDisplayMode_NameAndValue_instance = new EditorDisplayMode('NameAndValue', 4, 'NameAndValue');
  EditorDisplayMode_PointPath_instance = new EditorDisplayMode('PointPath', 5, 'PointPath');
  EditorDisplayMode_PointPathLoop_instance = new EditorDisplayMode('PointPathLoop', 6, 'PointPathLoop');
  EditorDisplayMode_PointStar_instance = new EditorDisplayMode('PointStar', 7, 'PointStar');
  EditorDisplayMode_Points_instance = new EditorDisplayMode('Points', 8, 'Points');
  EditorDisplayMode_RadiusGrid_instance = new EditorDisplayMode('RadiusGrid', 9, 'RadiusGrid');
  EditorDisplayMode_RadiusPx_instance = new EditorDisplayMode('RadiusPx', 10, 'RadiusPx');
  EditorDisplayMode_RefLinkBetweenCenters_instance = new EditorDisplayMode('RefLinkBetweenCenters', 11, 'RefLinkBetweenCenters');
  EditorDisplayMode_RefLinkBetweenPivots_instance = new EditorDisplayMode('RefLinkBetweenPivots', 12, 'RefLinkBetweenPivots');
  EditorDisplayMode_ValueOnly_instance = new EditorDisplayMode('ValueOnly', 13, 'ValueOnly');
  Companion_getInstance_7();
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.ocu_1.w1();
}
function EditorDisplayPos$Companion$_anonymous__f71kr4() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.EditorDisplayPos', values_1());
}
var EditorDisplayPos_Above_instance;
var EditorDisplayPos_Beneath_instance;
var EditorDisplayPos_Center_instance;
var Companion_instance_7;
function Companion_getInstance_8() {
  EditorDisplayPos_initEntries();
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
function values_1() {
  return [EditorDisplayPos_Above_getInstance(), EditorDisplayPos_Beneath_getInstance(), EditorDisplayPos_Center_getInstance()];
}
var EditorDisplayPos_entriesInitialized;
function EditorDisplayPos_initEntries() {
  if (EditorDisplayPos_entriesInitialized)
    return Unit_instance;
  EditorDisplayPos_entriesInitialized = true;
  EditorDisplayPos_Above_instance = new EditorDisplayPos('Above', 0, 'Above');
  EditorDisplayPos_Beneath_instance = new EditorDisplayPos('Beneath', 1, 'Beneath');
  EditorDisplayPos_Center_instance = new EditorDisplayPos('Center', 2, 'Center');
  Companion_getInstance_8();
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.pcu_1.w1();
}
function TextLanguageMode$Companion$_anonymous__u336u1() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.TextLanguageMode', values_2());
}
var TextLanguageMode_LangC_instance;
var TextLanguageMode_LangHaxe_instance;
var TextLanguageMode_LangJS_instance;
var TextLanguageMode_LangJSON_instance;
var TextLanguageMode_LangLog_instance;
var TextLanguageMode_LangLua_instance;
var TextLanguageMode_LangMarkdown_instance;
var TextLanguageMode_LangPython_instance;
var TextLanguageMode_LangRuby_instance;
var TextLanguageMode_LangXML_instance;
var Companion_instance_8;
function Companion_getInstance_9() {
  TextLanguageMode_initEntries();
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function values_2() {
  return [TextLanguageMode_LangC_getInstance(), TextLanguageMode_LangHaxe_getInstance(), TextLanguageMode_LangJS_getInstance(), TextLanguageMode_LangJSON_getInstance(), TextLanguageMode_LangLog_getInstance(), TextLanguageMode_LangLua_getInstance(), TextLanguageMode_LangMarkdown_getInstance(), TextLanguageMode_LangPython_getInstance(), TextLanguageMode_LangRuby_getInstance(), TextLanguageMode_LangXML_getInstance()];
}
var TextLanguageMode_entriesInitialized;
function TextLanguageMode_initEntries() {
  if (TextLanguageMode_entriesInitialized)
    return Unit_instance;
  TextLanguageMode_entriesInitialized = true;
  TextLanguageMode_LangC_instance = new TextLanguageMode('LangC', 0, 'LangC');
  TextLanguageMode_LangHaxe_instance = new TextLanguageMode('LangHaxe', 1, 'LangHaxe');
  TextLanguageMode_LangJS_instance = new TextLanguageMode('LangJS', 2, 'LangJS');
  TextLanguageMode_LangJSON_instance = new TextLanguageMode('LangJSON', 3, 'LangJson');
  TextLanguageMode_LangLog_instance = new TextLanguageMode('LangLog', 4, 'LangLog');
  TextLanguageMode_LangLua_instance = new TextLanguageMode('LangLua', 5, 'LangLua');
  TextLanguageMode_LangMarkdown_instance = new TextLanguageMode('LangMarkdown', 6, 'LangMarkdown');
  TextLanguageMode_LangPython_instance = new TextLanguageMode('LangPython', 7, 'LangPython');
  TextLanguageMode_LangRuby_instance = new TextLanguageMode('LangRuby', 8, 'LangRuby');
  TextLanguageMode_LangXML_instance = new TextLanguageMode('LangXML', 9, 'LangXml');
  Companion_getInstance_9();
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.vcv_1.w1();
}
function LimitBehavior$Companion$_anonymous__hsp10i() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.LimitBehavior', values_3());
}
var LimitBehavior_DiscardOldOnes_instance;
var LimitBehavior_MoveLastOne_instance;
var LimitBehavior_PreventAdding_instance;
var Companion_instance_9;
function Companion_getInstance_10() {
  LimitBehavior_initEntries();
  if (Companion_instance_9 === VOID)
    new Companion_9();
  return Companion_instance_9;
}
function values_3() {
  return [LimitBehavior_DiscardOldOnes_getInstance(), LimitBehavior_MoveLastOne_getInstance(), LimitBehavior_PreventAdding_getInstance()];
}
var LimitBehavior_entriesInitialized;
function LimitBehavior_initEntries() {
  if (LimitBehavior_entriesInitialized)
    return Unit_instance;
  LimitBehavior_entriesInitialized = true;
  LimitBehavior_DiscardOldOnes_instance = new LimitBehavior('DiscardOldOnes', 0, 'DiscardOldOnes');
  LimitBehavior_MoveLastOne_instance = new LimitBehavior('MoveLastOne', 1, 'MoveLastOne');
  LimitBehavior_PreventAdding_instance = new LimitBehavior('PreventAdding', 2, 'PreventAdding');
  Companion_getInstance_10();
}
function _get_$cachedSerializer__te6jhj_4($this) {
  return $this.wcv_1.w1();
}
function LimitScope$Companion$_anonymous__ndoxsa() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.LimitScope', values_4());
}
var LimitScope_PerLayer_instance;
var LimitScope_PerLevel_instance;
var LimitScope_PerWorld_instance;
var Companion_instance_10;
function Companion_getInstance_11() {
  LimitScope_initEntries();
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
function values_4() {
  return [LimitScope_PerLayer_getInstance(), LimitScope_PerLevel_getInstance(), LimitScope_PerWorld_getInstance()];
}
var LimitScope_entriesInitialized;
function LimitScope_initEntries() {
  if (LimitScope_entriesInitialized)
    return Unit_instance;
  LimitScope_entriesInitialized = true;
  LimitScope_PerLayer_instance = new LimitScope('PerLayer', 0, 'PerLayer');
  LimitScope_PerLevel_instance = new LimitScope('PerLevel', 1, 'PerLevel');
  LimitScope_PerWorld_instance = new LimitScope('PerWorld', 2, 'PerWorld');
  Companion_getInstance_11();
}
function _get_$cachedSerializer__te6jhj_5($this) {
  return $this.xcv_1.w1();
}
function RenderMode$Companion$_anonymous__ho71fu() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.RenderMode', values_5());
}
var RenderMode_Cross_instance;
var RenderMode_Ellipse_instance;
var RenderMode_Rectangle_instance;
var RenderMode_Tile_instance;
var Companion_instance_11;
function Companion_getInstance_12() {
  RenderMode_initEntries();
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
function values_5() {
  return [RenderMode_Cross_getInstance(), RenderMode_Ellipse_getInstance(), RenderMode_Rectangle_getInstance(), RenderMode_Tile_getInstance()];
}
var RenderMode_entriesInitialized;
function RenderMode_initEntries() {
  if (RenderMode_entriesInitialized)
    return Unit_instance;
  RenderMode_entriesInitialized = true;
  RenderMode_Cross_instance = new RenderMode('Cross', 0, 'Cross');
  RenderMode_Ellipse_instance = new RenderMode('Ellipse', 1, 'Ellipse');
  RenderMode_Rectangle_instance = new RenderMode('Rectangle', 2, 'Rectangle');
  RenderMode_Tile_instance = new RenderMode('Tile', 3, 'Tile');
  Companion_getInstance_12();
}
function _get_$cachedSerializer__te6jhj_6($this) {
  return $this.ycv_1.w1();
}
function TileRenderMode$Companion$_anonymous__shhaw() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.TileRenderMode', values_6());
}
var TileRenderMode_Cover_instance;
var TileRenderMode_FitInside_instance;
var TileRenderMode_FullSizeCropped_instance;
var TileRenderMode_FullSizeUncropped_instance;
var TileRenderMode_NineSlice_instance;
var TileRenderMode_Repeat_instance;
var TileRenderMode_Stretch_instance;
var Companion_instance_12;
function Companion_getInstance_13() {
  TileRenderMode_initEntries();
  if (Companion_instance_12 === VOID)
    new Companion_12();
  return Companion_instance_12;
}
function values_6() {
  return [TileRenderMode_Cover_getInstance(), TileRenderMode_FitInside_getInstance(), TileRenderMode_FullSizeCropped_getInstance(), TileRenderMode_FullSizeUncropped_getInstance(), TileRenderMode_NineSlice_getInstance(), TileRenderMode_Repeat_getInstance(), TileRenderMode_Stretch_getInstance()];
}
var TileRenderMode_entriesInitialized;
function TileRenderMode_initEntries() {
  if (TileRenderMode_entriesInitialized)
    return Unit_instance;
  TileRenderMode_entriesInitialized = true;
  TileRenderMode_Cover_instance = new TileRenderMode('Cover', 0, 'Cover');
  TileRenderMode_FitInside_instance = new TileRenderMode('FitInside', 1, 'FitInside');
  TileRenderMode_FullSizeCropped_instance = new TileRenderMode('FullSizeCropped', 2, 'FullSizeCropped');
  TileRenderMode_FullSizeUncropped_instance = new TileRenderMode('FullSizeUncropped', 3, 'FullSizeUncropped');
  TileRenderMode_NineSlice_instance = new TileRenderMode('NineSlice', 4, 'NineSlice');
  TileRenderMode_Repeat_instance = new TileRenderMode('Repeat', 5, 'Repeat');
  TileRenderMode_Stretch_instance = new TileRenderMode('Stretch', 6, 'Stretch');
  Companion_getInstance_13();
}
var Companion_instance_13;
function Companion_getInstance_14() {
  if (Companion_instance_13 === VOID)
    new Companion_13();
  return Companion_instance_13;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new $serializer_5();
  return $serializer_instance_5;
}
var Companion_instance_14;
function Companion_getInstance_15() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 === VOID)
    new $serializer_6();
  return $serializer_instance_6;
}
var Companion_instance_15;
function Companion_getInstance_16() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 === VOID)
    new $serializer_7();
  return $serializer_instance_7;
}
var Companion_instance_16;
function Companion_getInstance_17() {
  return Companion_instance_16;
}
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 === VOID)
    new $serializer_8();
  return $serializer_instance_8;
}
var Companion_instance_17;
function Companion_getInstance_18() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 === VOID)
    new $serializer_9();
  return $serializer_instance_9;
}
var Companion_instance_18;
function Companion_getInstance_19() {
  return Companion_instance_18;
}
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 === VOID)
    new $serializer_10();
  return $serializer_instance_10;
}
function _get_$cachedSerializer__te6jhj_7($this) {
  return $this.ncz_1.w1();
}
function Type$Companion$_anonymous__vg0awb() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.Type', values_7());
}
var Type_AutoLayer_instance;
var Type_Entities_instance;
var Type_IntGrid_instance;
var Type_Tiles_instance;
var Companion_instance_19;
function Companion_getInstance_20() {
  Type_initEntries();
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
function values_7() {
  return [Type_AutoLayer_getInstance(), Type_Entities_getInstance(), Type_IntGrid_getInstance(), Type_Tiles_getInstance()];
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_AutoLayer_instance = new Type('AutoLayer', 0, 'AutoLayer');
  Type_Entities_instance = new Type('Entities', 1, 'Entities');
  Type_IntGrid_instance = new Type('IntGrid', 2, 'IntGrid');
  Type_Tiles_instance = new Type('Tiles', 3, 'Tiles');
  Companion_getInstance_20();
}
var Companion_instance_20;
function Companion_getInstance_21() {
  return Companion_instance_20;
}
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 === VOID)
    new $serializer_11();
  return $serializer_instance_11;
}
function _get_$cachedSerializer__te6jhj_8($this) {
  return $this.qd0_1.w1();
}
function EmbedAtlas$Companion$_anonymous__2y90yr() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.EmbedAtlas', values_8());
}
var EmbedAtlas_LdtkIcons_instance;
var Companion_instance_21;
function Companion_getInstance_22() {
  EmbedAtlas_initEntries();
  if (Companion_instance_21 === VOID)
    new Companion_21();
  return Companion_instance_21;
}
function values_8() {
  return [EmbedAtlas_LdtkIcons_getInstance()];
}
var EmbedAtlas_entriesInitialized;
function EmbedAtlas_initEntries() {
  if (EmbedAtlas_entriesInitialized)
    return Unit_instance;
  EmbedAtlas_entriesInitialized = true;
  EmbedAtlas_LdtkIcons_instance = new EmbedAtlas('LdtkIcons', 0, 'LdtkIcons');
  Companion_getInstance_22();
}
var Companion_instance_22;
function Companion_getInstance_23() {
  return Companion_instance_22;
}
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 === VOID)
    new $serializer_12();
  return $serializer_instance_12;
}
var Companion_instance_23;
function Companion_getInstance_24() {
  if (Companion_instance_23 === VOID)
    new Companion_23();
  return Companion_instance_23;
}
var $serializer_instance_13;
function $serializer_getInstance_13() {
  if ($serializer_instance_13 === VOID)
    new $serializer_13();
  return $serializer_instance_13;
}
function _get_$cachedSerializer__te6jhj_9($this) {
  return $this.bd3_1.w1();
}
function Checker$Companion$_anonymous__y7s1qy() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.Checker', values_9());
}
var Checker_Horizontal_instance;
var Checker_None_instance;
var Checker_Vertical_instance;
var Companion_instance_24;
function Companion_getInstance_25() {
  Checker_initEntries();
  if (Companion_instance_24 === VOID)
    new Companion_24();
  return Companion_instance_24;
}
function values_9() {
  return [Checker_Horizontal_getInstance(), Checker_None_getInstance(), Checker_Vertical_getInstance()];
}
var Checker_entriesInitialized;
function Checker_initEntries() {
  if (Checker_entriesInitialized)
    return Unit_instance;
  Checker_entriesInitialized = true;
  Checker_Horizontal_instance = new Checker('Horizontal', 0, 'Horizontal');
  Checker_None_instance = new Checker('None', 1, 'None');
  Checker_Vertical_instance = new Checker('Vertical', 2, 'Vertical');
  Companion_getInstance_25();
}
function _get_$cachedSerializer__te6jhj_10($this) {
  return $this.cd3_1.w1();
}
function TileMode$Companion$_anonymous__ez765a() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.TileMode', values_10());
}
var TileMode_Single_instance;
var TileMode_Stamp_instance;
var Companion_instance_25;
function Companion_getInstance_26() {
  TileMode_initEntries();
  if (Companion_instance_25 === VOID)
    new Companion_25();
  return Companion_instance_25;
}
function values_10() {
  return [TileMode_Single_getInstance(), TileMode_Stamp_getInstance()];
}
var TileMode_entriesInitialized;
function TileMode_initEntries() {
  if (TileMode_entriesInitialized)
    return Unit_instance;
  TileMode_entriesInitialized = true;
  TileMode_Single_instance = new TileMode('Single', 0, 'Single');
  TileMode_Stamp_instance = new TileMode('Stamp', 1, 'Stamp');
  Companion_getInstance_26();
}
function LDTKJson$Companion$load$lambda($this$Json) {
  $this$Json.y1h_1 = true;
  return Unit_instance;
}
var Companion_instance_26;
function Companion_getInstance_27() {
  if (Companion_instance_26 === VOID)
    new Companion_26();
  return Companion_instance_26;
}
var $serializer_instance_14;
function $serializer_getInstance_14() {
  if ($serializer_instance_14 === VOID)
    new $serializer_14();
  return $serializer_instance_14;
}
var Companion_instance_27;
function Companion_getInstance_28() {
  if (Companion_instance_27 === VOID)
    new Companion_27();
  return Companion_instance_27;
}
var $serializer_instance_15;
function $serializer_getInstance_15() {
  if ($serializer_instance_15 === VOID)
    new $serializer_15();
  return $serializer_instance_15;
}
var Companion_instance_28;
function Companion_getInstance_29() {
  if (Companion_instance_28 === VOID)
    new Companion_28();
  return Companion_instance_28;
}
var $serializer_instance_16;
function $serializer_getInstance_16() {
  if ($serializer_instance_16 === VOID)
    new $serializer_16();
  return $serializer_instance_16;
}
var Companion_instance_29;
function Companion_getInstance_30() {
  return Companion_instance_29;
}
var $serializer_instance_17;
function $serializer_getInstance_17() {
  if ($serializer_instance_17 === VOID)
    new $serializer_17();
  return $serializer_instance_17;
}
var Companion_instance_30;
function Companion_getInstance_31() {
  return Companion_instance_30;
}
var $serializer_instance_18;
function $serializer_getInstance_18() {
  if ($serializer_instance_18 === VOID)
    new $serializer_18();
  return $serializer_instance_18;
}
function _get_$cachedSerializer__te6jhj_11($this) {
  return $this.ld4_1.w1();
}
function Flag$Companion$_anonymous__vfldct() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.Flag', values_11());
}
var Flag_DiscardPreCSVIntGrid_instance;
var Flag_ExportPreCSVIntGridFormat_instance;
var Flag_IgnoreBackupSuggest_instance;
var Flag_MultiWorlds_instance;
var Flag_PrependIndexToLevelFileNames_instance;
var Flag_UseMultilinesType_instance;
var Companion_instance_31;
function Companion_getInstance_32() {
  Flag_initEntries();
  if (Companion_instance_31 === VOID)
    new Companion_31();
  return Companion_instance_31;
}
function values_11() {
  return [Flag_DiscardPreCSVIntGrid_getInstance(), Flag_ExportPreCSVIntGridFormat_getInstance(), Flag_IgnoreBackupSuggest_getInstance(), Flag_MultiWorlds_getInstance(), Flag_PrependIndexToLevelFileNames_getInstance(), Flag_UseMultilinesType_getInstance()];
}
var Flag_entriesInitialized;
function Flag_initEntries() {
  if (Flag_entriesInitialized)
    return Unit_instance;
  Flag_entriesInitialized = true;
  Flag_DiscardPreCSVIntGrid_instance = new Flag('DiscardPreCSVIntGrid', 0, 'DiscardPreCsvIntGrid');
  Flag_ExportPreCSVIntGridFormat_instance = new Flag('ExportPreCSVIntGridFormat', 1, 'ExportPreCsvIntGridFormat');
  Flag_IgnoreBackupSuggest_instance = new Flag('IgnoreBackupSuggest', 2, 'IgnoreBackupSuggest');
  Flag_MultiWorlds_instance = new Flag('MultiWorlds', 3, 'MultiWorlds');
  Flag_PrependIndexToLevelFileNames_instance = new Flag('PrependIndexToLevelFileNames', 4, 'PrependIndexToLevelFileNames');
  Flag_UseMultilinesType_instance = new Flag('UseMultilinesType', 5, 'UseMultilinesType');
  Companion_getInstance_32();
}
function _get_$cachedSerializer__te6jhj_12($this) {
  return $this.md4_1.w1();
}
function IdentifierStyle$Companion$_anonymous__e7aoxl() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.IdentifierStyle', values_12());
}
var IdentifierStyle_Capitalize_instance;
var IdentifierStyle_Free_instance;
var IdentifierStyle_Lowercase_instance;
var IdentifierStyle_Uppercase_instance;
var Companion_instance_32;
function Companion_getInstance_33() {
  IdentifierStyle_initEntries();
  if (Companion_instance_32 === VOID)
    new Companion_32();
  return Companion_instance_32;
}
function values_12() {
  return [IdentifierStyle_Capitalize_getInstance(), IdentifierStyle_Free_getInstance(), IdentifierStyle_Lowercase_getInstance(), IdentifierStyle_Uppercase_getInstance()];
}
var IdentifierStyle_entriesInitialized;
function IdentifierStyle_initEntries() {
  if (IdentifierStyle_entriesInitialized)
    return Unit_instance;
  IdentifierStyle_entriesInitialized = true;
  IdentifierStyle_Capitalize_instance = new IdentifierStyle('Capitalize', 0, 'Capitalize');
  IdentifierStyle_Free_instance = new IdentifierStyle('Free', 1, 'Free');
  IdentifierStyle_Lowercase_instance = new IdentifierStyle('Lowercase', 2, 'Lowercase');
  IdentifierStyle_Uppercase_instance = new IdentifierStyle('Uppercase', 3, 'Uppercase');
  Companion_getInstance_33();
}
function _get_$cachedSerializer__te6jhj_13($this) {
  return $this.nd4_1.w1();
}
function ImageExportMode$Companion$_anonymous__oljsbh() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.ImageExportMode', values_13());
}
var ImageExportMode_LayersAndLevels_instance;
var ImageExportMode_None_instance;
var ImageExportMode_OneImagePerLayer_instance;
var ImageExportMode_OneImagePerLevel_instance;
var Companion_instance_33;
function Companion_getInstance_34() {
  ImageExportMode_initEntries();
  if (Companion_instance_33 === VOID)
    new Companion_33();
  return Companion_instance_33;
}
function values_13() {
  return [ImageExportMode_LayersAndLevels_getInstance(), ImageExportMode_None_getInstance(), ImageExportMode_OneImagePerLayer_getInstance(), ImageExportMode_OneImagePerLevel_getInstance()];
}
var ImageExportMode_entriesInitialized;
function ImageExportMode_initEntries() {
  if (ImageExportMode_entriesInitialized)
    return Unit_instance;
  ImageExportMode_entriesInitialized = true;
  ImageExportMode_LayersAndLevels_instance = new ImageExportMode('LayersAndLevels', 0, 'LayersAndLevels');
  ImageExportMode_None_instance = new ImageExportMode('None', 1, 'None');
  ImageExportMode_OneImagePerLayer_instance = new ImageExportMode('OneImagePerLayer', 2, 'OneImagePerLayer');
  ImageExportMode_OneImagePerLevel_instance = new ImageExportMode('OneImagePerLevel', 3, 'OneImagePerLevel');
  Companion_getInstance_34();
}
function _get_$cachedSerializer__te6jhj_14($this) {
  return $this.od4_1.w1();
}
function WorldLayout$Companion$_anonymous__u3nwqb() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.WorldLayout', values_14());
}
var WorldLayout_Free_instance;
var WorldLayout_GridVania_instance;
var WorldLayout_LinearHorizontal_instance;
var WorldLayout_LinearVertical_instance;
var Companion_instance_34;
function Companion_getInstance_35() {
  WorldLayout_initEntries();
  if (Companion_instance_34 === VOID)
    new Companion_34();
  return Companion_instance_34;
}
function values_14() {
  return [WorldLayout_Free_getInstance(), WorldLayout_GridVania_getInstance(), WorldLayout_LinearHorizontal_getInstance(), WorldLayout_LinearVertical_getInstance()];
}
var WorldLayout_entriesInitialized;
function WorldLayout_initEntries() {
  if (WorldLayout_entriesInitialized)
    return Unit_instance;
  WorldLayout_entriesInitialized = true;
  WorldLayout_Free_instance = new WorldLayout('Free', 0, 'Free');
  WorldLayout_GridVania_instance = new WorldLayout('GridVania', 1, 'GridVania');
  WorldLayout_LinearHorizontal_instance = new WorldLayout('LinearHorizontal', 2, 'LinearHorizontal');
  WorldLayout_LinearVertical_instance = new WorldLayout('LinearVertical', 3, 'LinearVertical');
  Companion_getInstance_35();
}
var Companion_instance_35;
function Companion_getInstance_36() {
  if (Companion_instance_35 === VOID)
    new Companion_35();
  return Companion_instance_35;
}
var $serializer_instance_19;
function $serializer_getInstance_19() {
  if ($serializer_instance_19 === VOID)
    new $serializer_19();
  return $serializer_instance_19;
}
var Companion_instance_36;
function Companion_getInstance_37() {
  if (Companion_instance_36 === VOID)
    new Companion_36();
  return Companion_instance_36;
}
var $serializer_instance_20;
function $serializer_getInstance_20() {
  if ($serializer_instance_20 === VOID)
    new $serializer_20();
  return $serializer_instance_20;
}
var Companion_instance_37;
function Companion_getInstance_38() {
  return Companion_instance_37;
}
var $serializer_instance_21;
function $serializer_getInstance_21() {
  if ($serializer_instance_21 === VOID)
    new $serializer_21();
  return $serializer_instance_21;
}
function _get_$cachedSerializer__te6jhj_15($this) {
  return $this.wd5_1.w1();
}
function BgPos$Companion$_anonymous__iejcu8() {
  return createSimpleEnumSerializer('korlibs.korge.ldtk.BgPos', values_15());
}
var BgPos_Contain_instance;
var BgPos_Cover_instance;
var BgPos_CoverDirty_instance;
var BgPos_Unscaled_instance;
var Companion_instance_38;
function Companion_getInstance_39() {
  BgPos_initEntries();
  if (Companion_instance_38 === VOID)
    new Companion_38();
  return Companion_instance_38;
}
function values_15() {
  return [BgPos_Contain_getInstance(), BgPos_Cover_getInstance(), BgPos_CoverDirty_getInstance(), BgPos_Unscaled_getInstance()];
}
var BgPos_entriesInitialized;
function BgPos_initEntries() {
  if (BgPos_entriesInitialized)
    return Unit_instance;
  BgPos_entriesInitialized = true;
  BgPos_Contain_instance = new BgPos('Contain', 0, 'Contain');
  BgPos_Cover_instance = new BgPos('Cover', 1, 'Cover');
  BgPos_CoverDirty_instance = new BgPos('CoverDirty', 2, 'CoverDirty');
  BgPos_Unscaled_instance = new BgPos('Unscaled', 3, 'Unscaled');
  Companion_getInstance_39();
}
var Companion_instance_39;
function Companion_getInstance_40() {
  return Companion_instance_39;
}
var $serializer_instance_22;
function $serializer_getInstance_22() {
  if ($serializer_instance_22 === VOID)
    new $serializer_22();
  return $serializer_instance_22;
}
var Companion_instance_40;
function Companion_getInstance_41() {
  return Companion_instance_40;
}
var $serializer_instance_23;
function $serializer_getInstance_23() {
  if ($serializer_instance_23 === VOID)
    new $serializer_23();
  return $serializer_instance_23;
}
var Companion_instance_41;
function Companion_getInstance_42() {
  return Companion_instance_41;
}
var $serializer_instance_24;
function $serializer_getInstance_24() {
  if ($serializer_instance_24 === VOID)
    new $serializer_24();
  return $serializer_instance_24;
}
function AllowedRefs_Any_getInstance() {
  AllowedRefs_initEntries();
  return AllowedRefs_Any_instance;
}
function AllowedRefs_OnlySame_getInstance() {
  AllowedRefs_initEntries();
  return AllowedRefs_OnlySame_instance;
}
function AllowedRefs_OnlyTags_getInstance() {
  AllowedRefs_initEntries();
  return AllowedRefs_OnlyTags_instance;
}
function EditorDisplayMode_ArrayCountNoLabel_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_ArrayCountNoLabel_instance;
}
function EditorDisplayMode_ArrayCountWithLabel_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_ArrayCountWithLabel_instance;
}
function EditorDisplayMode_EntityTile_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_EntityTile_instance;
}
function EditorDisplayMode_Hidden_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_Hidden_instance;
}
function EditorDisplayMode_NameAndValue_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_NameAndValue_instance;
}
function EditorDisplayMode_PointPath_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_PointPath_instance;
}
function EditorDisplayMode_PointPathLoop_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_PointPathLoop_instance;
}
function EditorDisplayMode_PointStar_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_PointStar_instance;
}
function EditorDisplayMode_Points_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_Points_instance;
}
function EditorDisplayMode_RadiusGrid_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_RadiusGrid_instance;
}
function EditorDisplayMode_RadiusPx_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_RadiusPx_instance;
}
function EditorDisplayMode_RefLinkBetweenCenters_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_RefLinkBetweenCenters_instance;
}
function EditorDisplayMode_RefLinkBetweenPivots_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_RefLinkBetweenPivots_instance;
}
function EditorDisplayMode_ValueOnly_getInstance() {
  EditorDisplayMode_initEntries();
  return EditorDisplayMode_ValueOnly_instance;
}
function EditorDisplayPos_Above_getInstance() {
  EditorDisplayPos_initEntries();
  return EditorDisplayPos_Above_instance;
}
function EditorDisplayPos_Beneath_getInstance() {
  EditorDisplayPos_initEntries();
  return EditorDisplayPos_Beneath_instance;
}
function EditorDisplayPos_Center_getInstance() {
  EditorDisplayPos_initEntries();
  return EditorDisplayPos_Center_instance;
}
function TextLanguageMode_LangC_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangC_instance;
}
function TextLanguageMode_LangHaxe_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangHaxe_instance;
}
function TextLanguageMode_LangJS_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangJS_instance;
}
function TextLanguageMode_LangJSON_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangJSON_instance;
}
function TextLanguageMode_LangLog_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangLog_instance;
}
function TextLanguageMode_LangLua_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangLua_instance;
}
function TextLanguageMode_LangMarkdown_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangMarkdown_instance;
}
function TextLanguageMode_LangPython_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangPython_instance;
}
function TextLanguageMode_LangRuby_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangRuby_instance;
}
function TextLanguageMode_LangXML_getInstance() {
  TextLanguageMode_initEntries();
  return TextLanguageMode_LangXML_instance;
}
function LimitBehavior_DiscardOldOnes_getInstance() {
  LimitBehavior_initEntries();
  return LimitBehavior_DiscardOldOnes_instance;
}
function LimitBehavior_MoveLastOne_getInstance() {
  LimitBehavior_initEntries();
  return LimitBehavior_MoveLastOne_instance;
}
function LimitBehavior_PreventAdding_getInstance() {
  LimitBehavior_initEntries();
  return LimitBehavior_PreventAdding_instance;
}
function LimitScope_PerLayer_getInstance() {
  LimitScope_initEntries();
  return LimitScope_PerLayer_instance;
}
function LimitScope_PerLevel_getInstance() {
  LimitScope_initEntries();
  return LimitScope_PerLevel_instance;
}
function LimitScope_PerWorld_getInstance() {
  LimitScope_initEntries();
  return LimitScope_PerWorld_instance;
}
function RenderMode_Cross_getInstance() {
  RenderMode_initEntries();
  return RenderMode_Cross_instance;
}
function RenderMode_Ellipse_getInstance() {
  RenderMode_initEntries();
  return RenderMode_Ellipse_instance;
}
function RenderMode_Rectangle_getInstance() {
  RenderMode_initEntries();
  return RenderMode_Rectangle_instance;
}
function RenderMode_Tile_getInstance() {
  RenderMode_initEntries();
  return RenderMode_Tile_instance;
}
function TileRenderMode_Cover_getInstance() {
  TileRenderMode_initEntries();
  return TileRenderMode_Cover_instance;
}
function TileRenderMode_FitInside_getInstance() {
  TileRenderMode_initEntries();
  return TileRenderMode_FitInside_instance;
}
function TileRenderMode_FullSizeCropped_getInstance() {
  TileRenderMode_initEntries();
  return TileRenderMode_FullSizeCropped_instance;
}
function TileRenderMode_FullSizeUncropped_getInstance() {
  TileRenderMode_initEntries();
  return TileRenderMode_FullSizeUncropped_instance;
}
function TileRenderMode_NineSlice_getInstance() {
  TileRenderMode_initEntries();
  return TileRenderMode_NineSlice_instance;
}
function TileRenderMode_Repeat_getInstance() {
  TileRenderMode_initEntries();
  return TileRenderMode_Repeat_instance;
}
function TileRenderMode_Stretch_getInstance() {
  TileRenderMode_initEntries();
  return TileRenderMode_Stretch_instance;
}
function Type_AutoLayer_getInstance() {
  Type_initEntries();
  return Type_AutoLayer_instance;
}
function Type_Entities_getInstance() {
  Type_initEntries();
  return Type_Entities_instance;
}
function Type_IntGrid_getInstance() {
  Type_initEntries();
  return Type_IntGrid_instance;
}
function Type_Tiles_getInstance() {
  Type_initEntries();
  return Type_Tiles_instance;
}
function EmbedAtlas_LdtkIcons_getInstance() {
  EmbedAtlas_initEntries();
  return EmbedAtlas_LdtkIcons_instance;
}
function Checker_Horizontal_getInstance() {
  Checker_initEntries();
  return Checker_Horizontal_instance;
}
function Checker_None_getInstance() {
  Checker_initEntries();
  return Checker_None_instance;
}
function Checker_Vertical_getInstance() {
  Checker_initEntries();
  return Checker_Vertical_instance;
}
function TileMode_Single_getInstance() {
  TileMode_initEntries();
  return TileMode_Single_instance;
}
function TileMode_Stamp_getInstance() {
  TileMode_initEntries();
  return TileMode_Stamp_instance;
}
function Flag_DiscardPreCSVIntGrid_getInstance() {
  Flag_initEntries();
  return Flag_DiscardPreCSVIntGrid_instance;
}
function Flag_ExportPreCSVIntGridFormat_getInstance() {
  Flag_initEntries();
  return Flag_ExportPreCSVIntGridFormat_instance;
}
function Flag_IgnoreBackupSuggest_getInstance() {
  Flag_initEntries();
  return Flag_IgnoreBackupSuggest_instance;
}
function Flag_MultiWorlds_getInstance() {
  Flag_initEntries();
  return Flag_MultiWorlds_instance;
}
function Flag_PrependIndexToLevelFileNames_getInstance() {
  Flag_initEntries();
  return Flag_PrependIndexToLevelFileNames_instance;
}
function Flag_UseMultilinesType_getInstance() {
  Flag_initEntries();
  return Flag_UseMultilinesType_instance;
}
function IdentifierStyle_Capitalize_getInstance() {
  IdentifierStyle_initEntries();
  return IdentifierStyle_Capitalize_instance;
}
function IdentifierStyle_Free_getInstance() {
  IdentifierStyle_initEntries();
  return IdentifierStyle_Free_instance;
}
function IdentifierStyle_Lowercase_getInstance() {
  IdentifierStyle_initEntries();
  return IdentifierStyle_Lowercase_instance;
}
function IdentifierStyle_Uppercase_getInstance() {
  IdentifierStyle_initEntries();
  return IdentifierStyle_Uppercase_instance;
}
function ImageExportMode_LayersAndLevels_getInstance() {
  ImageExportMode_initEntries();
  return ImageExportMode_LayersAndLevels_instance;
}
function ImageExportMode_None_getInstance() {
  ImageExportMode_initEntries();
  return ImageExportMode_None_instance;
}
function ImageExportMode_OneImagePerLayer_getInstance() {
  ImageExportMode_initEntries();
  return ImageExportMode_OneImagePerLayer_instance;
}
function ImageExportMode_OneImagePerLevel_getInstance() {
  ImageExportMode_initEntries();
  return ImageExportMode_OneImagePerLevel_instance;
}
function WorldLayout_Free_getInstance() {
  WorldLayout_initEntries();
  return WorldLayout_Free_instance;
}
function WorldLayout_GridVania_getInstance() {
  WorldLayout_initEntries();
  return WorldLayout_GridVania_instance;
}
function WorldLayout_LinearHorizontal_getInstance() {
  WorldLayout_initEntries();
  return WorldLayout_LinearHorizontal_instance;
}
function WorldLayout_LinearVertical_getInstance() {
  WorldLayout_initEntries();
  return WorldLayout_LinearVertical_instance;
}
function BgPos_Contain_getInstance() {
  BgPos_initEntries();
  return BgPos_Contain_instance;
}
function BgPos_Cover_getInstance() {
  BgPos_initEntries();
  return BgPos_Cover_instance;
}
function BgPos_CoverDirty_getInstance() {
  BgPos_initEntries();
  return BgPos_CoverDirty_instance;
}
function BgPos_Unscaled_getInstance() {
  BgPos_initEntries();
  return BgPos_Unscaled_instance;
}
var fieldInstancesByName$delegate;
var fieldDefsByName$delegate;
var entitiesByUid$delegate;
function get_gridPos(_this__u8e3s4) {
  _init_properties_LDTKJsonExt_kt__q9kc60();
  return Vector2I.v3r(_this__u8e3s4.zct_1[0], _this__u8e3s4.zct_1[1]);
}
function fieldInstancesByName$delegate$lambda($this$PropertyThis) {
  _init_properties_LDTKJsonExt_kt__q9kc60();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = $this$PropertyThis.gcu_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.xc(capacity);
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.ldtk.fieldInstancesByName$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$0 = element.oct_1;
    destination.k3(tmp$ret$0, element);
  }
  return destination;
}
function fieldDefsByName$delegate$lambda($this$PropertyThis) {
  _init_properties_LDTKJsonExt_kt__q9kc60();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = $this$PropertyThis.ecw_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.xc(capacity);
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.ldtk.fieldDefsByName$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$0 = element.jcv_1;
    destination.k3(tmp$ret$0, element);
  }
  return destination;
}
function entitiesByUid$delegate$lambda($this$PropertyThis) {
  _init_properties_LDTKJsonExt_kt__q9kc60();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = $this$PropertyThis.hcx_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.xc(capacity);
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.ldtk.entitiesByUid$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$0 = element.acx_1;
    destination.k3(tmp$ret$0, element);
  }
  return destination;
}
var properties_initialized_LDTKJsonExt_kt_byyf7e;
function _init_properties_LDTKJsonExt_kt__q9kc60() {
  if (!properties_initialized_LDTKJsonExt_kt_byyf7e) {
    properties_initialized_LDTKJsonExt_kt_byyf7e = true;
    fieldInstancesByName$delegate = new PropertyThis(VOID, fieldInstancesByName$delegate$lambda);
    fieldDefsByName$delegate = new PropertyThis(VOID, fieldDefsByName$delegate$lambda);
    entitiesByUid$delegate = new PropertyThis(VOID, entitiesByUid$delegate$lambda);
  }
}
function LDTKWorld$levels$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.pdb_1.ld5_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.ldtk.view.LDTKWorld.levels$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = new LDTKLevel(this$0, item);
      destination.h(tmp$ret$0);
    }
    return destination;
  };
}
function LDTKWorld$levelsByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.xdb();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.ldtk.view.LDTKWorld.levelsByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.zdb_1.ld6_1;
      destination.k3(tmp$ret$0, element);
    }
    return destination;
  };
}
function *_generator_readLDTKWorld__pombw9(_this__u8e3s4, extrude_0, $completion) {
  extrude_0 = extrude_0 === VOID ? true : extrude_0;
  var file = _this__u8e3s4;
  var tmp = file.e3h(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var json = tmp;
  var ldtk = Companion_getInstance_27().t9q(json);
  // Inline function 'kotlin.collections.associate' call
  var this_0 = ldtk.dd5_1.mcx_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap.xc(capacity);
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'korlibs.korge.ldtk.view.readLDTKWorld.<anonymous>' call
    var tmp0_safe_receiver = element.ed1_1;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.ldtk.view.readLDTKWorld.<anonymous>.<anonymous>' call
      var tmp_1 = readBitmap(file.z3g().cj(tmp0_safe_receiver), VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var bmp = tmp_1;
      tmp_0 = extrude_0 ? bmp.d57() : bmp;
    }
    var bitmap = tmp_0;
    var tmp_2;
    if (bitmap == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.ldtk.view.readLDTKWorld.<anonymous>.<anonymous>' call
      tmp_2 = Companion_getInstance().g6z(slice(bitmap), element.jd1_1, element.jd1_1);
    }
    var unextrudedTileSet = tmp_2;
    var tmp_3;
    if (unextrudedTileSet == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.ldtk.view.readLDTKWorld.<anonymous>.<anonymous>' call
      tmp_3 = extrude_0 ? extrude(unextrudedTileSet, 2) : unextrudedTileSet;
    }
    var tileSet = tmp_3;
    var pair = to(element.kd1_1, new ExtTileset(element, tileSet, unextrudedTileSet));
    destination.k3(pair.nm_1, pair.om_1);
  }
  var tilesetDefsById = destination;
  return new LDTKWorld(ldtk, tilesetDefsById, extrude_0);
}
function readLDTKWorld(_this__u8e3s4, extrude, $completion) {
  extrude = extrude === VOID ? true : extrude;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readLDTKWorld__pombw9.bind(VOID, _this__u8e3s4, extrude), $completion);
}
function LDTKLevel$layers$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.zdb_1.nd6_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(tmp0_safe_receiver, 10));
      var tmp0_iterator = tmp0_safe_receiver.b1();
      while (tmp0_iterator.c1()) {
        var item = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.ldtk.view.LDTKLevel.layers$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new LDTKLayer(this$0, item);
        destination.h(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  };
}
function LDTKLevel$layersByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.ocm();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.ldtk.view.LDTKLevel.layersByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.gdc_1.cd7_1;
      destination.k3(tmp$ret$0, element);
    }
    return destination;
  };
}
function extrude(_this__u8e3s4, border, mipmaps) {
  border = border === VOID ? 1 : border;
  mipmaps = mipmaps === VOID ? false : mipmaps;
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.t6z();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.korge.ldtk.view.extrude.<anonymous>' call
    var tmp$ret$0 = extract(item instanceof RectSlice ? item : THROW_CCE()).d57();
    destination.h(tmp$ret$0);
  }
  var bitmaps = destination;
  return Companion_getInstance().j6z(_this__u8e3s4.m6z_1, _this__u8e3s4.n6z_1, bitmaps, border, mipmaps);
}
function levels$factory() {
  return getPropertyCallableRef('levels', 1, KProperty1, function (receiver) {
    return receiver.xdb();
  }, null);
}
function layers$factory() {
  return getPropertyCallableRef('layers', 1, KProperty1, function (receiver) {
    return receiver.ocm();
  }, null);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
protoOf($serializer).e17 = typeParametersSerializers;
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FieldInstance, 'FieldInstance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
protoOf($serializer_0).e17 = typeParametersSerializers;
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EntityInstance, 'EntityInstance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_1);
protoOf($serializer_1).e17 = typeParametersSerializers;
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FieldDefinition, 'FieldDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_2);
protoOf($serializer_2).e17 = typeParametersSerializers;
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EntityDefinition, 'EntityDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_3);
protoOf($serializer_3).e17 = typeParametersSerializers;
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Definitions, 'Definitions', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_4);
protoOf($serializer_4).e17 = typeParametersSerializers;
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TilesetRectangle, 'TilesetRectangle', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForCompanion(Companion_5, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(AllowedRefs, 'AllowedRefs', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_6});
initMetadataForCompanion(Companion_6, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(EditorDisplayMode, 'EditorDisplayMode', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_7});
initMetadataForCompanion(Companion_7, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(EditorDisplayPos, 'EditorDisplayPos', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
initMetadataForCompanion(Companion_8, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(TextLanguageMode, 'TextLanguageMode', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
initMetadataForCompanion(Companion_9, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(LimitBehavior, 'LimitBehavior', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_10});
initMetadataForCompanion(Companion_10, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(LimitScope, 'LimitScope', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_11});
initMetadataForCompanion(Companion_11, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(RenderMode, 'RenderMode', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_12});
initMetadataForCompanion(Companion_12, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(TileRenderMode, 'TileRenderMode', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_13});
initMetadataForCompanion(Companion_13);
protoOf($serializer_5).e17 = typeParametersSerializers;
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EnumDefinition, 'EnumDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_14);
protoOf($serializer_6).e17 = typeParametersSerializers;
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LayerDefinition, 'LayerDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForCompanion(Companion_15);
protoOf($serializer_7).e17 = typeParametersSerializers;
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TilesetDefinition, 'TilesetDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_16);
protoOf($serializer_8).e17 = typeParametersSerializers;
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EnumValueDefinition, 'EnumValueDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForCompanion(Companion_17);
protoOf($serializer_9).e17 = typeParametersSerializers;
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AutoLayerRuleGroup, 'AutoLayerRuleGroup', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForCompanion(Companion_18);
protoOf($serializer_10).e17 = typeParametersSerializers;
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IntGridValueDefinition, 'IntGridValueDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_19, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(Type, 'Type', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_20});
initMetadataForCompanion(Companion_20);
protoOf($serializer_11).e17 = typeParametersSerializers;
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TileCustomMetadata, 'TileCustomMetadata', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForCompanion(Companion_21, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(EmbedAtlas, 'EmbedAtlas', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_22});
initMetadataForCompanion(Companion_22);
protoOf($serializer_12).e17 = typeParametersSerializers;
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EnumTagValue, 'EnumTagValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
initMetadataForCompanion(Companion_23);
protoOf($serializer_13).e17 = typeParametersSerializers;
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AutoLayerRuleDefinition, 'AutoLayerRuleDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
initMetadataForCompanion(Companion_24, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(Checker, 'Checker', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_25});
initMetadataForCompanion(Companion_25, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(TileMode, 'TileMode', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_26});
initMetadataForCompanion(Companion_26);
protoOf($serializer_14).e17 = typeParametersSerializers;
initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LDTKJson, 'LDTKJson', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
initMetadataForCompanion(Companion_27);
protoOf($serializer_15).e17 = typeParametersSerializers;
initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Level, 'Level', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
initMetadataForCompanion(Companion_28);
protoOf($serializer_16).e17 = typeParametersSerializers;
initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LayerInstance, 'LayerInstance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
initMetadataForCompanion(Companion_29);
protoOf($serializer_17).e17 = typeParametersSerializers;
initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TileInstance, 'TileInstance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
initMetadataForCompanion(Companion_30);
protoOf($serializer_18).e17 = typeParametersSerializers;
initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ForcedRefs, 'ForcedRefs', ForcedRefs, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
initMetadataForCompanion(Companion_31, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(Flag, 'Flag', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_32});
initMetadataForCompanion(Companion_32, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(IdentifierStyle, 'IdentifierStyle', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_33});
initMetadataForCompanion(Companion_33, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(ImageExportMode, 'ImageExportMode', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_34});
initMetadataForCompanion(Companion_34, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(WorldLayout, 'WorldLayout', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_35});
initMetadataForCompanion(Companion_35);
protoOf($serializer_19).e17 = typeParametersSerializers;
initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(World, 'World', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
initMetadataForCompanion(Companion_36);
protoOf($serializer_20).e17 = typeParametersSerializers;
initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LevelBackgroundPosition, 'LevelBackgroundPosition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
initMetadataForCompanion(Companion_37);
protoOf($serializer_21).e17 = typeParametersSerializers;
initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(NeighbourLevel, 'NeighbourLevel', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
initMetadataForCompanion(Companion_38, VOID, [KSerializer, SerializerFactory]);
initMetadataForClass(BgPos, 'BgPos', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_39});
initMetadataForCompanion(Companion_39);
protoOf($serializer_22).e17 = typeParametersSerializers;
initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FieldInstanceEntityReference, 'FieldInstanceEntityReference', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
initMetadataForCompanion(Companion_40);
protoOf($serializer_23).e17 = typeParametersSerializers;
initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FieldInstanceGridPoint, 'FieldInstanceGridPoint', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
initMetadataForCompanion(Companion_41);
protoOf($serializer_24).e17 = typeParametersSerializers;
initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IntGridValueInstance, 'IntGridValueInstance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
initMetadataForClass(LDTKWorld, 'LDTKWorld');
initMetadataForClass(ExtTileset, 'ExtTileset');
initMetadataForClass(LDTKLevel, 'LDTKLevel');
initMetadataForClass(LDTKLayer, 'LDTKLayer');
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_4 = new Companion_4();
Companion_instance_16 = new Companion_16();
Companion_instance_18 = new Companion_18();
Companion_instance_20 = new Companion_20();
Companion_instance_22 = new Companion_22();
Companion_instance_29 = new Companion_29();
Companion_instance_30 = new Companion_30();
Companion_instance_37 = new Companion_37();
Companion_instance_39 = new Companion_39();
Companion_instance_40 = new Companion_40();
Companion_instance_41 = new Companion_41();
//endregion
//region block: exports
export {
  readLDTKWorld as readLDTKWorld3amu50q42pjqj,
  get_gridPos as get_gridPos37aquento5ou5,
};
//endregion
